(function ($) {
  var $ = (jQuery = $),
    cc = { sections: [] };
  (theme.cartNoteMonitor = {
    load: function ($notes) {
      $notes.on(
        "change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor",
        function () {
          theme.cartNoteMonitor.postUpdate($(this).val());
        },
      );
    },
    unload: function ($notes) {
      $notes.off(".themeCartNoteMonitor");
    },
    updateThrottleTimeoutId: -1,
    updateThrottleInterval: 500,
    postUpdate: function (val) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
        (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(
          function () {
            $.post(
              theme.routes.cart_url + "/update.js",
              { note: val },
              function (data) {},
              "json",
            );
          },
          theme.cartNoteMonitor.updateThrottleInterval,
        ));
    },
  }),
    (theme.Shopify = {
      formatMoney: function (t, r) {
        function e(t2, r2) {
          return t2 === void 0 ? r2 : t2;
        }
        function a(t2, r2, a2, o2) {
          if (
            ((r2 = e(r2, 2)),
            (a2 = e(a2, ",")),
            (o2 = e(o2, ".")),
            isNaN(t2) || t2 == null)
          )
            return 0;
          t2 = (t2 / 100).toFixed(r2);
          var n2 = t2.split(".");
          return (
            n2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a2) +
            (n2[1] ? o2 + n2[1] : "")
          );
        }
        typeof t == "string" && (t = t.replace(".", ""));
        var o = "",
          n = /\{\{\s*(\w+)\s*\}\}/,
          i = r || this.money_format;
        switch (i.match(n)[1]) {
          case "amount":
            o = a(t, 2);
            break;
          case "amount_no_decimals":
            o = a(t, 0);
            break;
          case "amount_with_comma_separator":
            o = a(t, 2, ".", ",");
            break;
          case "amount_with_space_separator":
            o = a(t, 2, " ", ",");
            break;
          case "amount_with_period_and_space_separator":
            o = a(t, 2, " ", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            o = a(t, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            o = a(t, 0, " ", "");
            break;
          case "amount_with_apostrophe_separator":
            o = a(t, 2, "'", ".");
            break;
          case "amount_with_decimal_separator":
            o = a(t, 2, ".", ".");
        }
        return i.replace(n, o);
      },
      formatImage: function (originalImageUrl, format) {
        return originalImageUrl
          ? originalImageUrl.replace(
              /^(.*)\.([^\.]*)$/g,
              "$1_" + format + ".$2",
            )
          : "";
      },
      Image: {
        imageSize: function (t) {
          var e = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/,
          );
          return e !== null ? e[1] : null;
        },
        getSizedImageUrl: function (t, e) {
          if (e == null) return t;
          if (e == "master") return this.removeProtocol(t);
          var o = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i,
          );
          if (o != null) {
            var i = t.split(o[0]),
              r = o[0];
            return this.removeProtocol(i[0] + "_" + e + r);
          }
          return null;
        },
        removeProtocol: function (t) {
          return t.replace(/http(s)?:/, "");
        },
      },
    }),
    (theme.Disclosure = (function () {
      var selectors = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        },
        classes = { listVisible: "disclosure-list--visible" };
      function Disclosure($disclosure) {
        (this.$container = $disclosure),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (Disclosure.prototype = $.extend({}, Disclosure.prototype, {
          _cacheSelectors: function () {
            this.cache = {
              $disclosureList: this.$container.find(selectors.disclosureList),
              $disclosureToggle: this.$container.find(
                selectors.disclosureToggle,
              ),
              $disclosureInput: this.$container.find(selectors.disclosureInput),
              $disclosureOptions: this.$container.find(
                selectors.disclosureOptions,
              ),
            };
          },
          _connectToggle: function () {
            this.cache.$disclosureToggle.on(
              "click",
              function (evt) {
                var ariaExpanded =
                  $(evt.currentTarget).attr("aria-expanded") === "true";
                $(evt.currentTarget).attr("aria-expanded", !ariaExpanded),
                  this.cache.$disclosureList.toggleClass(classes.listVisible);
              }.bind(this),
            );
          },
          _connectOptions: function () {
            this.cache.$disclosureOptions.on(
              "click",
              function (evt) {
                evt.preventDefault(),
                  this._submitForm($(evt.currentTarget).data("value"));
              }.bind(this),
            );
          },
          _onFocusOut: function () {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (evt) {
                var disclosureLostFocus =
                  this.$container.has(evt.relatedTarget).length === 0;
                disclosureLostFocus && this._hideList();
              }.bind(this),
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (evt) {
                  var childInFocus =
                      $(evt.currentTarget).has(evt.relatedTarget).length > 0,
                    isVisible = this.cache.$disclosureList.hasClass(
                      classes.listVisible,
                    );
                  isVisible && !childInFocus && this._hideList();
                }.bind(this),
              ),
              this.$container.on(
                "keyup",
                function (evt) {
                  evt.which === 27 &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this),
              ),
              (this.bodyOnClick = function (evt) {
                var isOption = this.$container.has(evt.target).length > 0,
                  isVisible = this.cache.$disclosureList.hasClass(
                    classes.listVisible,
                  );
                isVisible && !isOption && this._hideList();
              }.bind(this)),
              $("body").on("click", this.bodyOnClick);
          },
          _submitForm: function (value) {
            this.cache.$disclosureInput.val(value),
              this.$container.parents("form").submit();
          },
          _hideList: function () {
            this.cache.$disclosureList.removeClass(classes.listVisible),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function () {
            $("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        Disclosure
      );
    })()),
    (function () {
      function throttle(callback, threshold) {
        var debounceTimeoutId = -1,
          tick = !1;
        return function () {
          clearTimeout(debounceTimeoutId),
            (debounceTimeoutId = setTimeout(callback, threshold)),
            tick ||
              (callback.call(),
              (tick = !0),
              setTimeout(function () {
                tick = !1;
              }, threshold));
        };
      }
      var scrollEvent = document.createEvent("Event");
      scrollEvent.initEvent("throttled-scroll", !0, !0),
        window.addEventListener(
          "scroll",
          throttle(function () {
            window.dispatchEvent(scrollEvent);
          }, 200),
        );
    })(),
    (theme.debounce = function (func) {
      var wait =
          arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 700,
        immediate = arguments.length > 2 ? arguments[2] : void 0,
        timeout;
      return function () {
        var context = this,
          args = arguments,
          later = function () {
            (timeout = null), immediate || func.apply(context, args);
          },
          callNow = immediate && !timeout;
        clearTimeout(timeout),
          (timeout = setTimeout(later, wait)),
          callNow && func.apply(context, args);
      };
    }),
    (theme.Sections = new (function () {
      var _ = this;
      (_._instances = []),
        (_._deferredSectionTargets = []),
        (_._sections = []),
        (_._deferredLoadViewportExcess = 300),
        (_._deferredWatcherRunning = !1),
        (_.init = function () {
          $(document)
            .on("shopify:section:load", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target,
              );
              target && _.sectionLoad(target);
            })
            .on("shopify:section:unload", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target,
              );
              target && _.sectionUnload(target);
            })
            .on("shopify:section:reorder", function (e) {
              var target = _._themeSectionTargetFromShopifySectionTarget(
                e.target,
              );
              target && _.sectionReorder(target);
            }),
            $(window).on(
              "throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader",
              _._processDeferredSections,
            ),
            (_._deferredWatcherRunning = !0);
        }),
        (_.register = function (type, section, options) {
          _._sections.push({
            type,
            section,
            afterSectionLoadCallback: options ? options.afterLoad : null,
            afterSectionUnloadCallback: options ? options.afterUnload : null,
          }),
            $('[data-section-type="' + type + '"]').each(function () {
              Shopify.designMode ||
              (options && options.deferredLoad === !1) ||
              !_._deferredWatcherRunning
                ? _.sectionLoad(this)
                : _.sectionDeferredLoad(this, options);
            });
        }),
        (_.sectionDeferredLoad = function (target, options) {
          _._deferredSectionTargets.push({
            target,
            deferredLoadViewportExcess:
              options && options.deferredLoadViewportExcess
                ? options.deferredLoadViewportExcess
                : _._deferredLoadViewportExcess,
          }),
            _._processDeferredSections(!0);
        }),
        (_._processDeferredSections = function (firstRunCheck) {
          if (_._deferredSectionTargets.length)
            for (
              var viewportTop = $(window).scrollTop(),
                viewportBottom = viewportTop + $(window).height(),
                loopStart =
                  firstRunCheck === !0
                    ? _._deferredSectionTargets.length - 1
                    : 0,
                i = loopStart;
              i < _._deferredSectionTargets.length;
              i++
            ) {
              var target = _._deferredSectionTargets[i].target,
                viewportExcess =
                  _._deferredSectionTargets[i].deferredLoadViewportExcess,
                sectionTop = $(target).offset().top - viewportExcess,
                doLoad =
                  sectionTop > viewportTop && sectionTop < viewportBottom;
              if (!doLoad) {
                var sectionBottom =
                  sectionTop + $(target).outerHeight() + viewportExcess * 2;
                doLoad =
                  sectionBottom > viewportTop && sectionBottom < viewportBottom;
              }
              (doLoad ||
                (sectionTop < viewportTop && sectionBottom > viewportBottom)) &&
                (_.sectionLoad(target),
                _._deferredSectionTargets.splice(i, 1),
                i--);
            }
          firstRunCheck !== !0 &&
            _._deferredSectionTargets.length === 0 &&
            ((_._deferredWatcherRunning = !1),
            $(window).off(".themeSectionDeferredLoader"));
        }),
        (_.sectionLoad = function (target) {
          var target = target,
            sectionObj = _._sectionForTarget(target),
            section = !1;
          if (
            (sectionObj.section
              ? (section = sectionObj.section)
              : (section = sectionObj),
            section !== !1)
          ) {
            var instance = {
              target,
              section,
              $shopifySectionContainer: $(target).closest(".shopify-section"),
              thisContext: {
                functions: section.functions,
                registeredEventListeners: [],
              },
            };
            if (
              ((instance.thisContext.registerEventListener =
                _._registerEventListener.bind(instance.thisContext)),
              _._instances.push(instance),
              $(target).data("components"))
            ) {
              var components = $(target).data("components").split(",");
              components.forEach((component) => {
                $(document).trigger("cc:component:load", [component, target]);
              });
            }
            _._callSectionWith(
              section,
              "onSectionLoad",
              target,
              instance.thisContext,
            ),
              _._callSectionWith(
                section,
                "afterSectionLoadCallback",
                target,
                instance.thisContext,
              ),
              section.onSectionSelect &&
                instance.$shopifySectionContainer.on(
                  "shopify:section:select",
                  function (e) {
                    _._callSectionWith(
                      section,
                      "onSectionSelect",
                      e.target,
                      instance.thisContext,
                    );
                  },
                ),
              section.onSectionDeselect &&
                instance.$shopifySectionContainer.on(
                  "shopify:section:deselect",
                  function (e) {
                    _._callSectionWith(
                      section,
                      "onSectionDeselect",
                      e.target,
                      instance.thisContext,
                    );
                  },
                ),
              section.onBlockSelect &&
                $(target).on("shopify:block:select", function (e) {
                  _._callSectionWith(
                    section,
                    "onBlockSelect",
                    e.target,
                    instance.thisContext,
                  );
                }),
              section.onBlockDeselect &&
                $(target).on("shopify:block:deselect", function (e) {
                  _._callSectionWith(
                    section,
                    "onBlockDeselect",
                    e.target,
                    instance.thisContext,
                  );
                });
          }
        }),
        (_.sectionUnload = function (target) {
          for (
            var sectionObj = _._sectionForTarget(target),
              instanceIndex = -1,
              i = 0;
            i < _._instances.length;
            i++
          )
            _._instances[i].target == target && (instanceIndex = i);
          if (instanceIndex > -1) {
            var instance = _._instances[instanceIndex];
            if (
              ($(target).off("shopify:block:select shopify:block:deselect"),
              instance.$shopifySectionContainer.off(
                "shopify:section:select shopify:section:deselect",
              ),
              _._callSectionWith(
                instance.section,
                "onSectionUnload",
                target,
                instance.thisContext,
              ),
              _._unloadRegisteredEventListeners(
                instance.thisContext.registeredEventListeners,
              ),
              _._callSectionWith(
                sectionObj,
                "afterSectionUnloadCallback",
                target,
                instance.thisContext,
              ),
              _._instances.splice(instanceIndex),
              $(target).data("components"))
            ) {
              var components = $(target).data("components").split(",");
              components.forEach((component) => {
                $(document).trigger("cc:component:unload", [component, target]);
              });
            }
          } else
            for (var i = 0; i < _._deferredSectionTargets.length; i++)
              if (_._deferredSectionTargets[i].target == target) {
                _._deferredSectionTargets[i].splice(i, 1);
                break;
              }
        }),
        (_.sectionReorder = function (target) {
          for (var instanceIndex = -1, i = 0; i < _._instances.length; i++)
            _._instances[i].target == target && (instanceIndex = i);
          if (instanceIndex > -1) {
            var instance = _._instances[instanceIndex];
            _._callSectionWith(
              instance.section,
              "onSectionReorder",
              target,
              instance.thisContext,
            );
          }
        }),
        (_._registerEventListener = function (element, eventType, callback) {
          element.addEventListener(eventType, callback),
            this.registeredEventListeners.push({
              element,
              eventType,
              callback,
            });
        }),
        (_._unloadRegisteredEventListeners = function (
          registeredEventListeners,
        ) {
          registeredEventListeners.forEach((rel) => {
            rel.element.removeEventListener(rel.eventType, rel.callback);
          });
        }),
        (_._callSectionWith = function (
          section,
          method,
          container2,
          thisContext,
        ) {
          if (typeof section[method] == "function")
            try {
              thisContext
                ? section[method].bind(thisContext)(container2)
                : section[method](container2);
            } catch (ex) {
              var sectionType = container2.dataset.sectionType;
              console.warn(
                "Theme warning: '"
                  .concat(method, "' failed for section '")
                  .concat(sectionType, "'"),
              ),
                console.debug(container2, ex);
            }
        }),
        (_._themeSectionTargetFromShopifySectionTarget = function (target) {
          var $target = $("[data-section-type]:first", target);
          return $target.length > 0 ? $target[0] : !1;
        }),
        (_._sectionForTarget = function (target) {
          for (
            var type = $(target).attr("data-section-type"), i = 0;
            i < _._sections.length;
            i++
          )
            if (_._sections[i].type == type) return _._sections[i];
          return !1;
        }),
        (_._sectionAlreadyRegistered = function (type) {
          for (var i = 0; i < _._sections.length; i++)
            if (_._sections[i].type == type) return !0;
          return !1;
        });
    })()),
    (theme.scriptsLoaded = {}),
    (theme.loadScriptOnce = function (src, callback, beforeRun, sync) {
      if (typeof theme.scriptsLoaded[src] > "u") {
        theme.scriptsLoaded[src] = [];
        var tag = document.createElement("script");
        (tag.src = src),
          (sync || beforeRun) && (tag.async = !1),
          beforeRun && beforeRun(),
          typeof callback == "function" &&
            (theme.scriptsLoaded[src].push(callback),
            tag.readyState
              ? (tag.onreadystatechange = function () {
                  if (
                    tag.readyState == "loaded" ||
                    tag.readyState == "complete"
                  ) {
                    tag.onreadystatechange = null;
                    for (var i = 0; i < theme.scriptsLoaded[this].length; i++)
                      theme.scriptsLoaded[this][i]();
                    theme.scriptsLoaded[this] = !0;
                  }
                }.bind(src))
              : (tag.onload = function () {
                  for (var i = 0; i < theme.scriptsLoaded[this].length; i++)
                    theme.scriptsLoaded[this][i]();
                  theme.scriptsLoaded[this] = !0;
                }.bind(src)));
        var firstScriptTag = document.getElementsByTagName("script")[0];
        return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag), !0;
      } else if (
        typeof theme.scriptsLoaded[src] == "object" &&
        typeof callback == "function"
      )
        theme.scriptsLoaded[src].push(callback);
      else return typeof callback == "function" && callback(), !1;
    }),
    (theme.loadStyleOnce = function (src) {
      var srcWithoutProtocol = src.replace(/^https?:/, "");
      if (
        !document.querySelector(
          'link[href="' + encodeURI(srcWithoutProtocol) + '"]',
        )
      ) {
        var tag = document.createElement("link");
        (tag.href = srcWithoutProtocol),
          (tag.rel = "stylesheet"),
          (tag.type = "text/css");
        var firstTag = document.getElementsByTagName("link")[0];
        firstTag.parentNode.insertBefore(tag, firstTag);
      }
    }),
    (theme.showQuickPopup = function (message, $origin) {
      var $popup = $('<div class="simple-popup"/>'),
        offs = $origin.offset();
      $popup.html(message).css({ left: offs.left, top: offs.top }).hide(),
        $("body").append($popup),
        $popup.css({
          marginTop: -$popup.outerHeight() - 10,
          marginLeft: -($popup.outerWidth() - $origin.outerWidth()) / 2,
        }),
        $popup
          .fadeIn(200)
          .delay(3500)
          .fadeOut(400, function () {
            $(this).remove();
          });
    });
  class ccComponent {
    constructor(name) {
      var cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name),
        _this = this;
      (this.instances = []),
        $(document).on(
          "cc:component:load",
          function (event, component, target) {
            component === name &&
              $(target)
                .find("".concat(cssSelector, ":not(.cc-initialized)"))
                .each(function () {
                  _this.init(this);
                });
          },
        ),
        $(document).on(
          "cc:component:unload",
          function (event, component, target) {
            component === name &&
              $(target)
                .find(cssSelector)
                .each(function () {
                  _this.destroy(this);
                });
          },
        ),
        $(cssSelector).each(function () {
          _this.init(this);
        });
    }
    init(container2) {
      $(container2).addClass("cc-initialized");
    }
    destroy(container2) {
      $(container2).removeClass("cc-initialized");
    }
    registerInstance(container2, instance) {
      this.instances.push({ container: container2, instance });
    }
    destroyInstance(container2) {
      this.instances = this.instances.filter((item) => {
        if (item.container === container2)
          return (
            typeof item.instance.destroy == "function" &&
              item.instance.destroy(),
            item.container !== container2
          );
      });
    }
  }
  (theme.createTemplateVariableEncoder = function () {
    return {
      utilityElement: document.createElement("div"),
      values: {},
      add: function (key, value, type) {
        switch (type) {
          case "attribute":
            (this.utilityElement.innerHTML = ""),
              this.utilityElement.setAttribute("util", value),
              (this.values[key] =
                this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1]);
            break;
          case "html":
            (this.utilityElement.innerText = value),
              (this.values[key] = this.utilityElement.innerHTML);
            break;
          case "raw":
            this.values[key] = value;
            break;
          default:
            throw "Type '".concat(type, "' not handled");
        }
      },
    };
  }),
    (theme.suffixIds = function (container2, suffix) {
      var refAttrs = ["aria-describedby", "aria-controls"];
      (suffix = "-" + suffix),
        container2.querySelectorAll("[id]").forEach((el) => {
          var oldId = el.id,
            newId = oldId + suffix;
          (el.id = newId),
            refAttrs.forEach((attr) => {
              container2
                .querySelectorAll("[".concat(attr, '="').concat(oldId, '"]'))
                .forEach((refEl) => {
                  refEl.setAttribute(attr, newId);
                });
            });
        });
    }),
    (theme.renderUnitPrice = function (
      unit_price,
      unit_price_measurement,
      money_format,
    ) {
      if (unit_price && unit_price_measurement) {
        var unitPriceHtml = '<div class="unit-price">';
        (unitPriceHtml += '<span class="unit-price__price theme-money">'.concat(
          theme.Shopify.formatMoney(unit_price, money_format),
          "</span>",
        )),
          (unitPriceHtml += '<span class="unit-price__separator">'.concat(
            theme.strings.products_product_unit_price_separator,
            "</span>",
          ));
        var unit = unit_price_measurement.reference_unit;
        return (
          unit_price_measurement.reference_value != 1 &&
            (unit = unit_price_measurement.reference_value + unit),
          (unitPriceHtml += '<span class="unit-price__unit">'.concat(
            unit,
            "</span>",
          )),
          (unitPriceHtml += "</div>"),
          unitPriceHtml
        );
      } else return "";
    });
  class ccPopup {
    constructor($container, namespace) {
      (this.$container = $container),
        (this.namespace = namespace),
        (this.cssClasses = {
          visible: "cc-popup--visible",
          bodyNoScroll: "cc-popup-no-scroll",
          bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right",
        });
    }
    open(callback) {
      if (this.$container.data("freeze-scroll")) {
        clearTimeout(theme.ccPopupRemoveScrollFreezeTimeoutId),
          $("body").addClass(this.cssClasses.bodyNoScroll);
        var scrollDiv = document.createElement("div");
        (scrollDiv.className = "popup-scrollbar-measure"),
          document.body.appendChild(scrollDiv);
        var scrollbarWidth =
          scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv),
          scrollbarWidth > 0 &&
            $("body")
              .css("padding-right", scrollbarWidth + "px")
              .addClass(this.cssClasses.bodyNoScrollPadRight);
      }
      this.$container.addClass(this.cssClasses.visible),
        (this.previouslyActiveElement = document.activeElement),
        setTimeout(() => {
          this.$container.find(".cc-popup-close")[0].focus();
        }, 500),
        $(window).on("keydown" + this.namespace, (event) => {
          event.keyCode === 27 && this.close();
        }),
        callback && callback();
    }
    close(callback) {
      this.$container.removeClass(this.cssClasses.visible),
        this.previouslyActiveElement && $(this.previouslyActiveElement).focus(),
        $(window).off("keydown" + this.namespace);
      var $visibleFreezePopups = $("." + this.cssClasses.visible).filter(() =>
        this.$container.data("freeze-scroll"),
      );
      if ($visibleFreezePopups.length === 0) {
        var transitionDuration = 500,
          $innerModal = this.$container.find(".cc-popup-modal");
        $innerModal.length &&
          ((transitionDuration = parseFloat(
            getComputedStyle($innerModal[0]).transitionDuration,
          )),
          transitionDuration &&
            transitionDuration > 0 &&
            (transitionDuration *= 1e3)),
          (theme.ccPopupRemoveScrollFreezeTimeoutId = setTimeout(() => {
            $("body")
              .removeClass(this.cssClasses.bodyNoScroll)
              .removeClass(this.cssClasses.bodyNoScrollPadRight)
              .css("padding-right", "0");
          }, transitionDuration));
      }
      callback && callback();
    }
  }
  (() => {
    (theme.initAnimateOnScroll = function () {
      if (
        document.body.classList.contains("cc-animate-enabled") &&
        window.innerWidth >= 768
      ) {
        var animationTimeout =
          typeof document.body.dataset.ccAnimateTimeout < "u"
            ? document.body.dataset.ccAnimateTimeout
            : 200;
        if ("IntersectionObserver" in window) {
          var intersectionObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                entry.isIntersecting &&
                  !entry.target.classList.contains("cc-animate-complete") &&
                  (setTimeout(() => {
                    entry.target.classList.add("-in", "cc-animate-complete");
                  }, animationTimeout),
                  setTimeout(() => {
                    entry.target.classList.remove("data-cc-animate"),
                      (entry.target.style.transitionDuration = null),
                      (entry.target.style.transitionDelay = null);
                  }, 5e3),
                  observer.unobserve(entry.target));
              });
            },
          );
          document
            .querySelectorAll("[data-cc-animate]:not(.cc-animate-init)")
            .forEach((elem) => {
              elem.dataset.ccAnimateDelay &&
                (elem.style.transitionDelay = elem.dataset.ccAnimateDelay),
                elem.dataset.ccAnimateDuration &&
                  (elem.style.transitionDuration =
                    elem.dataset.ccAnimateDuration),
                elem.dataset.ccAnimate &&
                  elem.classList.add(elem.dataset.ccAnimate),
                elem.classList.add("cc-animate-init"),
                intersectionObserver.observe(elem);
            });
        } else
          for (
            var elems = document.querySelectorAll(
                "[data-cc-animate]:not(.cc-animate-init)",
              ),
              i = 0;
            i < elems.length;
            i++
          )
            elems[i].classList.add("-in", "cc-animate-complete");
      }
    }),
      theme.initAnimateOnScroll(),
      document.addEventListener("shopify:section:load", () => {
        setTimeout(theme.initAnimateOnScroll, 100);
      });
    try {
      window
        .matchMedia("(min-width: 768px)")
        .addEventListener("change", (event) => {
          event.matches && setTimeout(theme.initAnimateOnScroll, 100);
        });
    } catch {}
  })();
  class AccordionInstance {
    constructor(container2) {
      (this.accordion = container2),
        (this.itemClass = ".cc-accordion-item"),
        (this.titleClass = ".cc-accordion-item__title"),
        (this.panelClass = ".cc-accordion-item__panel"),
        (this.allowMultiOpen =
          this.accordion.dataset.allowMultiOpen === "true"),
        this.allowMultiOpen ||
          (this.activeItem = this.accordion.querySelector(
            "".concat(this.itemClass, "[open]"),
          )),
        this.bindEvents();
    }
    static addPanelHeight(panel) {
      panel.style.height = "".concat(panel.scrollHeight, "px");
    }
    static removePanelHeight(panel) {
      panel.getAttribute("style"), panel.removeAttribute("style");
    }
    open(item, panel) {
      if (
        ((panel.style.height = "0"),
        (item.open = !0),
        AccordionInstance.addPanelHeight(panel),
        setTimeout(() => {
          item.classList.add("is-open");
        }, 10),
        !this.allowMultiOpen)
      ) {
        if (this.activeItem && this.activeItem !== item) {
          var activePanel = this.activeItem.querySelector(this.panelClass);
          this.close(this.activeItem, activePanel);
        }
        this.activeItem = item;
      }
    }
    close(item, panel) {
      AccordionInstance.addPanelHeight(panel),
        item.classList.remove("is-open"),
        item.classList.add("is-closing"),
        this.activeItem === item && (this.activeItem = null),
        setTimeout(() => {
          panel.style.height = "0";
        }, 10);
    }
    handleClick(e) {
      var toggle = e.target.closest(this.titleClass);
      if (toggle) {
        e.preventDefault();
        var item = toggle.parentNode,
          panel = toggle.nextElementSibling;
        item.open ? this.close(item, panel) : this.open(item, panel);
      }
    }
    handleTransition(e) {
      if (e.target.matches(this.panelClass)) {
        var panel = e.target,
          item = panel.parentNode;
        item.classList.contains("is-closing") &&
          (item.classList.remove("is-closing"), (item.open = !1)),
          AccordionInstance.removePanelHeight(panel);
      }
    }
    bindEvents() {
      (this.clickHandler = this.handleClick.bind(this)),
        (this.transitionHandler = this.handleTransition.bind(this)),
        this.accordion.addEventListener("click", this.clickHandler),
        this.accordion.addEventListener(
          "transitionend",
          this.transitionHandler,
        );
    }
    destroy() {
      this.accordion.removeEventListener("click", this.clickHandler),
        this.accordion.removeEventListener(
          "transitionend",
          this.transitionHandler,
        );
    }
  }
  class Accordion extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "accordion",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name);
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new AccordionInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new Accordion();
  class CustomSelectInstance {
    constructor(el) {
      (this.el = el),
        (this.button = el.querySelector(".cc-select__btn")),
        (this.listbox = el.querySelector(".cc-select__listbox")),
        (this.options = el.querySelectorAll(".cc-select__option")),
        (this.selectedOption = el.querySelector('[aria-selected="true"]')),
        (this.nativeSelect = document.getElementById(
          "".concat(el.id, "-native"),
        )),
        (this.swatches =
          "swatch" in this.options[this.options.length - 1].dataset),
        (this.focusedClass = "is-focused"),
        (this.searchString = ""),
        (this.listboxOpen = !1),
        this.selectedOption ||
          (this.selectedOption = this.listbox.firstElementChild),
        this.bindEvents(),
        this.setButtonWidth();
    }
    bindEvents() {
      this.el.addEventListener("keydown", this.handleKeydown.bind(this)),
        this.el.addEventListener(
          "selectOption",
          this.handleSelectOption.bind(this),
        ),
        this.button.addEventListener(
          "mousedown",
          this.handleMousedown.bind(this),
        );
    }
    addListboxOpenEvents() {
      (this.mouseoverHandler = this.handleMouseover.bind(this)),
        (this.mouseleaveHandler = this.handleMouseleave.bind(this)),
        (this.clickHandler = this.handleClick.bind(this)),
        (this.blurHandler = this.handleBlur.bind(this)),
        this.listbox.addEventListener("mouseover", this.mouseoverHandler),
        this.listbox.addEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.addEventListener("click", this.clickHandler),
        this.listbox.addEventListener("blur", this.blurHandler);
    }
    removeListboxOpenEvents() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler),
        this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.removeEventListener("click", this.clickHandler),
        this.listbox.removeEventListener("blur", this.blurHandler);
    }
    handleKeydown(e) {
      this.listboxOpen
        ? this.handleKeyboardNav(e)
        : (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === " ") &&
          (e.preventDefault(), this.showListbox());
    }
    handleMousedown(e) {
      !this.listboxOpen && e.button === 0 && this.showListbox();
    }
    handleMouseover(e) {
      e.target.matches("li") && this.focusOption(e.target);
    }
    handleMouseleave() {
      this.focusOption(this.selectedOption);
    }
    handleClick(e) {
      e.target.matches(".js-option") && this.selectOption(e.target);
    }
    handleBlur() {
      this.listboxOpen && this.hideListbox();
    }
    handleKeyboardNav(e) {
      var optionToFocus;
      switch ((e.key === "Tab" && e.preventDefault(), e.key)) {
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault(),
            e.key === "ArrowUp"
              ? (optionToFocus = this.focusedOption.previousElementSibling)
              : (optionToFocus = this.focusedOption.nextElementSibling),
            optionToFocus &&
              !optionToFocus.classList.contains("is-disabled") &&
              this.focusOption(optionToFocus);
          break;
        case "Enter":
        case " ":
          e.preventDefault(), this.selectOption(this.focusedOption);
          break;
        case "Escape":
          e.preventDefault(), this.hideListbox();
          break;
        default:
          (optionToFocus = this.findOption(e.key)),
            optionToFocus && this.focusOption(optionToFocus);
          break;
      }
    }
    setButtonWidth() {
      var getUnpaddedWidth = (el) => {
          var elStyle = getComputedStyle(el);
          return (
            parseFloat(elStyle.paddingLeft) + parseFloat(elStyle.paddingRight)
          );
        },
        buttonPadding = getUnpaddedWidth(this.button),
        optionPadding = getUnpaddedWidth(this.selectedOption),
        buttonBorder = this.button.offsetWidth - this.button.clientWidth,
        optionWidth = Math.ceil(
          this.selectedOption.getBoundingClientRect().width,
        );
      this.button.style.width = "".concat(
        optionWidth - optionPadding + buttonPadding + buttonBorder,
        "px",
      );
    }
    showListbox() {
      (this.listbox.hidden = !1),
        (this.listboxOpen = !0),
        this.el.classList.add("is-open"),
        this.button.setAttribute("aria-expanded", "true"),
        this.listbox.setAttribute("aria-hidden", "false"),
        setTimeout(() => {
          this.focusOption(this.selectedOption),
            this.listbox.focus(),
            this.addListboxOpenEvents();
        }, 10);
    }
    hideListbox() {
      this.listboxOpen &&
        ((this.listbox.hidden = !0),
        (this.listboxOpen = !1),
        this.el.classList.remove("is-open"),
        this.button.setAttribute("aria-expanded", "false"),
        this.listbox.setAttribute("aria-hidden", "true"),
        this.focusedOption &&
          (this.focusedOption.classList.remove(this.focusedClass),
          (this.focusedOption = null)),
        this.button.focus(),
        this.removeListboxOpenEvents());
    }
    findOption(key) {
      (this.searchString += key),
        this.searchTimer && clearTimeout(this.searchTimer),
        (this.searchTimer = setTimeout(() => {
          this.searchString = "";
        }, 500));
      var matchingOption = [...this.options].find((option) => {
        var label = option.innerText.toLowerCase();
        return (
          label.includes(this.searchString) &&
          !option.classList.contains("is-disabled")
        );
      });
      return matchingOption;
    }
    focusOption(option) {
      if (
        (this.focusedOption &&
          this.focusedOption.classList.remove(this.focusedClass),
        (this.focusedOption = option),
        this.focusedOption.classList.add(this.focusedClass),
        this.listbox.scrollHeight > this.listbox.clientHeight)
      ) {
        var scrollBottom = this.listbox.clientHeight + this.listbox.scrollTop,
          optionBottom = option.offsetTop + option.offsetHeight;
        optionBottom > scrollBottom
          ? (this.listbox.scrollTop = optionBottom - this.listbox.clientHeight)
          : option.offsetTop < this.listbox.scrollTop &&
            (this.listbox.scrollTop = option.offsetTop);
      }
    }
    handleSelectOption(e) {
      var matchingOption = [...this.options].find(
        (option) => option.dataset.value === e.detail.value,
      );
      matchingOption && this.selectOption(matchingOption);
    }
    selectOption(option) {
      if (option !== this.selectedOption)
        if (
          (option.setAttribute("aria-selected", "true"),
          this.selectedOption.setAttribute("aria-selected", "false"),
          this.swatches &&
            (option.dataset.swatch
              ? (this.button.dataset.swatch = option.dataset.swatch)
              : this.button.removeAttribute("data-swatch")),
          (this.button.firstChild.textContent =
            option.firstElementChild.textContent),
          this.listbox.setAttribute("aria-activedescendant", option.id),
          (this.selectedOption = document.getElementById(option.id)),
          this.nativeSelect)
        )
          (this.nativeSelect.value = option.dataset.value),
            this.nativeSelect.dispatchEvent(
              new Event("change", { bubbles: !0 }),
            );
        else {
          var detail = { selectedValue: option.dataset.value };
          this.el.dispatchEvent(
            new CustomEvent("change", { bubbles: !0, detail }),
          );
        }
      this.hideListbox();
    }
  }
  class CustomSelect extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "custom-select",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-select";
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new CustomSelectInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new CustomSelect();
  class ModalInstance {
    constructor(container2) {
      (this.container = container2),
        (this.size = container2.dataset.ccModalSize || "medium"),
        (this.contentElement = document.querySelector(
          container2.dataset.ccModalContentelement,
        )),
        this.container.addEventListener("click", this.handleClick.bind(this)),
        container2.dataset.ccModalLaunch === "true" &&
          setTimeout(this.open.bind(this), 10);
    }
    handleClick(e) {
      e.preventDefault(), this.open(), (this.opener = e.target);
    }
    open() {
      var tve = theme.createTemplateVariableEncoder();
      tve.add("size", this.size, "attribute"),
        tve.add("content", this.contentElement.innerHTML, "raw"),
        tve.add(
          "button_close_label",
          theme.strings.general_accessibility_labels_close,
          "attribute",
        ),
        tve.add("button_close_icon", theme.icons.close, "raw");
      var html = `
      <div class="cc-modal-window cc-modal-window--pre-reveal cc-modal-window--size-`
          .concat(
            tve.values.size,
            `">
        <div class="cc-modal-window__background"></div>
        <div class="cc-modal-window__foreground" role="dialog" aria-modal="true">
          <div class="cc-modal-window__content-container">
            <button class="cc-modal-window__close" aria-label="`,
          )
          .concat(tve.values.button_close_label, '">')
          .concat(
            tve.values.button_close_icon,
            `</button>
            <div class="cc-modal-window__content">`,
          )
          .concat(
            tve.values.content,
            `</div>
          </div>
        </div>
      </div>
    `,
          ),
        modalElementFragment = document
          .createRange()
          .createContextualFragment(html);
      document.body.appendChild(modalElementFragment),
        document.body.classList.add("cc-modal-visible"),
        (this.modalElement = document.body.lastElementChild),
        this.modalElement
          .querySelector(".cc-modal-window__background")
          .addEventListener("click", this.close.bind(this)),
        this.modalElement
          .querySelector(".cc-modal-window__close")
          .addEventListener("click", this.close.bind(this)),
        setTimeout(() => {
          this.modalElement.classList.remove("cc-modal-window--pre-reveal"),
            this.modalElement.querySelector(".cc-modal-window__close").focus();
        }, 10);
    }
    close() {
      this.modalElement.classList.add("cc-modal-window--closing"),
        document.querySelector(
          ".cc-modal-window:not(.cc-modal-window--closing)",
        ) || document.body.classList.remove("cc-modal-visible"),
        this.opener &&
          setTimeout(() => {
            this.opener.focus();
          }, 10),
        setTimeout(
          function () {
            this.remove();
          }.bind(this.modalElement),
          5e3,
        );
    }
  }
  class Modal extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "modal",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name);
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new ModalInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new Modal();
  class PriceRangeInstance {
    constructor(container2) {
      (this.container = container2),
        (this.selectors = {
          inputMin: ".cc-price-range__input--min",
          inputMax: ".cc-price-range__input--max",
          control: ".cc-price-range__control",
          controlMin: ".cc-price-range__control--min",
          controlMax: ".cc-price-range__control--max",
          bar: ".cc-price-range__bar",
          activeBar: ".cc-price-range__bar-active",
        }),
        (this.controls = {
          min: {
            barControl: container2.querySelector(this.selectors.controlMin),
            input: container2.querySelector(this.selectors.inputMin),
          },
          max: {
            barControl: container2.querySelector(this.selectors.controlMax),
            input: container2.querySelector(this.selectors.inputMax),
          },
        }),
        (this.controls.min.value = parseInt(
          this.controls.min.input.value === ""
            ? this.controls.min.input.placeholder
            : this.controls.min.input.value,
        )),
        (this.controls.max.value = parseInt(
          this.controls.max.input.value === ""
            ? this.controls.max.input.placeholder
            : this.controls.max.input.value,
        )),
        (this.valueMin = this.controls.min.input.min),
        (this.valueMax = this.controls.min.input.max),
        (this.valueRange = this.valueMax - this.valueMin),
        [this.controls.min, this.controls.max].forEach((item) => {
          item.barControl.setAttribute("aria-valuemin", this.valueMin),
            item.barControl.setAttribute("aria-valuemax", this.valueMax),
            item.barControl.setAttribute("tabindex", 0);
        }),
        this.controls.min.barControl.setAttribute(
          "aria-valuenow",
          this.controls.min.value,
        ),
        this.controls.max.barControl.setAttribute(
          "aria-valuenow",
          this.controls.max.value,
        ),
        (this.bar = container2.querySelector(this.selectors.bar)),
        (this.activeBar = container2.querySelector(this.selectors.activeBar)),
        (this.inDrag = !1),
        (this.rtl = document.querySelector("html[dir=rtl]")),
        this.bindEvents(),
        this.render();
    }
    getPxToValueRatio() {
      var r = this.bar.clientWidth / (this.valueMax - this.valueMin);
      return this.rtl ? -r : r;
    }
    getPcToValueRatio() {
      return 100 / (this.valueMax - this.valueMin);
    }
    setActiveControlValue(value) {
      isNaN(parseInt(value)) ||
        (this.activeControl === this.controls.min
          ? (value === "" && (value = this.valueMin),
            (value = Math.max(this.valueMin, value)),
            (value = Math.min(value, this.controls.max.value)))
          : (value === "" && (value = this.valueMax),
            (value = Math.min(this.valueMax, value)),
            (value = Math.max(value, this.controls.min.value))),
        (this.activeControl.value = Math.round(value)),
        this.activeControl.input.value != this.activeControl.value &&
          (this.activeControl.value == this.activeControl.input.placeholder
            ? (this.activeControl.input.value = "")
            : (this.activeControl.input.value = this.activeControl.value),
          this.activeControl.input.dispatchEvent(
            new CustomEvent("change", {
              bubbles: !0,
              cancelable: !1,
              detail: { sender: "theme:component:price_range" },
            }),
          )),
        this.activeControl.barControl.setAttribute(
          "aria-valuenow",
          this.activeControl.value,
        ));
    }
    render() {
      this.drawControl(this.controls.min),
        this.drawControl(this.controls.max),
        this.drawActiveBar();
    }
    drawControl(control) {
      var x = (control.value - this.valueMin) * this.getPcToValueRatio() + "%";
      this.rtl
        ? (control.barControl.style.right = x)
        : (control.barControl.style.left = x);
    }
    drawActiveBar() {
      var s =
          (this.controls.min.value - this.valueMin) * this.getPcToValueRatio() +
          "%",
        e =
          (this.valueMax - this.controls.max.value) * this.getPcToValueRatio() +
          "%";
      this.rtl
        ? ((this.activeBar.style.left = e), (this.activeBar.style.right = s))
        : ((this.activeBar.style.left = s), (this.activeBar.style.right = e));
    }
    handleControlTouchStart(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.touches[0].clientX),
        (this.boundControlTouchMoveEvent =
          this.handleControlTouchMove.bind(this)),
        (this.boundControlTouchEndEvent =
          this.handleControlTouchEnd.bind(this)),
        window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
        window.addEventListener("touchend", this.boundControlTouchEndEvent);
    }
    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX);
    }
    handleControlTouchEnd(e) {
      e.preventDefault(),
        window.removeEventListener(
          "touchmove",
          this.boundControlTouchMoveEvent,
        ),
        window.removeEventListener("touchend", this.boundControlTouchEndEvent),
        this.stopDrag();
    }
    handleControlMouseDown(e) {
      e.preventDefault(),
        this.startDrag(e.target, e.clientX),
        (this.boundControlMouseMoveEvent =
          this.handleControlMouseMove.bind(this)),
        (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
        window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
        window.addEventListener("mouseup", this.boundControlMouseUpEvent);
    }
    handleControlMouseMove(e) {
      this.moveDrag(e.clientX);
    }
    handleControlMouseUp(e) {
      e.preventDefault(),
        window.removeEventListener(
          "mousemove",
          this.boundControlMouseMoveEvent,
        ),
        window.removeEventListener("mouseup", this.boundControlMouseUpEvent),
        this.stopDrag();
    }
    startDrag(target, startX) {
      this.controls.min.barControl === target
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        (this.dragStartX = startX),
        (this.dragStartValue = this.activeControl.value),
        (this.inDrag = !0);
    }
    moveDrag(moveX) {
      if (this.inDrag) {
        var value =
          this.dragStartValue +
          (moveX - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(value), this.render();
      }
    }
    stopDrag() {
      this.inDrag = !1;
    }
    handleControlKeyDown(e) {
      e.key === "ArrowRight"
        ? this.incrementControlFromKeypress(e.target, 10)
        : e.key === "ArrowLeft" &&
          this.incrementControlFromKeypress(e.target, -10);
    }
    incrementControlFromKeypress(control, pxAmount) {
      this.controls.min.barControl === control
        ? (this.activeControl = this.controls.min)
        : (this.activeControl = this.controls.max),
        this.setActiveControlValue(
          this.activeControl.value + pxAmount / this.getPxToValueRatio(),
        ),
        this.render();
    }
    handleInputChange(e) {
      (e.target.value = e.target.value.replace(/\D/g, "")),
        (!e.detail || e.detail.sender != "theme:component:price_range") &&
          (this.controls.min.input === e.target
            ? (this.activeControl = this.controls.min)
            : (this.activeControl = this.controls.max),
          this.setActiveControlValue(e.target.value),
          this.render());
    }
    handleInputKeyup(e) {
      setTimeout(
        function () {
          this.value = this.value.replace(/\D/g, "");
        }.bind(e.target),
        10,
      );
    }
    bindEvents() {
      [this.controls.min, this.controls.max].forEach((item) => {
        item.barControl.addEventListener(
          "touchstart",
          this.handleControlTouchStart.bind(this),
        ),
          item.barControl.addEventListener(
            "mousedown",
            this.handleControlMouseDown.bind(this),
          ),
          item.barControl.addEventListener(
            "keydown",
            this.handleControlKeyDown.bind(this),
          ),
          item.input.addEventListener(
            "change",
            this.handleInputChange.bind(this),
          ),
          item.input.addEventListener(
            "keyup",
            this.handleInputKeyup.bind(this),
          );
      });
    }
    destroy() {}
  }
  class PriceRange extends ccComponent {
    constructor() {
      var name =
          arguments.length > 0 && arguments[0] !== void 0
            ? arguments[0]
            : "price-range",
        cssSelector =
          arguments.length > 1 && arguments[1] !== void 0
            ? arguments[1]
            : ".cc-".concat(name);
      super(name, cssSelector);
    }
    init(container2) {
      super.init(container2),
        this.registerInstance(container2, new PriceRangeInstance(container2));
    }
    destroy(container2) {
      this.destroyInstance(container2), super.destroy(container2);
    }
  }
  new PriceRange(),
    (theme.VideoManager = new (function () {
      var _ = this;
      (_.videos = { incrementor: 0, videoData: {} }),
        (_._loadYoutubeVideos = function (container2) {
          $(
            '.video-container[data-video-type="youtube"]:not(.video--init)',
            container2,
          ).each(function () {
            $(this).addClass("video--init"), _.videos.incrementor++;
            var containerId = "theme-yt-video-" + _.videos.incrementor;
            $(this).data("video-container-id", containerId);
            var autoplay = $(this).data("video-autoplay"),
              loop = $(this).data("video-loop"),
              videoId = $(this).data("video-id"),
              isBackgroundVideo = $(this).hasClass(
                "video-container--background",
              ),
              ytURLSearchParams = new URLSearchParams(
                "iv_load_policy=3&modestbranding=1&rel=0&showinfo=0&enablejsapi=1&playslinline=1",
              );
            ytURLSearchParams.append("origin", location.origin),
              ytURLSearchParams.append("playlist", videoId),
              ytURLSearchParams.append("loop", loop ? 1 : 0),
              ytURLSearchParams.append("autoplay", 0),
              ytURLSearchParams.append("controls", isBackgroundVideo ? 0 : 1);
            var widgetid = _.videos.incrementor;
            ytURLSearchParams.append("widgetid", widgetid);
            var src =
                "https://www.youtube.com/embed/" +
                videoId +
                "?" +
                ytURLSearchParams.toString(),
              $videoElement = $(
                '<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">',
              )
                .attr({
                  id: containerId,
                  width: 640,
                  height: 360,
                  tabindex: isBackgroundVideo ? "-1" : null,
                })
                .appendTo($(".video-container__video", this));
            (_.videos.videoData[containerId] = {
              type: "yt",
              id: containerId,
              container: this,
              mute: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"mute","args":""}',
                  "*",
                ),
              play: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"playVideo","args":""}',
                  "*",
                ),
              pause: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  "*",
                ),
              stop: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"stopVideo","args":""}',
                  "*",
                ),
              seekTo: (to) =>
                $videoElement[0].contentWindow.postMessage(
                  '{"event":"command","func":"seekTo","args":['.concat(
                    to,
                    ",true]}",
                  ),
                  "*",
                ),
              videoElement: $videoElement[0],
              isBackgroundVideo,
              establishedYTComms: !1,
            }),
              autoplay &&
                $videoElement.on("load", () =>
                  setTimeout(() => {
                    window.addEventListener("message", (message) => {
                      if (
                        message.origin === "https://www.youtube.com" &&
                        message.data &&
                        typeof message.data == "string"
                      ) {
                        var data = JSON.parse(message.data);
                        data.event === "initialDelivery" &&
                          data.info &&
                          data.info.duration &&
                          (_.videos.videoData[containerId].duration =
                            data.info.duration),
                          data.event === "infoDelivery" &&
                            data.channel === "widget" &&
                            data.id === widgetid &&
                            ((_.videos.videoData[
                              containerId
                            ].establishedYTComms = !0),
                            data.info &&
                              data.info.playerState === 1 &&
                              $(this).addClass("video-container--playing"),
                            loop &&
                              data.info &&
                              data.info.currentTime >
                                _.videos.videoData[containerId].duration - 1 &&
                              _.videos.videoData[containerId].seekTo(0));
                      }
                    }),
                      $videoElement[0].contentWindow.postMessage(
                        '{"event":"listening","id":'.concat(
                          widgetid,
                          ',"channel":"widget"}',
                        ),
                        "*",
                      ),
                      _.videos.videoData[containerId].mute(),
                      _.videos.videoData[containerId].play(),
                      setTimeout(() => {
                        _.videos.videoData[containerId].establishedYTComms ||
                          $(this).addClass("video-container--playing");
                      }, 2e3);
                  }, 100),
                ),
              isBackgroundVideo &&
                ($videoElement.attr("tabindex", "-1"),
                _._initBackgroundVideo(_.videos.videoData[containerId]),
                _.addYTPageshowListenerHack()),
              $videoElement.attr("src", src),
              fetch(
                "https://www.youtube.com/oembed?format=json&url=" +
                  encodeURIComponent($(this).data("video-url")),
              )
                .then((response) => {
                  if (!response.ok)
                    throw new Error(
                      "HTTP error! Status: ".concat(response.status),
                    );
                  return response.json();
                })
                .then((response) => {
                  response.width &&
                    response.height &&
                    ($videoElement.attr({
                      width: response.width,
                      height: response.height,
                    }),
                    _.videos.videoData[containerId].assessBackgroundVideo &&
                      _.videos.videoData[containerId].assessBackgroundVideo());
                });
          });
        }),
        (_._loadVimeoVideos = function (container2) {
          $(
            '.video-container[data-video-type="vimeo"]:not(.video--init)',
            container2,
          ).each(function () {
            $(this).addClass("video--init"), _.videos.incrementor++;
            var containerId = "theme-vi-video-" + _.videos.incrementor;
            $(this).data("video-container-id", containerId);
            var autoplay = $(this).data("video-autoplay"),
              loop = $(this).data("video-loop"),
              videoId = $(this).data("video-id"),
              isBackgroundVideo = $(this).hasClass(
                "video-container--background",
              ),
              viURLSearchParams = new URLSearchParams();
            autoplay && viURLSearchParams.append("muted", 1),
              loop && viURLSearchParams.append("loop", 1),
              isBackgroundVideo && viURLSearchParams.append("controls", 0);
            var src =
                "https://player.vimeo.com/video/" +
                videoId +
                "?" +
                viURLSearchParams.toString(),
              $videoElement = $(
                '<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">',
              )
                .attr({
                  id: containerId,
                  width: 640,
                  height: 360,
                  tabindex: isBackgroundVideo ? "-1" : null,
                })
                .appendTo($(".video-container__video", this));
            (_.videos.videoData[containerId] = {
              type: "vimeo",
              id: containerId,
              container: this,
              play: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"method":"play"}',
                  "*",
                ),
              pause: () =>
                $videoElement[0].contentWindow.postMessage(
                  '{"method":"pause"}',
                  "*",
                ),
              videoElement: $videoElement[0],
              isBackgroundVideo,
              establishedVimeoComms: !1,
            }),
              autoplay &&
                $videoElement.on("load", () =>
                  setTimeout(() => {
                    window.addEventListener("message", (message) => {
                      if (
                        message.origin === "https://player.vimeo.com" &&
                        message.source === $videoElement[0].contentWindow &&
                        message.data
                      ) {
                        var data = message.data;
                        typeof data == "string" && (data = JSON.parse(data)),
                          (data.method === "ping" ||
                            data.event === "playing") &&
                            (_.videos.videoData[
                              containerId
                            ].establishedVimeoComms = !0),
                          data.event === "playing" &&
                            $(this).addClass("video-container--playing");
                      }
                    }),
                      $videoElement[0].contentWindow.postMessage(
                        { method: "addEventListener", value: "playing" },
                        "*",
                      ),
                      $videoElement[0].contentWindow.postMessage(
                        {
                          method: "appendVideoMetadata",
                          value: location.origin,
                        },
                        "*",
                      ),
                      $videoElement[0].contentWindow.postMessage(
                        { method: "ping" },
                        "*",
                      ),
                      _.videos.videoData[containerId].play(),
                      setTimeout(() => {
                        _.videos.videoData[containerId].establishedVimeoComms ||
                          $(this).addClass("video-container--playing");
                      }, 2e3);
                  }, 100),
                ),
              isBackgroundVideo &&
                ($videoElement.attr("tabindex", "-1"),
                _._initBackgroundVideo(_.videos.videoData[containerId])),
              $videoElement.attr("src", src),
              fetch(
                "https://vimeo.com/api/oembed.json?url=" +
                  encodeURIComponent($(this).data("video-url")),
              )
                .then((response) => {
                  if (!response.ok)
                    throw new Error(
                      "HTTP error! Status: ".concat(response.status),
                    );
                  return response.json();
                })
                .then((response) => {
                  response.width &&
                    response.height &&
                    ($videoElement.attr({
                      width: response.width,
                      height: response.height,
                    }),
                    _.videos.videoData[containerId].assessBackgroundVideo &&
                      _.videos.videoData[containerId].assessBackgroundVideo());
                });
          });
        }),
        (_._loadMp4Videos = function (container2) {
          $(
            '.video-container[data-video-type="mp4"]:not(.video--init)',
            container2,
          )
            .addClass("video--init")
            .each(function () {
              _.videos.incrementor++;
              var containerId = "theme-mp-video-" + _.videos.incrementor,
                $container = $(this);
              $(this).data("video-container-id", containerId);
              var $videoElement = $(
                  '<div class="video-container__video-element">',
                )
                  .attr("id", containerId)
                  .appendTo($(".video-container__video", this)),
                autoplay = $(this).data("video-autoplay"),
                isBackgroundVideo = $(this).hasClass(
                  "video-container--background",
                ),
                $video = $("<video playsinline>");
              if (
                ($(this).data("video-loop") && $video.attr("loop", "loop"),
                $video.on("click mouseenter", () =>
                  $video.attr("controls", "controls"),
                ),
                autoplay &&
                  ($video.attr({ autoplay: "autoplay", muted: "muted" }),
                  ($video[0].muted = !0),
                  $video.one("loadeddata", function () {
                    this.play(),
                      $container.addClass("video-container--playing");
                  })),
                $(this).data("video-url") &&
                  $video.attr("src", $(this).data("video-url")),
                $(this).data("video-sources"))
              )
                for (
                  var sources = $(this).data("video-sources").split("|"), i = 0;
                  i < sources.length;
                  i++
                ) {
                  var [format, mimeType, url] = sources[i].split(" ");
                  (format === "m3u8" && $(this).data("video-loop")) ||
                    $("<source>")
                      .attr({ src: url, type: mimeType })
                      .appendTo($video);
                }
              $video.appendTo($videoElement);
              var videoData = (_.videos.videoData[containerId] = {
                type: "mp4",
                element: $video[0],
                play: () => $video[0].play(),
                pause: () => $video[0].pause(),
                isBackgroundVideo,
              });
              isBackgroundVideo &&
                ($video.attr("tabindex", "-1"),
                autoplay &&
                  container2.addEventListener("click", videoData.play, {
                    once: !0,
                  }));
            });
        }),
        (_._initBackgroundVideo = function (videoData) {
          videoData.container.classList.contains(
            "video-container--background",
          ) &&
            ((videoData.assessBackgroundVideo = function () {
              var cw = this.offsetWidth,
                ch = this.offsetHeight,
                cr = cw / ch,
                frame = this.querySelector("iframe"),
                vr = parseFloat(frame.width) / parseFloat(frame.height),
                pan = this.querySelector(".video-container__video"),
                vCrop = 75;
              if (cr > vr) {
                var vh = cw / vr + vCrop * 2;
                (pan.style.marginTop = (ch - vh) / 2 - vCrop + "px"),
                  (pan.style.marginInlineStart = ""),
                  (pan.style.height = vh + vCrop * 2 + "px"),
                  (pan.style.width = "");
              } else {
                var ph = ch + vCrop * 2,
                  pw = ph * vr;
                (pan.style.marginTop = -vCrop + "px"),
                  (pan.style.marginInlineStart = (cw - pw) / 2 + "px"),
                  (pan.style.height = ph + "px"),
                  (pan.style.width = pw + "px");
              }
            }.bind(videoData.container)),
            videoData.assessBackgroundVideo(),
            $(window).on(
              "debouncedresize." + videoData.id,
              videoData.assessBackgroundVideo,
            ),
            videoData.container.addEventListener("click", videoData.play, {
              once: !0,
            }));
        }),
        (_._unloadVideos = function (container2) {
          for (var dataKey in _.videos.videoData) {
            var data = _.videos.videoData[dataKey];
            if ($(container2).find(data.container).length) {
              delete _.videos.videoData[dataKey];
              return;
            }
          }
        }),
        (this.onSectionLoad = function (container2) {
          $(".video-container[data-video-url]:not([data-video-type])").each(
            function () {
              var url = $(this).data("video-url");
              url.indexOf(".mp4") > -1 &&
                $(this).attr("data-video-type", "mp4"),
                url.indexOf("vimeo.com") > -1 &&
                  ($(this).attr("data-video-type", "vimeo"),
                  $(this).attr(
                    "data-video-id",
                    url.split("?")[0].split("/").pop(),
                  )),
                (url.indexOf("youtu.be") > -1 ||
                  url.indexOf("youtube.com") > -1) &&
                  ($(this).attr("data-video-type", "youtube"),
                  url.indexOf("v=") > -1
                    ? $(this).attr(
                        "data-video-id",
                        url.split("v=").pop().split("&")[0],
                      )
                    : $(this).attr(
                        "data-video-id",
                        url.split("?")[0].split("/").pop(),
                      ));
            },
          ),
            _._loadYoutubeVideos(container2),
            _._loadVimeoVideos(container2),
            _._loadMp4Videos(container2),
            $(".video-container__play", container2).on("click", function (evt) {
              evt.preventDefault();
              var $container = $(this).closest(".video-container");
              $container.addClass("video-container--playing"),
                $container.trigger("cc:video:play");
              var id = $container.data("video-container-id");
              _.videos.videoData[id].play();
            }),
            $(".video-container__stop", container2).on("click", function (evt) {
              evt.preventDefault();
              var $container = $(this).closest(".video-container");
              $container.removeClass("video-container--playing"),
                $container.trigger("cc:video:stop");
              var id = $container.data("video-container-id");
              _.videos.videoData[id].pause();
            });
        }),
        (this.onSectionUnload = function (container2) {
          $(".video-container__play, .video-container__stop", container2).off(
            "click",
          ),
            $(window).off(
              "." + $(".video-container").data("video-container-id"),
            ),
            $(window).off("debouncedresize.video-manager-resize"),
            _._unloadVideos(container2),
            $(container2).trigger("cc:video:stop");
        }),
        (_.addYTPageshowListenerHack = function () {
          _.pageshowListenerAdded ||
            ((_.pageshowListenerAdded = !0),
            window.addEventListener("pageshow", (event) => {
              event.persisted &&
                Object.keys(_.videos.videoData)
                  .filter(
                    (key) =>
                      _.videos.videoData[key].type === "yt" &&
                      _.videos.videoData[key].isBackgroundVideo,
                  )
                  .forEach((key) => {
                    _.videos.videoData[key].stop(),
                      _.videos.videoData[key].play();
                  });
            }));
        });
    })()),
    cc.sections.push({ name: "video", section: theme.VideoManager }),
    (theme.MapSection = new (function () {
      var _ = this;
      (_.config = {
        zoom: 14,
        styles: {
          default: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#523735" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#746855" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#8ec3b9" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
      }),
        (_.apiStatus = null),
        (this.geolocate = function ($map) {
          var deferred = $.Deferred(),
            geocoder = new google.maps.Geocoder(),
            address = $map.data("address-setting");
          return (
            geocoder.geocode({ address }, function (results, status2) {
              status2 !== google.maps.GeocoderStatus.OK &&
                deferred.reject(status2),
                deferred.resolve(results);
            }),
            deferred
          );
        }),
        (this.createMap = function (container2) {
          var $map = $(".map-section__map-container", container2);
          return _.geolocate($map)
            .then(
              function (results) {
                var mapOptions = {
                  zoom: _.config.zoom,
                  styles: _.config.styles[$(container2).data("map-style")],
                  center: results[0].geometry.location,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0,
                  zoomControl: !$map.data("hide-zoom"),
                };
                (_.map = new google.maps.Map($map[0], mapOptions)),
                  (_.center = _.map.getCenter());
                var marker = new google.maps.Marker({
                  map: _.map,
                  position: _.center,
                  clickable: !1,
                });
                google.maps.event.addDomListener(window, "resize", function () {
                  google.maps.event.trigger(_.map, "resize"),
                    _.map.setCenter(_.center);
                });
              }.bind(this),
            )
            .fail(function () {
              var errorMessage;
              switch (status) {
                case "ZERO_RESULTS":
                  errorMessage = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  errorMessage = theme.strings.addressQueryLimit;
                  break;
                default:
                  errorMessage = theme.strings.addressError;
                  break;
              }
              if (Shopify.designMode) {
                var $mapContainer = $map.parents(".map-section");
                $mapContainer.addClass("page-width map-section--load-error"),
                  $mapContainer
                    .find(".map-section__wrapper")
                    .html(
                      '<div class="errors text-center">' +
                        errorMessage +
                        "</div>",
                    );
              }
            });
        }),
        (this.onSectionLoad = function (target) {
          var $container = $(target);
          window.gm_authFailure = function () {
            Shopify.designMode &&
              ($container.addClass("page-width map-section--load-error"),
              $container
                .find(".map-section__wrapper")
                .html(
                  '<div class="errors text-center">' +
                    theme.strings.authError +
                    "</div>",
                ));
          };
          var key = $container.data("api-key");
          typeof key != "string" ||
            key === "" ||
            theme.loadScriptOnce(
              "https://maps.googleapis.com/maps/api/js?key=" + key,
              function () {
                _.createMap($container);
              },
            );
        }),
        (this.onSectionUnload = function (target) {
          typeof window.google < "u" &&
            typeof google.maps < "u" &&
            google.maps.event.clearListeners(_.map, "resize");
        });
    })()),
    cc.sections.push({ name: "map", section: theme.MapSection }),
    (theme.FaqHeader = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.container = container2),
          (this.classNames = {
            questionContainerInactive: "faq-search-item-inactive",
            sectionWithIndexStatus: "section-faq-header--with-index",
          }),
          (this.searchInput =
            this.container.querySelector(".faq-search__input")),
          this.searchInput &&
            (this.registerEventListener(
              this.searchInput,
              "change",
              this.functions.performSearch.bind(this),
            ),
            this.registerEventListener(
              this.searchInput,
              "keyup",
              this.functions.performSearch.bind(this),
            ),
            this.registerEventListener(
              this.searchInput,
              "paste",
              this.functions.performSearch.bind(this),
            )),
          (this.functions.debouncedBuildIndex = theme.debounce(
            this.functions.buildIndex.bind(this),
            50,
          )),
          this.registerEventListener(
            document,
            "theme:faq-header-update",
            this.functions.debouncedBuildIndex,
          ),
          this.functions.debouncedBuildIndex(),
          this.container.querySelector(".faq-index") &&
            (this.registerEventListener(
              this.container,
              "click",
              this.functions.handleIndexClick.bind(this),
            ),
            this.container
              .closest(".section-faq-header")
              .classList.add(this.classNames.sectionWithIndexStatus),
            this.functions.resizeIndex.call(this),
            this.registerEventListener(
              window,
              "resize",
              theme.debounce(this.functions.resizeIndex.bind(this), 250),
            ));
      }),
        (this.onSectionReorder = function (container2) {
          this.functions.debouncedBuildIndex();
        }),
        (this.functions = {
          buildIndex: function () {
            var faqHeaderSection = this.container.closest(
                ".section-faq-header",
              ),
              indexContainer = this.container.querySelector(
                ".faq-index__item-container",
              );
            indexContainer &&
              indexContainer
                .querySelectorAll(".faq-index-item")
                .forEach((element) => {
                  element.parentNode.removeChild(element);
                }),
              (this.linkedCollapsibleTabs = []),
              (this.linkedQuestionContainers = []),
              (this.linkedContent = []);
            for (
              var currentElement = faqHeaderSection;
              currentElement.nextElementSibling &&
              currentElement.nextElementSibling.classList.contains(
                "section-collapsible-tabs",
              );
            )
              if (
                ((currentElement = currentElement.nextElementSibling),
                this.linkedCollapsibleTabs.push(currentElement),
                currentElement
                  .querySelectorAll(".collapsible-tabs__tab")
                  .forEach((element) =>
                    this.linkedQuestionContainers.push(element),
                  ),
                currentElement
                  .querySelectorAll(".collapsible-tabs__content")
                  .forEach((element) => this.linkedContent.push(element)),
                indexContainer)
              ) {
                var currentElementHeading = currentElement.querySelector(
                  ".collapsible-tabs__heading",
                );
                if (currentElementHeading) {
                  var tve = theme.createTemplateVariableEncoder();
                  tve.add("title_id", currentElementHeading.id, "attribute"),
                    tve.add("title", currentElementHeading.innerHTML, "raw");
                  var html = `
              <div class="faq-index-item">
                <a class="faq-index-item__link" href="#`
                      .concat(tve.values.title_id, '">')
                      .concat(
                        tve.values.title,
                        `</a>
              </div>`,
                      ),
                    htmlFragment = document
                      .createRange()
                      .createContextualFragment(html);
                  indexContainer.appendChild(htmlFragment);
                }
              }
            indexContainer && this.functions.resizeIndex.call(this);
          },
          resizeIndex: function () {
            for (
              var stickyContainer = this.container.querySelector(
                  ".faq-index__sticky-container",
                ),
                faqHeaderSection = this.container.closest(
                  ".section-faq-header",
                ),
                currentElement = faqHeaderSection;
              currentElement.nextElementSibling &&
              currentElement.nextElementSibling.classList.contains(
                "section-collapsible-tabs",
              );
            )
              currentElement = currentElement.nextElementSibling;
            var stickyContainerRect = stickyContainer.getBoundingClientRect(),
              currentElementRect = currentElement.getBoundingClientRect();
            stickyContainer.style.height =
              currentElementRect.bottom - stickyContainerRect.top + "px";
          },
          performSearch: function () {
            setTimeout(() => {
              var splitValue = this.searchInput.value.split(" "),
                terms = [];
              splitValue.forEach((t) => {
                t.length > 0 && terms.push(t.toLowerCase());
              }),
                this.linkedQuestionContainers.forEach((element) => {
                  if (terms.length) {
                    var termFound = !1,
                      matchContent = element.textContent.toLowerCase();
                    terms.forEach((term) => {
                      matchContent.indexOf(term) >= 0 && (termFound = !0);
                    }),
                      termFound
                        ? element.classList.remove(
                            this.classNames.questionContainerInactive,
                          )
                        : element.classList.add(
                            this.classNames.questionContainerInactive,
                          );
                  } else
                    element.classList.remove(
                      this.classNames.questionContainerInactive,
                    );
                }),
                this.linkedContent.forEach((element) => {
                  terms.length
                    ? element.classList.add(
                        this.classNames.questionContainerInactive,
                      )
                    : element.classList.remove(
                        this.classNames.questionContainerInactive,
                      );
                });
            }, 10);
          },
          handleIndexClick: function (evt) {
            if (evt.target.classList.contains("faq-index-item__link")) {
              evt.preventDefault();
              var id = evt.target.href.split("#")[1],
                scrollTarget = document.getElementById(id),
                scrollTargetY =
                  scrollTarget.getBoundingClientRect().top +
                  window.pageYOffset -
                  50,
                stickyHeight = getComputedStyle(
                  document.documentElement,
                ).getPropertyValue("--theme-sticky-header-height");
              stickyHeight && (scrollTargetY -= parseInt(stickyHeight)),
                window.scrollTo({ top: scrollTargetY, behavior: "smooth" });
            }
          },
        });
    })()),
    cc.sections.push({
      name: "faq-header",
      section: theme.FaqHeader,
      deferredLoad: !1,
    }),
    (theme.CollapsibleTabs = new (function () {
      (this.onSectionLoad = function (container2) {
        this.functions.notifyFaqHeaderOfChange();
      }),
        (this.onSectionReorder = function (container2) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.onSectionUnload = function (container2) {
          this.functions.notifyFaqHeaderOfChange();
        }),
        (this.functions = {
          notifyFaqHeaderOfChange: function () {
            document.dispatchEvent(
              new CustomEvent("theme:faq-header-update", {
                bubbles: !0,
                cancelable: !1,
              }),
            );
          },
        });
    })()),
    cc.sections.push({
      name: "collapsible-tabs",
      section: theme.CollapsibleTabs,
      deferredLoad: !1,
    }),
    (theme.StoreAvailability = function (container2) {
      var loadingClass = "store-availability-loading",
        initClass = "store-availability-initialized",
        storageKey = "cc-location";
      (this.onSectionLoad = function (container3) {
        (this.namespace = theme.namespaceFromSection(container3)),
          (this.$container = $(container3)),
          (this.productId = this.$container.data(
            "store-availability-container",
          )),
          (this.sectionUrl = this.$container.data("section-url")),
          this.$modal,
          this.$container.addClass(initClass),
          (this.transitionDurationMS =
            parseFloat(getComputedStyle(container3).transitionDuration) * 1e3),
          (this.removeFixedHeightTimeout = -1),
          $(window).on(
            "cc-variant-updated".concat(this.namespace).concat(this.productId),
            (e, args) => {
              args.product.id === this.productId &&
                this.functions.updateContent.bind(this)(
                  args.variant ? args.variant.id : null,
                  args.product.title,
                  this.$container.data("has-only-default-variant"),
                  args.variant && typeof args.variant.available < "u",
                );
            },
          ),
          this.$container.data("single-variant-id") &&
            this.functions.updateContent.bind(this)(
              this.$container.data("single-variant-id"),
              this.$container.data("single-variant-product-title"),
              this.$container.data("has-only-default-variant"),
              this.$container.data("single-variant-product-available"),
            );
      }),
        (this.onSectionUnload = function () {
          $(window).off(
            "cc-variant-updated".concat(this.namespace).concat(this.productId),
          ),
            this.$container.off("click"),
            this.$modal && this.$modal.off("click");
        }),
        (this.functions = {
          getUserLocation: function () {
            return new Promise((resolve, reject) => {
              var storedCoords;
              sessionStorage[storageKey] &&
                (storedCoords = JSON.parse(sessionStorage[storageKey])),
                storedCoords
                  ? resolve(storedCoords)
                  : navigator.geolocation
                    ? navigator.geolocation.getCurrentPosition(
                        function (position) {
                          var coords = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                          };
                          fetch("/localization.json", {
                            method: "PUT",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify(coords),
                          }),
                            (sessionStorage[storageKey] =
                              JSON.stringify(coords)),
                            resolve(coords);
                        },
                        function () {
                          resolve(!1);
                        },
                        { maximumAge: 36e5, timeout: 5e3 },
                      )
                    : resolve(!1);
            });
          },
          getAvailableStores: function (variantId, cb) {
            return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
          },
          calculateDistance: function (coords1, coords2, unitSystem) {
            var dtor = Math.PI / 180,
              radius = unitSystem === "metric" ? 6378.14 : 3959,
              rlat1 = coords1.latitude * dtor,
              rlong1 = coords1.longitude * dtor,
              rlat2 = coords2.latitude * dtor,
              rlong2 = coords2.longitude * dtor,
              dlon = rlong1 - rlong2,
              dlat = rlat1 - rlat2,
              a =
                Math.pow(Math.sin(dlat / 2), 2) +
                Math.cos(rlat1) *
                  Math.cos(rlat2) *
                  Math.pow(Math.sin(dlon / 2), 2),
              c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return radius * c;
          },
          updateLocationDistances: function (coords) {
            var unitSystem = this.$modal
                .find("[data-unit-system]")
                .data("unit-system"),
              self = this;
            this.$modal.find('[data-distance="false"]').each(function () {
              var thisCoords = {
                latitude: parseFloat($(this).data("latitude")),
                longitude: parseFloat($(this).data("longitude")),
              };
              if (thisCoords.latitude && thisCoords.longitude) {
                var distance = self.functions
                  .calculateDistance(coords, thisCoords, unitSystem)
                  .toFixed(1);
                $(this).html(distance),
                  setTimeout(() => {
                    $(this)
                      .closest(".store-availability-list__location__distance")
                      .addClass("-in");
                  }, 0);
              }
              $(this).attr("data-distance", "true");
            });
          },
          updateContent: function (
            variantId,
            productTitle,
            isSingleDefaultVariant,
            isVariantAvailable,
          ) {
            this.$container.off(
              "click",
              "[data-store-availability-modal-open]",
            ),
              this.$container.off(
                "click" + this.namespace,
                ".cc-popup-close, .cc-popup-background",
              ),
              $(".store-availabilities-modal").remove(),
              isVariantAvailable
                ? (this.$container.addClass(loadingClass),
                  this.transitionDurationMS > 0 &&
                    this.$container.css(
                      "height",
                      this.$container.outerHeight() + "px",
                    ))
                : (this.$container.addClass(loadingClass),
                  this.transitionDurationMS > 0 &&
                    this.$container.css("height", "0px")),
              isVariantAvailable &&
                this.functions.getAvailableStores.call(
                  this,
                  variantId,
                  (response) => {
                    if (
                      response.trim().length > 0 &&
                      !response.includes("NO_PICKUP")
                    ) {
                      this.$container.html(response),
                        this.$container.html(
                          this.$container.children().first().html(),
                        ),
                        this.$container
                          .find("[data-store-availability-modal-product-title]")
                          .html(productTitle),
                        isSingleDefaultVariant &&
                          this.$container
                            .find(".store-availabilities-modal__variant-title")
                            .remove(),
                        this.$container.find(".cc-popup").appendTo("body"),
                        (this.$modal = $("body").find(
                          ".store-availabilities-modal",
                        ));
                      var popup = new ccPopup(this.$modal, this.namespace);
                      if (
                        (this.$container.on(
                          "click",
                          "[data-store-availability-modal-open]",
                          () => (
                            popup.open(),
                            this.functions.getUserLocation().then((coords) => {
                              coords &&
                                this.$modal.find('[data-distance="false"]')
                                  .length &&
                                this.functions.getAvailableStores.call(
                                  this,
                                  variantId,
                                  (response2) => {
                                    this.$modal
                                      .find(".store-availabilities-list")
                                      .html(
                                        $(response2)
                                          .find(".store-availabilities-list")
                                          .html(),
                                      ),
                                      this.functions.updateLocationDistances.bind(
                                        this,
                                      )(coords);
                                  },
                                );
                            }),
                            !1
                          ),
                        ),
                        this.$modal.on(
                          "click" + this.namespace,
                          ".cc-popup-close, .cc-popup-background",
                          () => {
                            popup.close();
                          },
                        ),
                        this.$container.removeClass(loadingClass),
                        this.transitionDurationMS > 0)
                      ) {
                        var newHeight = this.$container
                          .find(".store-availability-container")
                          .outerHeight();
                        this.$container.css(
                          "height",
                          newHeight > 0 ? newHeight + "px" : "",
                        ),
                          clearTimeout(this.removeFixedHeightTimeout),
                          (this.removeFixedHeightTimeout = setTimeout(() => {
                            this.$container.css("height", "");
                          }, this.transitionDurationMS));
                      }
                    }
                  },
                );
          },
        }),
        this.onSectionLoad(container2);
    }),
    cc.sections.push({
      name: "store-availability",
      section: theme.StoreAvailability,
    }),
    (theme.Popup = new (function () {
      var dismissedStorageKey = "cc-theme-popup-dismissed";
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.popup = new ccPopup(this.$container, this.namespace));
        var dismissForDays = this.$container.data("dismiss-for-days"),
          delaySeconds = this.$container.data("delay-seconds"),
          showPopup = !0,
          testMode = this.$container.data("test-mode"),
          lastDismissed = window.localStorage.getItem(dismissedStorageKey);
        if (lastDismissed) {
          var dismissedDaysAgo = (new Date().getTime() - lastDismissed) / 864e5;
          dismissedDaysAgo < dismissForDays && (showPopup = !1);
        }
        this.$container.find(".cc-popup-form__response").length &&
          ((showPopup = !0),
          (delaySeconds = 1),
          this.$container.find(".cc-popup-form__response--success").length &&
            this.functions.popupSetAsDismissed.call(this)),
          document.querySelector(".shopify-challenge__container") &&
            (showPopup = !1),
          (showPopup || testMode) &&
            setTimeout(() => {
              this.popup.open();
            }, delaySeconds * 1e3),
          this.$container.on(
            "click" + this.namespace,
            ".cc-popup-close, .cc-popup-background",
            () => {
              this.popup.close(() => {
                this.functions.popupSetAsDismissed.call(this);
              });
            },
          );
      }),
        (this.onSectionSelect = function () {
          this.popup.open();
        }),
        (this.functions = {
          popupSetAsDismissed: function () {
            window.localStorage.setItem(
              dismissedStorageKey,
              new Date().getTime(),
            );
          },
        }),
        (this.onSectionUnload = function () {
          this.$container.off(this.namespace);
        });
    })()),
    cc.sections.push({ name: "newsletter-popup", section: theme.Popup }),
    (theme.owlCarouselEventList =
      [
        "to",
        "next",
        "prev",
        "destroy",
        "initialized",
        "resized",
        "refreshed",
      ].join(".owl.carousel ") + ".owl.carousel"),
    (theme.beforeCarouselLoadEventBlockFix = function (carouselEls) {
      $(carouselEls).on(theme.owlCarouselEventList, function (evt) {
        evt.stopPropagation();
      });
    }),
    (theme.beforeCarouselUnloadEventBlockFix = function (carouselEls) {
      $(carouselEls).off(theme.owlCarouselEventList);
    }),
    (theme.loadCarousels = function (container2) {
      return $(".carousel", container2).each(function () {
        var $this = $(this);
        function getTotalProductBlockWidth() {
          var productBlockTotalWidth = 0;
          return (
            $this
              .find(
                $this.hasClass("owl-loaded")
                  ? ".owl-item:not(.cloned)"
                  : ".product-block",
              )
              .each(function () {
                productBlockTotalWidth += $(this).outerWidth(!0);
              }),
            productBlockTotalWidth
          );
        }
        $this
          .closest(".collection-slider")
          .unbind()
          .on("click.themeCarousel", ".prev, .next", function (e) {
            e.preventDefault();
            var carousel = $(this)
              .closest(".collection-slider")
              .find(".owl-carousel")
              .data("owl.carousel");
            $(this).hasClass("prev") ? carousel.prev() : carousel.next();
          });
        var carouselOptions,
          isLooping,
          fixedMode =
            $this.hasClass("carousel--fixed-grid-mode") ||
            !$(this).closest(".container--no-max").length;
        if (
          ($(this).closest('[data-section-type="featured-collections"]')
            .length &&
            $(window).width() < 786 &&
            (fixedMode = !1),
          fixedMode)
        ) {
          $this.addClass("carousel--fixed-grid-mode");
          var desktopNumPerRow = parseInt(
              $this[0].className.match(/per-row-(.)/)[1],
            ),
            forcedNumPerRow = !1,
            mobileNumPerRow = !1,
            loopFalse = $this.hasClass("isLoopingFalse");
          if (
            ($this[0].className.indexOf("carousel--per-row-") > -1 &&
              ((forcedNumPerRow = parseInt(
                $this[0].className.match(/carousel--per-row-(.)/)[1],
              )),
              (forcedNumPerRow =
                forcedNumPerRow <= 20
                  ? forcedNumPerRow
                  : forcedNumPerRow / 10)),
            $this[0].className.indexOf("product-list--per-row-mob-") > -1)
          ) {
            try {
              mobileNumPerRow = parseInt(
                $this[0].className.match(/product-list--per-row-mob-(..)/)[1],
              );
            } catch {
              mobileNumPerRow = 2;
            }
            mobileNumPerRow =
              mobileNumPerRow <= 20 ? mobileNumPerRow : mobileNumPerRow / 10;
          } else mobileNumPerRow = forcedNumPerRow;
          carouselOptions = {
            margin: 0,
            loop: !1,
            autoWidth: !1,
            items: 5,
            center: !1,
            nav: !1,
            dots: !1,
            responsive: {
              0: {
                loop: !loopFalse,
                autoWidth: !0,
                items: mobileNumPerRow || (desktopNumPerRow < 4 ? 1 : 2),
                slideBy: mobileNumPerRow || (desktopNumPerRow < 4 ? 1 : 2),
              },
              480: {
                loop: !loopFalse,
                autoWidth: !0,
                items: mobileNumPerRow || Math.min(2, desktopNumPerRow - 2),
                slideBy: mobileNumPerRow || Math.min(2, desktopNumPerRow - 2),
              },
              767: {
                loop: !1,
                items: forcedNumPerRow || desktopNumPerRow - 1,
                slideBy: forcedNumPerRow || desktopNumPerRow - 1,
              },
              1e3: {
                loop: !1,
                items: forcedNumPerRow || desktopNumPerRow,
                slideBy: forcedNumPerRow || desktopNumPerRow,
              },
            },
          };
        } else {
          var desktopNumPerRow = parseInt(
              $this[0].className.match(/per-row-(.)/)[1],
            ),
            mobileNumPerRow = !1;
          if ($this[0].className.indexOf("product-list--per-row-mob-") > -1) {
            try {
              mobileNumPerRow = parseInt(
                $this[0].className.match(/product-list--per-row-mob-(..)/)[1],
              );
            } catch {
              mobileNumPerRow = 2;
            }
            mobileNumPerRow =
              mobileNumPerRow <= 20 ? mobileNumPerRow : mobileNumPerRow / 10;
          }
          isLooping = getTotalProductBlockWidth() > $this.width();
          let tempIsLooping = $this.hasClass("isLoopingFalse");
          tempIsLooping
            ? (carouselOptions = {
                margin: 0,
                loop: !1,
                autoWidth: !0,
                items: Math.min($this.children().length, 8),
                center: !tempIsLooping,
                nav: !1,
                dots: !1,
                slideBy: desktopNumPerRow - 1,
                responsive: {
                  0: { loop: !0, slideBy: mobileNumPerRow ?? 2 },
                  768: { loop: !0, slideBy: desktopNumPerRow - 1 },
                },
              })
            : (carouselOptions = {
                margin: 0,
                loop: !0,
                autoWidth: !1,
                items: Math.min($this.children().length, 8),
                center: !0,
                nav: !1,
                dots: !1,
                responsive: {
                  0: {
                    center: !1,
                    items: mobileNumPerRow || (desktopNumPerRow < 4 ? 1 : 2),
                  },
                  480: {
                    center: !1,
                    items: mobileNumPerRow || Math.min(2, desktopNumPerRow - 2),
                  },
                  767: {
                    items: forcedNumPerRow || desktopNumPerRow - 1,
                    center: !0,
                    autoWidth: !0,
                  },
                  1e3: {
                    items: forcedNumPerRow || desktopNumPerRow,
                    center: !0,
                    autoWidth: !0,
                  },
                },
              });
        }
        carouselOptions.rtl = !!document.querySelector("html[dir=rtl]");
        var loadCarousel = function () {
          $this.find("[data-src]").each(function () {
            $(this)
              .attr("data-src-temp", $(this).attr("data-src"))
              .removeAttr("data-src");
          }),
            theme.beforeCarouselLoadEventBlockFix($this),
            $this.on("initialized.owl.carousel", function () {
              $this.find("[data-src-temp]").each(function () {
                $(this)
                  .attr("data-src", $(this).attr("data-src-temp"))
                  .removeAttr("data-src-temp");
              }),
                $this
                  .find(
                    '.product-block__image--primary .lazyload--manual, .product-block__image--secondary[data-image-index="1"] .lazyload--manual, .product-block-options__item.lazyload--manual',
                  )
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
                theme.ProductBlockManager.loadImages(
                  $this.closest("[data-section-type]"),
                );
            }),
            $this.on(
              "initialized.owl.carousel resized.owl.carousel",
              function (evt) {
                if (!fixedMode && evt.type == "resized") {
                  var shouldLoop = getTotalProductBlockWidth() > $this.width();
                  if (shouldLoop != isLooping) {
                    (carouselOptions.loop = shouldLoop),
                      (isLooping = shouldLoop),
                      $(evt.target).data("owl.carousel").destroy(),
                      $(evt.target).owlCarousel(carouselOptions);
                    return;
                  }
                }
                setTimeout(function () {
                  var currentWidth = $this.find(".owl-stage").width(),
                    stageIsPartiallyOffScreen = currentWidth > $this.width();
                  if (stageIsPartiallyOffScreen) {
                    var newWidth = 0;
                    $this.find(".owl-item").each(function () {
                      newWidth += $(this).outerWidth(!0) + 1;
                    }),
                      $this
                        .find(".owl-stage")
                        .css({})
                        .removeClass("owl-stage--items-fit");
                  } else
                    $this
                      .find(".owl-stage")
                      .addClass("owl-stage--items-fit")
                      .css({});
                  $this
                    .closest(".collection-slider")
                    .find(".prev, .next")
                    .toggleClass(
                      "owl-btn-disabled",
                      !stageIsPartiallyOffScreen,
                    );
                }, 10);
              },
            ),
            (theme.carouselInputIncrementer =
              theme.carouselInputIncrementer || 0),
            $this
              .on("refreshed.owl.carousel", function () {
                $(".owl-item", this).removeAttr("aria-hidden"),
                  $(".owl-item.cloned", this)
                    .attr("aria-hidden", "true")
                    .each(function () {
                      theme.carouselInputIncrementer++;
                      var uniquenessSuffix =
                        "_" + theme.carouselInputIncrementer;
                      $(this)
                        .find(
                          "form[id]:not([data-id-altered]), :input[id]:not([data-id-altered])",
                        )
                        .each(function () {
                          $(this).attr(
                            "id",
                            $(this).attr("id") + uniquenessSuffix,
                          );
                        })
                        .attr("data-id-altered", !0),
                        $(this)
                          .find("label[for]:not([data-id-altered])")
                          .each(function () {
                            $(this).attr(
                              "for",
                              $(this).attr("for") + uniquenessSuffix,
                            );
                          })
                          .attr("data-id-altered", !0);
                    });
              })
              .addClass("owl-carousel")
              .owlCarousel(carouselOptions);
        };
        loadCarousel();
      });
    }),
    (theme.loadCarouselNew = function () {
      function scrollLeft() {
        document
          .querySelector(".categories")
          .scrollTo({
            left: document.querySelector(".subcategory-desktop").offsetWidth,
            behavior: "smooth",
          }),
          (document.querySelector(".autoscroll-left").style.display = "flex"),
          (document.querySelector(".autoscroll-right").style.display = "none");
      }
      function scrollRight() {
        document
          .querySelector(".categories")
          .scrollTo({ left: 0, behavior: "smooth" }),
          (document.querySelector(".autoscroll-left").style.display = "none"),
          (document.querySelector(".autoscroll-right").style.display = "flex");
      }
      function subCollectionScrollBtn() {
        document.querySelector(".subcategory-desktop").offsetWidth <
          document.querySelector(".subcategory-desktop .categories")
            .scrollWidth &&
          (document.querySelector(".autoscroll-right").style.display = "flex"),
          document
            .querySelector(".autoscroll-right")
            .addEventListener("click", scrollLeft),
          document
            .querySelector(".autoscroll-left")
            .addEventListener("click", scrollRight);
      }
      addSubcollectionActiveClass(), subCollectionScrollBtn();
    }),
    setTimeout(() => {
      $(".hover-enabled").on({
        mouseenter: function () {
          $(this).addClass("active");
          let temp = $(this).find(".option-selector");
          temp &&
            temp.length &&
            temp.each((index, item) => {
              $(item).width() <
                $(item).find(".option-wrapper .carousel-new").get(0)
                  .scrollWidth &&
                ($(item).find(".autoscroll-right").css({ display: "flex" }),
                $(item).addClass("has-arrows"));
            });
        },
        mouseleave: function () {
          $(this).removeClass("active");
        },
      }),
        $(".autoscroll-right").on("click", function () {
          let scrollLeft =
              -1 *
              parseInt(
                $(this)
                  .parent(".option-selector")
                  .find(".carousel-new")
                  .css("margin-left"),
              ),
            windowWidth = $(this).parent(".option-selector").width() - 10,
            maxWidth = $(this)
              .parent(".option-selector")
              .find(".option-wrapper .carousel-new")
              .get(0).scrollWidth;
          maxWidth <= scrollLeft + 2 * windowWidth
            ? (scrollLeft += maxWidth - scrollLeft - windowWidth)
            : (scrollLeft += windowWidth),
            $(this)
              .parent()
              .find(".carousel-new")
              .animate({ marginLeft: -1 * scrollLeft + "px" }),
            $(this).parent().find(".autoscroll-left").css({ display: "flex" }),
            $(this).parent().find(".autoscroll-left").removeClass("disabled"),
            maxWidth <= scrollLeft + windowWidth &&
              $(this).addClass("disabled");
        }),
        $(".autoscroll-left").on("click", function () {
          $(this).parent().find(".autoscroll-right").css({ display: "flex" }),
            $(this).parent().find(".autoscroll-right").removeClass("disabled");
          let scrollLeft =
              -1 *
              parseInt(
                $(this)
                  .parent(".option-selector")
                  .find(".carousel-new")
                  .css("margin-left"),
              ),
            windowWidth = $(this).parent(".option-selector").width() - 10;
          (scrollLeft -= windowWidth),
            scrollLeft < 0 && ((scrollLeft = 0), $(this).addClass("disabled")),
            $(this)
              .parent()
              .find(".carousel-new")
              .animate({ marginLeft: -1 * scrollLeft + "px" });
        });
    }, 2e3),
    (theme.unloadCarousels = function (container2) {
      $(".collection-slider", container2).off(".themeCarousel"),
        $(".slick-slider", container2).slick("unslick"),
        theme.beforeCarouselUnloadEventBlockFix($(".owl-carousel", container2)),
        $(".owl-carousel", container2).each(function () {
          $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.icons = {
      left:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_left +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
      right:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_right +
        '</title><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      close:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><title>' +
        theme.strings.icon_labels_close +
        '</title><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      chevronLeft:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left ltr-icon"><title>' +
        theme.strings.icon_labels_left +
        '</title><polyline points="15 18 9 12 15 6"></polyline></svg>',
      chevronRight:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right ltr-icon"><title>' +
        theme.strings.icon_labels_right +
        '</title><polyline points="9 18 15 12 9 6"></polyline></svg>',
      chevronDown:
        '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>' +
        theme.strings.icon_labels_down +
        '</title><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
      tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
      label:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg>',
    });
  try {
    theme.Shopify.features = JSON.parse(
      document.documentElement.querySelector("#shopify-features").textContent,
    );
  } catch (e) {
    theme.Shopify.features = {};
  }
  if (
    ((theme.namespaceFromSection = function (container2) {
      return [
        ".",
        $(container2).data("section-type"),
        $(container2).data("section-id"),
      ].join("");
    }),
    (theme.toggleLinkDropdownButton = function (evt) {
      evt.stopPropagation();
      var $btn2 = $(evt.currentTarget),
        doExpand = $btn2.attr("aria-expanded") == "false";
      $btn2.attr("aria-expanded", doExpand),
        $btn2.css("width", $btn2.outerWidth() + "px");
      var newWidth = null,
        $optsBox = $btn2.next(),
        isLeftAligned = $btn2
          .closest(".link-dropdown")
          .hasClass("link-dropdown--left-aligned");
      isLeftAligned ||
        (doExpand
          ? ((newWidth = $optsBox.outerWidth()),
            document.querySelector("html[dir=rtl]")
              ? (newWidth += parseInt($optsBox.css("left")))
              : (newWidth += parseInt($optsBox.css("right"))),
            (newWidth -= parseInt(
              $optsBox
                .find(".link-dropdown__link:first")
                .css("padding-inline-start"),
            )))
          : (newWidth =
              parseInt($btn2.css("padding-inline-end")) +
              $btn2.find(".link-dropdown__button-text").width() +
              1),
        setTimeout(function () {
          $btn2.css("width", newWidth + "px");
        }, 10));
    }),
    (theme.awakenImagesFromSlumber = function ($cont) {
      $cont.find(".lazyload--manual:not(.lazyload)").addClass("lazyload");
    }),
    (theme.measureTextInsideElement = function (text, element) {
      theme.measureTextInsideElementCanvas =
        theme.measureTextInsideElementCanvas ||
        document.createElement("canvas");
      var context = theme.measureTextInsideElementCanvas.getContext("2d"),
        font = getComputedStyle(element).font;
      return (context.font = font), context.measureText(text);
    }),
    (theme.avoidUnecessaryOrphans = function (element) {
      if (theme.settings.avoid_orphans) {
        var innerTextSplit = element.innerText.split(" ");
        if (
          innerTextSplit.length >= 4 &&
          innerTextSplit[innerTextSplit.length - 1].length +
            innerTextSplit[innerTextSplit.length - 2].length <
            20
        ) {
          var html = element.innerHTML;
          if (html.indexOf('<span class="orphan-join">') < 0) {
            html = html.replace(/<[^>]*?>/g, (match) =>
              match.replace(/ /g, "\u03A9\u03A9"),
            );
            var splitHtml = html.split(" "),
              lastItem = splitHtml.pop();
            if (
              theme.measureTextInsideElement(
                splitHtml[splitHtml.length - 1].replace(/<[^>]*?>/g, "") +
                  " " +
                  lastItem.replace(/<[^>]*?>/g, ""),
                element,
              ).width > element.clientWidth
            )
              return;
            (html =
              splitHtml.join(" ") +
              '<span class="orphan-join"> </span>' +
              lastItem),
              (html = html.replace(/ΩΩ/g, " ")),
              (element.innerHTML = html);
          }
        }
      }
    }),
    (theme.stickyHeaderHeight = function () {
      var v = getComputedStyle(document.documentElement).getPropertyValue(
        "--theme-sticky-header-height",
      );
      return (v && parseInt(v)) || 0;
    }),
    (theme.getOffsetTopFromDoc = (el) =>
      el ? theme.getOffsetTopFromDoc(el.offsetParent) + el.offsetTop : 0),
    (theme.getScrollParent = function (node) {
      var isElement = node instanceof HTMLElement,
        overflowY = isElement && window.getComputedStyle(node).overflowY,
        isScrollable = overflowY !== "visible" && overflowY !== "hidden";
      if (node) {
        if (isScrollable && node.scrollHeight > node.clientHeight) return node;
      } else return null;
      return (
        theme.getScrollParent(node.parentNode) ||
        document.scrollingElement ||
        window
      );
    }),
    (theme.scrollToRevealElement = function (el) {
      var scrollContainer = theme.getScrollParent(el),
        scrollTop =
          scrollContainer === window
            ? window.scrollY
            : scrollContainer.scrollTop,
        scrollVisibleHeight =
          scrollContainer === window
            ? window.innerHeight
            : scrollContainer.clientHeight,
        elTop = theme.getOffsetTopFromDoc(el),
        elBot = elTop + el.offsetHeight,
        inViewTop = scrollTop + theme.stickyHeaderHeight(),
        inViewBot = scrollTop + scrollVisibleHeight - 50;
      (elTop < inViewTop || elBot > inViewBot) &&
        scrollContainer.scrollTo({
          top: elTop - 100 - theme.stickyHeaderHeight(),
          left: 0,
          behavior: "smooth",
        });
    }),
    (theme.getEmptyOptionSelectors = function ($formContainer) {
      var emptySections = [];
      return (
        $formContainer
          .find('[data-selector-type="dropdown"].option-selector')
          .each(function () {
            $(this)
              .find('[aria-selected="true"]')
              .filter(function () {
                return this.dataset && this.dataset.value;
              }).length || emptySections.push(this);
          }),
        $formContainer
          .find('[data-selector-type="listed"].option-selector')
          .each(function () {
            $(this).find("input:checked").length || emptySections.push(this);
          }),
        emptySections
      );
    }),
    (theme.validateProductForm = function ($formContainer) {
      if (
        ($formContainer
          .find(".option-selector--empty")
          .removeClass("option-selector--empty")
          .find(".label__prefix")
          .remove(),
        $formContainer.find(".original-selector").val())
      )
        return !!theme.OptionManager.getCurrentVariantData($formContainer)
          .available;
      var emptySections = theme.getEmptyOptionSelectors($formContainer);
      return (
        emptySections.length &&
          (emptySections.forEach((el) => {
            el.classList.add("option-selector--empty");
            var labelPrefix = document.createElement("span");
            (labelPrefix.innerText =
              theme.strings.products_product_pick_a + " "),
              (labelPrefix.className = "label__prefix"),
              el.querySelector(".label").prepend(labelPrefix);
          }),
          theme.scrollToRevealElement(emptySections[0]),
          $formContainer.addClass("product-form--validation-started")),
        !1
      );
    }),
    (theme.pauseAllMedia = function (params) {
      (!params || params.videos) &&
        (document.querySelectorAll(".js-youtube").forEach((video) => {
          video.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*",
          );
        }),
        document.querySelectorAll(".js-vimeo").forEach((video) => {
          video.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((video) => video.pause())),
        (!params || params.models) &&
          document.querySelectorAll("product-model").forEach((model) => {
            model.modelViewerUI && model.modelViewerUI.pause();
          });
    }),
    (theme.suffixIds = (container2, prefix) => {
      for (
        var suffixCandidates = [
            "id",
            "for",
            "aria-describedby",
            "aria-controls",
          ],
          _loop = function (i2) {
            container2
              .querySelectorAll("[".concat(suffixCandidates[i2], "]"))
              .forEach((el) =>
                el.setAttribute(
                  suffixCandidates[i2],
                  el.getAttribute(suffixCandidates[i2]) + prefix,
                ),
              );
          },
          i = 0;
        i < suffixCandidates.length;
        i++
      )
        _loop(i);
    }),
    (theme.addDelegateEventListener = function (
      element,
      eventName,
      selector,
      callback,
    ) {
      var addEventListenerParams =
          arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null,
        cb = (evt) => {
          var el = evt.target.closest(selector);
          el && element.contains(el) && callback.call(el, evt, el);
        };
      element.addEventListener(eventName, cb, addEventListenerParams);
    }),
    (theme.hideAndRemove = (el) => {
      el.querySelectorAll("input").forEach((el2) => (el2.disabled = !0));
      var wrapper = document.createElement("div");
      (wrapper.className = "merge-remove-wrapper"),
        el.parentNode.insertBefore(wrapper, el),
        wrapper.appendChild(el),
        el.classList.add("merge-remove-item"),
        (wrapper.style.height = wrapper.clientHeight + "px");
      var cs = getComputedStyle(el),
        fadeDuration = parseFloat(cs.getPropertyValue("--fade-duration")) * 1e3,
        slideDuration =
          parseFloat(cs.getPropertyValue("--slide-duration")) * 1e3;
      setTimeout(() => {
        wrapper.classList.add("merge-remove-wrapper--fade"),
          setTimeout(() => {
            wrapper.classList.add("merge-remove-wrapper--slide"),
              setTimeout(() => wrapper.remove(), slideDuration);
          }, fadeDuration);
      }, 10);
    }),
    (theme.insertAndReveal = (el, target, iaeCmd, delay) => {
      var initialDelay = delay || 10;
      el.classList.add("merge-add-wrapper"),
        target.insertAdjacentElement(iaeCmd, el),
        (el.style.height = el.firstElementChild.clientHeight + "px");
      var cs = getComputedStyle(el),
        fadeDuration = parseFloat(cs.getPropertyValue("--fade-duration")) * 1e3,
        slideDuration =
          parseFloat(cs.getPropertyValue("--slide-duration")) * 1e3;
      setTimeout(() => {
        el.classList.add("merge-add-wrapper--slide"),
          setTimeout(() => {
            el.classList.add("merge-add-wrapper--fade"),
              setTimeout(() => {
                (el.style.height = ""),
                  el.classList.remove(
                    "merge-add-wrapper",
                    "merge-add-wrapper--slide",
                    "merge-add-wrapper--fade",
                  );
              }, fadeDuration);
          }, slideDuration);
      }, initialDelay);
    }),
    (theme.mergeNodes = (newContent, targetContainer) => {
      try {
        newContent.querySelectorAll("[data-merge]").forEach((newEl) => {
          var targetEl = targetContainer.querySelector(
            '[data-merge="'.concat(newEl.dataset.merge, '"]'),
          );
          (!newEl.dataset.mergeCache ||
            !targetEl.dataset.mergeCache ||
            newEl.dataset.mergeCache !== targetEl.dataset.mergeCache) &&
            ((targetEl.innerHTML = newEl.innerHTML),
            (targetEl.dataset.mergeCache = newEl.dataset.mergeCache));
        }),
          newContent
            .querySelectorAll("[data-merge-attributes]")
            .forEach((newEl) => {
              var targetEl = targetContainer.querySelector(
                '[data-merge-attributes="'.concat(
                  newEl.dataset.mergeAttributes,
                  '"]',
                ),
              );
              for (var attr of newEl.attributes)
                targetEl.setAttribute(attr.localName, attr.value);
            }),
          newContent
            .querySelectorAll("[data-merge-list]")
            .forEach((newList) => {
              var targetList = targetContainer.querySelector(
                  '[data-merge-list="'.concat(newList.dataset.mergeList, '"]'),
                ),
                targetListItems = Array.from(
                  targetList.querySelectorAll("[data-merge-list-item]"),
                ),
                newListItems = Array.from(
                  newList.querySelectorAll("[data-merge-list-item]"),
                );
              targetListItems.forEach((targetListItem) => {
                var matchedItem = newListItems.find(
                  (item) =>
                    item.dataset.mergeListItem ==
                    targetListItem.dataset.mergeListItem,
                );
                matchedItem || theme.hideAndRemove(targetListItem);
              }),
                (targetListItems = Array.from(
                  targetList.querySelectorAll(
                    "[data-merge-list-item]:not(.merge-remove-item)",
                  ),
                ));
              for (
                var _loop2 = function () {
                    var newListItem = newListItems[i],
                      matchedItem = targetListItems.find(
                        (item) =>
                          item.dataset.mergeListItem ==
                          newListItem.dataset.mergeListItem,
                      );
                    matchedItem
                      ? (!newListItem.dataset.mergeCache ||
                          !matchedItem.dataset.mergeCache ||
                          newListItem.dataset.mergeCache !==
                            matchedItem.dataset.mergeCache) &&
                        ((matchedItem.innerHTML = newListItem.innerHTML),
                        newListItem.dataset.mergeCache &&
                          (matchedItem.dataset.mergeCache =
                            newListItem.dataset.mergeCache))
                      : (i === 0
                          ? theme.insertAndReveal(
                              newListItem,
                              targetList,
                              "afterbegin",
                              500,
                            )
                          : i >= targetListItems.length
                            ? theme.insertAndReveal(
                                newListItem,
                                targetList,
                                "beforeend",
                                500,
                              )
                            : theme.insertAndReveal(
                                newListItem,
                                targetListItems[i],
                                "beforebegin",
                                500,
                              ),
                        targetListItems.splice(i, 0, newListItem));
                  },
                  i = 0;
                i < newListItems.length;
                i++
              )
                _loop2();
            });
      } catch {
        location.reload();
      }
    }),
    (theme.lazyBGSetWidths = [
      180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450,
      2700, 3e3, 3350, 3750, 4100,
    ]),
    (theme.loadLazyBGSet = function (container2) {
      $("[data-lazy-bgset-src]", container2).each(function () {
        for (
          var srcset = "",
            masterSrc = $(this).data("lazy-bgset-src"),
            aspectRatio = $(this).data("lazy-bgset-aspect-ratio"),
            masterWidth = $(this).data("lazy-bgset-width"),
            masterHeight = Math.round(masterWidth / aspectRatio),
            i = 0;
          i < theme.lazyBGSetWidths.length;
          i++
        ) {
          var thisWidth = theme.lazyBGSetWidths[i];
          masterWidth >= thisWidth &&
            (srcset += ""
              .concat(
                theme.Shopify.formatImage(masterSrc, thisWidth + "x"),
                " ",
              )
              .concat(thisWidth, "w ")
              .concat(Math.round(thisWidth / aspectRatio), "h, "));
        }
        (srcset += ""
          .concat(masterSrc, " ")
          .concat(masterWidth, "w ")
          .concat(masterHeight, "h")),
          $(this)
            .attr("data-bgset", srcset)
            .removeClass("lazyload--manual")
            .addClass("lazyload");
      });
    }),
    (theme.ProductBlockManager = new (function () {
      var _ = this;
      (_.isDesktop = function () {
        return $(window).width() >= 768;
      }),
        (_.loadImages = function (container2) {
          var container2 = container2;
          typeof container2 > "u" && (container2 = $("body")),
            theme.loadLazyBGSet(container2),
            _.isDesktop() &&
              (setTimeout(() => {
                $(
                  ".product-block__image--show-on-hover.product-block__image--inactivated",
                  container2,
                ).each(function () {
                  _.lazyloadImage($(this)),
                    lazySizes.loader.unveil($(this).find(".lazyload")[0]);
                });
              }, 250),
              setTimeout(() => {
                $(
                  ".product-block__image--show-on-hover + .product-block__image--inactivated",
                  container2,
                ).each(function () {
                  _.lazyloadImage($(this));
                });
              }, 1e3)),
            _.monitorImagePagination(container2),
            _.monitorSwatchSelection(container2),
            _.afterImagesResized(container2);
        }),
        (_.unloadImages = function (container2) {
          $(container2).off(".productBlockManager");
        }),
        (_.getImageAt = function ($images, index) {
          return $images[
            ((index % $images.length) + $images.length) % $images.length
          ];
        }),
        (_.lazyloadImage = function ($image, onLoadCB) {
          var $toLoad = $image.filter(".product-block__image--inactivated");
          $toLoad.length
            ? (onLoadCB &&
                $toLoad.on("lazyloaded.themeBlockManager", (evt) => {
                  evt.target === $toLoad.find(".lazyloaded")[0] && onLoadCB(),
                    $(this).off("lazyloaded.themeBlockManager");
                }),
              $toLoad.removeClass("product-block__image--inactivated"))
            : onLoadCB && onLoadCB();
        }),
        (_.incrementActiveImage = function ($images, increment) {
          var index = Math.max(
            $images.filter(".product-block__image--active:first").index(),
            0,
          );
          _.setActiveImage($images, index + increment);
        }),
        (_.setActiveImage = function ($images, index) {
          var $newActive = $(_.getImageAt($images, index));
          _.lazyloadImage($newActive, () => {
            $newActive.addClass("product-block__image--active"),
              $newActive.siblings().removeClass("product-block__image--active");
            var $hoverImage = $(_.getImageAt($images, index + 1)).addClass(
              "product-block__image--show-on-hover",
            );
            $hoverImage
              .siblings()
              .removeClass("product-block__image--show-on-hover"),
              _.lazyloadImage($hoverImage);
          });
          var $dots = $images
            .closest(".image-cont")
            .find(".product-block__image-dot");
          $dots
            .removeClass("product-block__image-dot--active")
            .eq($newActive.index())
            .addClass("product-block__image-dot--active");
        }),
        (_.monitorImagePagination = function (container2) {
          $(".image-cont--with-secondary-image", container2).length &&
            ($(container2).on(
              "click.productBlockManager",
              ".image-page-button",
              function (evt) {
                var $images = $(this)
                  .closest(".product-block")
                  .find(".product-block__image");
                return (
                  _.incrementActiveImage(
                    $images,
                    $(evt.currentTarget).hasClass("image-page-button--next")
                      ? 1
                      : -1,
                  ),
                  $images.each(function () {
                    _.lazyloadImage($(this));
                  }),
                  !1
                );
              },
            ),
            $(".image-cont--with-secondary-image:first", container2).closest(
              ".carousel, .product-list--scrollarea",
            ).length === 0 &&
              ($(container2).on("imageSwiped", ".product-block", function () {
                $(".product-block__image--inactivated", this).length &&
                  setTimeout(
                    function () {
                      $(this)
                        .find(".product-block__image")
                        .each(function () {
                          _.lazyloadImage($(this));
                        });
                    }.bind(this),
                    500,
                  );
              }),
              $(container2).on(
                "touchstart.productBlockManager",
                ".image-cont--with-secondary-image",
                function (evt) {
                  (theme.productBlockTouchTracking = !0),
                    (theme.productBlockTouchStartX = evt.touches[0].clientX),
                    (theme.productBlockTouchStartY = evt.touches[0].clientY);
                  var nextImage = evt.currentTarget.querySelector(
                    ".product-block__image--active + .product-block__image--inactivated",
                  );
                  nextImage && _.lazyloadImage($(nextImage));
                },
              ),
              $(container2).on(
                "touchmove.productBlockManager",
                ".image-cont--with-secondary-image",
                function (evt) {
                  if (
                    theme.productBlockTouchTracking &&
                    Math.abs(
                      evt.touches[0].clientY - theme.productBlockTouchStartY,
                    ) < 30
                  ) {
                    var deltaX =
                      evt.touches[0].clientX - theme.productBlockTouchStartX;
                    if (deltaX > 25) {
                      var $images = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      _.incrementActiveImage($images, -1),
                        (theme.productBlockTouchTracking = !1);
                    } else if (deltaX < -25) {
                      var $images = $(this)
                        .closest(".product-block")
                        .trigger("imageSwiped")
                        .find(".product-block__image");
                      _.incrementActiveImage($images, 1),
                        (theme.productBlockTouchTracking = !1);
                    }
                  }
                },
              ),
              $(container2).on(
                "touchend.productBlockManager",
                ".image-cont--with-secondary-image",
                function (evt) {
                  theme.productBlockTouchTracking = !1;
                },
              )));
        }),
        (_.monitorSwatchSelection = function (container2) {
          $("[data-media].product-block-options__item", container2).length &&
            $(container2).on(
              "mouseenter.productBlockManager click.productBlockManager",
              "[data-media].product-block-options__item",
              function () {
                var $block = $(this).closest(".product-block"),
                  $images = $block.find(".product-block__image"),
                  index = $images
                    .filter(
                      '[data-media-id="' +
                        $(this).data("media") +
                        '"].product-block__image',
                    )
                    .index();
                _.setActiveImage($images, index);
                var optionName = $(this)
                    .closest(".product-block-options")
                    .data("option-name"),
                  optionValue = $(this).data("option-item");
                $block[0]
                  .querySelectorAll(".product-link, .quickbuy-toggle")
                  .forEach((el) => {
                    var url = new URL(el.href),
                      params = new URLSearchParams(url.search);
                    params.set(optionName, optionValue),
                      (el.href = "".concat(url.pathname, "?").concat(params)),
                      (el.rel = "nofollow");
                  });
              },
            );
        }),
        (_.afterImagesResized = function (container2) {
          var container2 = container2;
          typeof container2 > "u" && (container2 = $("body")),
            _.alignProductBlockHeights(container2);
        }),
        (_.alignProductBlockHeights = function (container2) {
          var container2 = container2;
          typeof container2 > "u" && (container2 = $("body")),
            $(".collection-listing .product-list", container2).each(
              function () {
                if (
                  $(window).width() >= 768 ||
                  $(this).closest(".carousel").length > 0
                ) {
                  var tallest = 0;
                  $(this)
                    .find(".product-block .block-inner .block-inner-inner")
                    .each(function () {
                      $(this).height() > tallest &&
                        (tallest = $(this).height());
                    }),
                    $(this)
                      .find(".product-block .block-inner")
                      .css("min-height", tallest);
                } else
                  $(this)
                    .find(".product-block .block-inner")
                    .css("min-height", "");
              },
            );
        });
    })()),
    theme.settings.after_add_to_cart === "notification")
  ) {
    var AddedNotification = class extends HTMLElement {
      connectedCallback() {
        this.dismissOthers(),
          this.setProductTitle(this.dataset.productTitle),
          this.display();
      }
      disconnectedCallback() {
        clearTimeout(this.delayedDismissTimeout);
      }
      dismissOthers() {
        document
          .querySelectorAll(".added-notification")
          .forEach((notification) => {
            notification !== this && notification.dismiss();
          });
      }
      setProductTitle(productTitle) {
        this.querySelector(".added-notification__message-title").innerText =
          productTitle;
      }
      display() {
        if (
          (setTimeout(
            () => this.classList.remove("added-notification--hidden"),
            10,
          ),
          (this.delayedDismissTimeout = setTimeout(
            this.dismiss.bind(this),
            6e3,
          )),
          this.querySelector(".added-notification__close").addEventListener(
            "click",
            this.dismiss.bind(this),
          ),
          theme.settings.cart_type === "drawer")
        ) {
          var cartLinks = this.querySelectorAll(
            '.added-notification__message-text a[href$="/cart"]',
          );
          cartLinks.forEach((el) => {
            el.addEventListener("click", (evt) => {
              evt.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:open-cart-drawer", {
                    bubbles: !0,
                    cancelable: !1,
                  }),
                ),
                this.dismiss();
            });
          });
        }
      }
      dismiss(evt) {
        evt && evt.preventDefault(),
          this.classList.add("added-notification--dismissed"),
          setTimeout(this.remove.bind(this), 2e3);
      }
    };
    window.customElements.define("added-notification", AddedNotification);
  }
  (theme.applyAjaxToProductForm = function ($formContainer) {
    $formContainer.find("form.product-purchase-form").each(function () {
      var $form = $(this);
      $form.on("submit", function (evt) {
        if (!theme.validateProductForm($formContainer)) return !1;
        if (
          theme.settings.after_add_to_cart !== "no-js" &&
          $formContainer.is('[data-ajax-add-to-cart="true"]')
        ) {
          evt.preventDefault();
          var shopifyAjaxAddURL = theme.routes.cart_add_url;
          $form
            .find('button[type="submit"]')
            .attr("disabled", "disabled")
            .each(function () {
              $(this).hasClass("btn--added")
                ? clearTimeout($(this).data("revertAddToCartTextTimeoutID"))
                : $(this).data("previous-value", $(this).html());
            })
            .html(
              '<div class="loading-spinner loading-spinner--in-btn"></div>',
            );
          var formData = new FormData($form[0]);
          formData.append("sections", "cart-drawer"),
            $.post(
              shopifyAjaxAddURL,
              new URLSearchParams(formData).toString(),
              theme.addedToCartHandler.bind($form),
              "json",
            ).fail(function (data) {
              if (
                ($form
                  .find('button[type="submit"]')
                  .removeAttr("disabled")
                  .each(function () {
                    $(this).html($(this).data("previous-value"));
                  }),
                typeof data < "u" && typeof data.status < "u")
              ) {
                var jsonRes = $.parseJSON(data.responseText);
                theme.showQuickPopup(
                  jsonRes.description,
                  $form.find('button[type="submit"]:first'),
                );
              } else
                $formContainer.attr("ajax-add-to-cart", "false"),
                  $form.submit();
            });
        }
      });
    });
  }),
    (theme.addedToCartHandler = function (response) {
      if (theme.settings.after_add_to_cart === "page")
        window.location = theme.routes.cart_url;
      else if (theme.settings.after_add_to_cart === "drawer")
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:cartchanged", {
            bubbles: !0,
            cancelable: !1,
            detail: { openDrawer: !0 },
          }),
        );
      else if (theme.settings.after_add_to_cart === "notification") {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:cartchanged", { bubbles: !0, cancelable: !1 }),
        );
        var notification = document
          .getElementById("AddedNotification")
          .content.firstElementChild.cloneNode(!0);
        notification.dataset.productTitle = response.product_title;
        var notificationContainer = document.querySelector(
          ".pageheader--sticky",
        );
        notificationContainer ||
          (notificationContainer = document.querySelector("body")),
          notificationContainer.appendChild(notification);
      }
      $(this)
        .find('button[type="submit"]')
        .removeAttr("disabled")
        .each(function () {
          ($btn = $(this)),
            $btn
              .addClass("btn--added")
              .text(theme.strings.products_product_added_to_cart),
            clearTimeout($(this).data("revertAddToCartTextTimeoutID")),
            $btn.data(
              "revertAddToCartTextTimeoutID",
              setTimeout(function () {
                $btn
                  .html($btn.data("previous-value"))
                  .removeClass("btn--added");
              }, 3e3),
            );
        });
    }),
    (theme.removeAjaxFromProductForm = function ($formContainer) {
      $formContainer.find("form.product-purchase-form").off("submit");
    });
  var CartForm = class extends HTMLElement {
    connectedCallback() {
      theme.cartNoteMonitor.load($('[name="note"]', this)),
        (this.enableAjaxUpdate = this.dataset.ajaxUpdate),
        this.enableAjaxUpdate &&
          ((this.sectionId = this.dataset.sectionId),
          (this.boundRefresh = (evt) => {
            this.refresh(evt.detail && evt.detail.openDrawer);
          }),
          document.addEventListener("theme:cartchanged", this.boundRefresh),
          theme.addDelegateEventListener(
            this,
            "click",
            ".cart-item__remove",
            (evt) => {
              evt.preventDefault(),
                this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                  to: 0,
                });
            },
          ),
          theme.addDelegateEventListener(
            this,
            "click",
            ".quantity-down",
            (evt) => {
              evt.preventDefault(),
                this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                  decrease: !0,
                });
            },
          ),
          theme.addDelegateEventListener(
            this,
            "click",
            ".quantity-up",
            (evt) => {
              evt.preventDefault(),
                this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                  increase: !0,
                });
            },
          ),
          theme.addDelegateEventListener(
            this,
            "change",
            ".cart-item__quantity-input",
            (evt) => {
              this.adjustItemQuantity(evt.target.closest(".cart-item"), {
                currentValue: !0,
              });
            },
          ));
    }
    disconnectedCallback() {
      theme.cartNoteMonitor.unload($('[name="note"]', this)),
        this.enableAjaxUpdate &&
          document.removeEventListener("theme:cartchanged", this.boundRefresh);
    }
    refresh(openDrawer) {
      this.classList.add("cart-form--refreshing"),
        fetch(
          ""
            .concat(window.Shopify.routes.root, "?section_id=")
            .concat(this.sectionId),
        )
          .then((response) => {
            if (!response.ok)
              throw new Error("HTTP error! Status: ".concat(response.status));
            return response.text();
          })
          .then((response) => {
            var frag = document.createDocumentFragment(),
              newContent = document.createElement("div");
            frag.appendChild(newContent),
              (newContent.innerHTML = response),
              newContent
                .querySelectorAll("[data-cc-animate]")
                .forEach((el) => el.removeAttribute("data-cc-animate")),
              theme.mergeNodes(newContent, this),
              this.classList.remove("cart-form--refreshing"),
              this.querySelectorAll(".merge-item-refreshing").forEach((el) =>
                el.classList.remove("merge-item-refreshing"),
              ),
              theme.cartNoteMonitor.load($('[name="note"]', this)),
              openDrawer &&
                document.dispatchEvent(
                  new CustomEvent("theme:open-cart-drawer", {
                    bubbles: !0,
                    cancelable: !1,
                  }),
                );
          });
    }
    adjustItemQuantity(item, change) {
      var quantityInput = item.querySelector(".cart-item__quantity-input"),
        newQuantity = parseInt(quantityInput.value);
      typeof change.to < "u"
        ? ((newQuantity = change.to), (quantityInput.value = newQuantity))
        : change.increase
          ? ((newQuantity += quantityInput.step || 1),
            (quantityInput.value = newQuantity))
          : change.decrease
            ? ((newQuantity -= quantityInput.step || 1),
              (quantityInput.value = newQuantity))
            : change.currentValue,
        quantityInput.max &&
          parseInt(quantityInput.value) > parseInt(quantityInput.max) &&
          ((newQuantity = quantityInput.max),
          (quantityInput.value = newQuantity),
          theme.showQuickPopup(
            theme.strings.cart_general_quantity_too_high.replace(
              "[QUANTITY]",
              quantityInput.max,
            ),
            $(quantityInput),
          )),
        clearTimeout(this.adjustItemQuantityTimeout),
        (this.adjustItemQuantityTimeout = setTimeout(
          () => {
            var qtys = [];
            this.querySelectorAll(
              ".cart-item__quantity-input:not([disabled])",
            ).forEach((el) => {
              qtys.push(el.value),
                el.value != el.dataset.initialValue &&
                  el
                    .closest("[data-merge-list-item]")
                    .classList.add("merge-item-refreshing");
            }),
              fetch(theme.routes.cart_update_url, {
                method: "POST",
                body: JSON.stringify({ updates: qtys }),
                headers: { "Content-Type": "application/json" },
              }).then((response) => {
                if (!response.ok)
                  throw new Error(
                    "HTTP error! Status: ".concat(response.status),
                  );
                document.dispatchEvent(
                  new CustomEvent("theme:cartchanged", {
                    bubbles: !0,
                    cancelable: !1,
                  }),
                );
              });
          },
          newQuantity === 0 ? 10 : 700,
        ));
    }
  };
  window.customElements.define("cart-form", CartForm);
  var CCCartCrossSell = class extends HTMLElement {
    connectedCallback() {
      setTimeout(this.init.bind(this), 500);
    }
    init() {
      (this.productList = this.querySelector(".product-list")),
        this.dataset.from
          ? fetch(this.dataset.from)
              .then((response) => {
                if (!response.ok)
                  throw new Error(
                    "HTTP error! Status: ".concat(response.status),
                  );
                return response.text();
              })
              .then((response) => {
                var frag = document.createDocumentFragment(),
                  newContent = document.createElement("div");
                frag.appendChild(newContent), (newContent.innerHTML = response);
                var pl = newContent.querySelector(".product-list");
                pl
                  ? ((this.productList.innerHTML = pl.innerHTML),
                    theme.loadCarousels(this))
                  : this.classList.add("hidden");
              })
          : theme.loadCarousels(this);
    }
  };
  window.customElements.define("cc-cart-cross-sell", CCCartCrossSell);
  var CCFetchedContent = class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok)
            throw new Error("HTTP error! Status: ".concat(response.status));
          return response.text();
        })
        .then((response) => {
          var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement("div");
          frag.appendChild(fetchedContent),
            (fetchedContent.innerHTML = response);
          var replacementContent = fetchedContent.querySelector(
            '[data-id="'.concat(CSS.escape(this.dataset.id), '"]'),
          );
          replacementContent &&
            ((this.innerHTML = replacementContent.innerHTML),
            this.hasAttribute("contains-product-blocks") &&
              (theme.loadCarousels(this),
              theme.ProductBlockManager.loadImages(this)));
        });
    }
  };
  window.customElements.define("cc-fetched-content", CCFetchedContent),
    (theme.LoadFilterer = function (section) {
      if (
        ((this.$container = section.$container),
        (this.namespace = section.namespace),
        (this.registerEventListener = section.registerEventListener),
        (this.functions = {
          initFiltersEtc: function () {
            $(".filter-container", this.$container).addClass(
              "filter-container--mobile-initialised",
            ),
              location.href.indexOf("?") >= 0 &&
                $(
                  "#sort-dropdown-options .link-dropdown__link",
                  this.$container,
                ).each(function () {
                  var queryTerms = location.href.split("?")[1].split("&"),
                    newHref = $(this).attr("href");
                  queryTerms.forEach((term) => {
                    term.indexOf("sort_by=") === -1 && (newHref += "&" + term);
                  }),
                    $(this).attr("href", newHref);
                }),
              theme.ProductBlockManager.loadImages(this.$container),
              setTimeout(() => {
                $(".product-form", this.$container).trigger(
                  "load-product-form",
                ),
                  $(".hover-enabled").on({
                    mouseenter: function () {
                      $(this).addClass("active");
                      let temp = $(this).find(".option-selector");
                      temp &&
                        temp.length &&
                        temp.each((index, item) => {
                          $(item).width() <
                            $(item).find(".option-wrapper .carousel-new").get(0)
                              .scrollWidth &&
                            ($(item)
                              .find(".autoscroll-right")
                              .css({ display: "flex" }),
                            $(item).addClass("has-arrows"));
                        });
                    },
                    mouseleave: function () {
                      $(this).removeClass("active");
                    },
                  }),
                  $(".autoscroll-right").on("click", function () {
                    let scrollLeft =
                        -1 *
                        parseInt(
                          $(this)
                            .parent(".option-selector")
                            .find(".carousel-new")
                            .css("margin-left"),
                        ),
                      windowWidth =
                        $(this).parent(".option-selector").width() - 10,
                      maxWidth = $(this)
                        .parent(".option-selector")
                        .find(".option-wrapper .carousel-new")
                        .get(0).scrollWidth;
                    maxWidth <= scrollLeft + 2 * windowWidth
                      ? (scrollLeft += maxWidth - scrollLeft - windowWidth)
                      : (scrollLeft += windowWidth),
                      $(this)
                        .parent()
                        .find(".carousel-new")
                        .animate({ marginLeft: -1 * scrollLeft + "px" }),
                      $(this)
                        .parent()
                        .find(".autoscroll-left")
                        .css({ display: "flex" }),
                      $(this)
                        .parent()
                        .find(".autoscroll-left")
                        .removeClass("disabled"),
                      maxWidth <= scrollLeft + windowWidth &&
                        $(this).addClass("disabled");
                  }),
                  $(".autoscroll-left").on("click", function () {
                    $(this)
                      .parent()
                      .find(".autoscroll-right")
                      .css({ display: "flex" }),
                      $(this)
                        .parent()
                        .find(".autoscroll-right")
                        .removeClass("disabled");
                    let scrollLeft =
                        -1 *
                        parseInt(
                          $(this)
                            .parent(".option-selector")
                            .find(".carousel-new")
                            .css("margin-left"),
                        ),
                      windowWidth =
                        $(this).parent(".option-selector").width() - 10;
                    (scrollLeft -= windowWidth),
                      scrollLeft < 0 &&
                        ((scrollLeft = 0), $(this).addClass("disabled")),
                      $(this)
                        .parent()
                        .find(".carousel-new")
                        .animate({ marginLeft: -1 * scrollLeft + "px" });
                  });
              }, 2e3);
          },
          switchGridLayout: function (evt) {
            evt.preventDefault(),
              $(evt.currentTarget).hasClass("layout-switch--one-column")
                ? this.$container
                    .find(".product-list")
                    .removeClass("product-list--per-row-mob-2")
                    .addClass("product-list--per-row-mob-1")
                : this.$container
                    .find(".product-list")
                    .removeClass("product-list--per-row-mob-1")
                    .addClass("product-list--per-row-mob-2"),
              $(evt.currentTarget)
                .addClass("layout-switch--active")
                .siblings()
                .removeClass("layout-switch--active");
          },
          checkStickyScroll: function () {
            var utilityBarOffsetY = $(".utility-bar").offset().top;
            $(window).width() < 768 &&
            this.previousScrollTop > window.scrollY &&
            window.scrollY > utilityBarOffsetY
              ? $("body").addClass("utility-bar-sticky-mobile-copy-reveal")
              : $("body.utility-bar-sticky-mobile-copy-reveal").removeClass(
                  "utility-bar-sticky-mobile-copy-reveal",
                ),
              (this.previousScrollTop = window.scrollY);
          },
          ajaxLoadLink: function (evt) {
            evt.preventDefault(),
              this.functions.ajaxLoadUrl.call(
                this,
                $(evt.currentTarget).attr("href"),
              );
          },
          ajaxLoadForm: function (evt) {
            evt.type === "submit" && evt.preventDefault();
            var queryVals = [];
            evt.currentTarget
              .querySelectorAll("input, select")
              .forEach((input) => {
                ((input.type !== "checkbox" && input.type !== "radio") ||
                  input.checked) &&
                  input.value !== "" &&
                  queryVals.push([input.name, encodeURIComponent(input.value)]);
              });
            var newUrl = location.pathname;
            queryVals.forEach((value) => {
              newUrl += "&".concat(value[0], "=").concat(value[1]);
            }),
              (newUrl = newUrl.replace("&", "?")),
              this.functions.ajaxLoadUrl.call(this, newUrl);
          },
          ajaxPopState: function (event) {
            this.functions.ajaxLoadUrl.call(this, document.location.href, !0);
          },
          ajaxLoadUrl: function (url, noPushState) {
            if (!noPushState) {
              var fullUrl = url;
              fullUrl.slice(0, 1) === "/" &&
                (fullUrl =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  fullUrl),
                window.history.pushState({ path: fullUrl }, "", fullUrl);
            }
            this.$container[0].dataset.filterSectionId &&
              (url +=
                (url.indexOf("?") >= 0 ? "&" : "?") +
                "section_id=".concat(
                  this.$container[0].dataset.filterSectionId,
                ));
            var refreshContainerSelector = "[data-ajax-container]",
              $ajaxContainers = this.$container.find(refreshContainerSelector);
            $ajaxContainers.addClass("ajax-loading"),
              this.currentAjaxLoadUrlFetch &&
                this.currentAjaxLoadUrlFetch.abort(),
              (this.currentAjaxLoadUrlFetch = $.get(
                url,
                function (data) {
                  (this.currentAjaxLoadUrlFetch = null),
                    document.activeElement &&
                      (this.activeElementId = document.activeElement.id),
                    theme.ProductBlockManager.unloadImages(this.$container);
                  var scrollContainer =
                      this.$container[0].querySelector(".filters"),
                    elAboveScrollTopData = null;
                  if (getComputedStyle(scrollContainer).overflow === "auto") {
                    for (
                      var allFilterChildren =
                          scrollContainer.querySelectorAll(".filters *"),
                        elAboveScrollTop = allFilterChildren[0],
                        i = 1;
                      i < allFilterChildren.length;
                      i++
                    )
                      if (allFilterChildren[i].offsetTop)
                        if (
                          allFilterChildren[i].offsetTop <
                          scrollContainer.scrollTop
                        )
                          allFilterChildren[i].offsetTop >
                            elAboveScrollTop.offsetTop &&
                            (elAboveScrollTop = allFilterChildren[i]);
                        else break;
                    if (elAboveScrollTop.offsetTop === 0) elAboveScrollTop = !1;
                    else {
                      elAboveScrollTopData = {
                        selector: "",
                        textContent: elAboveScrollTop.textContent,
                        extraScrollOffset:
                          scrollContainer.scrollTop -
                          elAboveScrollTop.offsetTop,
                      };
                      for (var attrName of elAboveScrollTop.getAttributeNames())
                        attrName === "class"
                          ? Array.from(elAboveScrollTop.classList)
                              .filter(
                                (a) => a !== "filter-group__item--disabled",
                              )
                              .forEach((cl) => {
                                elAboveScrollTopData.selector += "." + cl;
                              })
                          : (elAboveScrollTopData.selector += "["
                              .concat(attrName, '="')
                              .concat(
                                CSS.escape(
                                  elAboveScrollTop.getAttribute(attrName),
                                ),
                                '"]',
                              ));
                    }
                  }
                  var $newAjaxContainers = $(
                    "<div>".concat(data, "</div>"),
                  ).find(refreshContainerSelector);
                  $newAjaxContainers.each(function (index) {
                    $($ajaxContainers[index]).html($(this).html());
                  }),
                    this.functions.initFiltersEtc.call(this),
                    elAboveScrollTopData &&
                      this.$container[0]
                        .querySelectorAll(elAboveScrollTopData.selector)
                        .forEach((el2) => {
                          el2.textContent ===
                            elAboveScrollTopData.textContent &&
                            (scrollContainer.scrollTop =
                              el2.offsetTop +
                              elAboveScrollTopData.extraScrollOffset);
                        });
                  var $componentHaver =
                    this.$container.closest("[data-components]");
                  if ($componentHaver.length) {
                    var components = $componentHaver
                      .data("components")
                      .split(",");
                    components.forEach(
                      function (component) {
                        $(document).trigger("cc:component:load", [
                          component,
                          $componentHaver[0],
                        ]);
                      }.bind(this),
                    );
                  }
                  if (
                    ($ajaxContainers.removeClass("ajax-loading"),
                    theme.initAnimateOnScroll(),
                    this.activeElementId)
                  ) {
                    var el = document.getElementById(this.activeElementId);
                    el && el.focus();
                  }
                  var scrollToY =
                    $("[data-ajax-scroll-to]:first", this.$container).offset()
                      .top - $(".section-header").height();
                  window.scrollTo({ top: scrollToY, behavior: "smooth" });
                }.bind(this),
              ));
          },
        }),
        (this.allowAutoApplyHideUnavailable = this.$container
          .find(".filters")
          .data("auto-apply-hide-unavailable")),
        this.allowAutoApplyHideUnavailable &&
          (this.$container.on(
            "change" + this.namespace,
            ".filter-group__checkbox, .cc-price-range__input",
            (evt) => {
              if (
                this.allowAutoApplyHideUnavailable &&
                ((evt.currentTarget.type === "checkbox" &&
                  evt.currentTarget.checked) ||
                  (evt.currentTarget.type === "text" &&
                    evt.currentTarget.value))
              ) {
                var toEnable = this.$container.find(
                  '[name="filter.v.availability"][value="1"]',
                )[0];
                toEnable &&
                  ((toEnable.checked = !0),
                  toEnable.dispatchEvent(
                    new CustomEvent("change", { bubbles: !0, cancelable: !1 }),
                  ));
              }
            },
          ),
          this.$container.on(
            "change" + this.namespace,
            ".filter-group--availability .filter-toggle__input",
            (evt) => {
              evt.currentTarget.checked &&
                evt.currentTarget.value == "1" &&
                (this.allowAutoApplyHideUnavailable = !1);
            },
          )),
        this.$container.data("ajax-filtering")
          ? (this.$container.on(
              "click" + this.namespace,
              ".link-dropdown__link, .filter-group__applied-item, .filter-group__clear-link, .pagination a",
              this.functions.ajaxLoadLink.bind(this),
            ),
            this.$container.on(
              "change" + this.namespace + " submit" + this.namespace,
              "#CollectionFilterForm",
              theme.debounce(this.functions.ajaxLoadForm.bind(this), 700),
            ),
            this.registerEventListener(
              window,
              "popstate",
              this.functions.ajaxPopState.bind(this),
            ))
          : this.$container.on(
              "change" + this.namespace,
              "#CollectionFilterForm",
              function () {
                $(this).submit();
              },
            ),
        this.$container.on(
          "click" + this.namespace,
          ".link-dropdown__button",
          theme.toggleLinkDropdownButton.bind(this),
        ),
        $(document).on("click" + this.namespace, function () {
          $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
        }),
        document.querySelector(".utility-bar"))
      ) {
        var $utilBarClone = $(".utility-bar")
          .clone()
          .addClass("utility-bar--sticky-mobile-copy")
          .removeAttr("data-ajax-container")
          .insertAfter(".utility-bar");
        theme.suffixIds($utilBarClone[0], "dupe"),
          (this.previousScrollTop = window.scrollY),
          $(window).on(
            "throttled-scroll" + this.namespace,
            this.functions.checkStickyScroll.bind(this),
          ),
          this.$container.on(
            "click" + this.namespace,
            "[data-toggle-filters]",
            function (evt) {
              var isNowVisible = $(".filter-container", this.$container)
                .toggleClass(
                  "filter-container--show-filters-desktop filter-container--show-filters-mobile",
                )
                .hasClass("filter-container--show-filters-desktop");
              return (
                $(
                  ".toggle-btn[data-toggle-filters]",
                  this.$container,
                ).toggleClass("toggle-btn--revealed-desktop", isNowVisible),
                theme.ProductBlockManager.afterImagesResized(),
                $(".slick-slider", this.$container).each(function () {
                  $(this).slick("setPosition");
                }),
                !1
              );
            }.bind(this),
          ),
          this.$container.on(
            "click" + this.namespace,
            ".layout-switch",
            this.functions.switchGridLayout.bind(this),
          );
      }
      this.functions.initFiltersEtc.call(this),
        (this.destroy = function () {
          theme.ProductBlockManager.unloadImages(this.$container),
            theme.destroyProductGallery(this.$container),
            this.$container.off(this.namespace),
            $(window).off(this.namespace),
            $(document).off(this.namespace);
        }.bind(this));
    }),
    (theme.buildGalleryViewer = function (config) {
      for (
        var $allContainer = $(
            '<div class="gallery-viewer gallery-viewer--pre-reveal">',
          ),
          $zoomContainer = $(
            '<div class="gallery-viewer__zoom-container">',
          ).appendTo($allContainer),
          $thumbContainer = $('<div class="gallery-viewer__thumbs">').appendTo(
            $allContainer,
          ),
          $controlsContainer = $(
            '<div class="gallery-viewer__controls">',
          ).appendTo($allContainer),
          $close = $(
            '<a class="gallery-viewer__button gallery-viewer__close" href="#">',
          )
            .html(config.close)
            .appendTo($controlsContainer),
          $right = $(
            '<a class="gallery-viewer__button gallery-viewer__prev" href="#">',
          )
            .html(config.prev)
            .appendTo($controlsContainer),
          $left = $(
            '<a class="gallery-viewer__button gallery-viewer__next" href="#">',
          )
            .html(config.next)
            .appendTo($controlsContainer),
          $currentZoomImage = null,
          wheelZoomMultiplier = -0.001,
          pinchZoomMultiplier = 0.003,
          touchPanModifier = 1,
          currentTransform = { panX: 0, panY: 0, zoom: 1 },
          i = 0;
        i < config.images.length;
        i++
      ) {
        var img = config.images[i];
        $('<a class="gallery-viewer__thumb" href="#">')
          .data("zoom-url", img.zoomUrl)
          .html(img.thumbTag)
          .appendTo($thumbContainer);
      }
      config.images.length === 1 &&
        $allContainer.addClass("gallery-viewer--single-image");
      var panZoomImageFromCoordinate = function (inputX, inputY) {
          var doPanX = $currentZoomImage.width() > $allContainer.width(),
            doPanY = $currentZoomImage.height() > $allContainer.height();
          if (doPanX || doPanY) {
            var midX = $allContainer.width() / 2,
              midY = $allContainer.height() / 2,
              offsetFromCentreX = inputX - midX,
              offsetFromCentreY = inputY - midY,
              finalOffsetX = 0,
              finalOffsetY = 0;
            if (doPanX) {
              var offsetMultiplierX =
                ($currentZoomImage.width() - $allContainer.width()) / 2 / midX;
              finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX);
            }
            if (doPanY) {
              var offsetMultiplierY =
                ($currentZoomImage.height() - $allContainer.height()) /
                2 /
                midY;
              finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY);
            }
            (currentTransform.panX = finalOffsetX),
              (currentTransform.panY = finalOffsetY),
              alterCurrentPanBy(0, 0),
              updateImagePosition();
          }
        },
        alterCurrentPanBy = function (x, y) {
          currentTransform.panX += x;
          var panXMax =
            ($currentZoomImage[0].naturalWidth * currentTransform.zoom -
              $allContainer.width()) /
            2;
          (panXMax = Math.max(panXMax, 0)),
            (currentTransform.panX = Math.min(currentTransform.panX, panXMax)),
            (currentTransform.panX = Math.max(currentTransform.panX, -panXMax)),
            (currentTransform.panY += y);
          var panYMax =
            ($currentZoomImage[0].naturalHeight * currentTransform.zoom -
              $allContainer.height()) /
            2;
          (panYMax = Math.max(panYMax, 0)),
            (currentTransform.panY = Math.min(currentTransform.panY, panYMax)),
            (currentTransform.panY = Math.max(currentTransform.panY, -panYMax)),
            updateImagePosition();
        },
        setCurrentTransform = function (panX, panY, zoom) {
          (currentTransform.panX = panX),
            (currentTransform.panY = panY),
            (currentTransform.zoom = zoom),
            alterCurrentTransformZoomBy(0);
        },
        alterCurrentTransformZoomBy = function (delta) {
          currentTransform.zoom += delta;
          var maxZoomX =
              $allContainer.width() / $currentZoomImage[0].naturalWidth,
            maxZoomY =
              $allContainer.height() / $currentZoomImage[0].naturalHeight;
          (currentTransform.zoom = Math.max(
            currentTransform.zoom,
            Math.min(maxZoomX, maxZoomY),
          )),
            (currentTransform.zoom = Math.min(currentTransform.zoom, 1)),
            alterCurrentPanBy(0, 0),
            updateImagePosition();
        },
        updateImagePosition = function () {
          $currentZoomImage.css(
            "transform",
            "translate3d("
              .concat(currentTransform.panX, "px, ")
              .concat(currentTransform.panY, "px, 0) scale(")
              .concat(currentTransform.zoom, ")"),
          );
        };
      $allContainer.on(
        "click.galleryViewer select.galleryViewer",
        ".gallery-viewer__thumb",
        function (evt) {
          evt.preventDefault(),
            $(this)
              .addClass("gallery-viewer__thumb--active")
              .siblings(".gallery-viewer__thumb--active")
              .removeClass("gallery-viewer__thumb--active"),
            $zoomContainer.addClass("gallery-viewer__zoom-container--loading"),
            ($currentZoomImage = $(
              '<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">',
            )),
            $currentZoomImage
              .on("load", function () {
                $(this)
                  .parent()
                  .removeClass("gallery-viewer__zoom-container--loading"),
                  $(this).off("load"),
                  $(this).css({
                    visibility: "",
                    top: $allContainer.height() / 2 - $(this).height() / 2,
                    left: $allContainer.width() / 2 - $(this).width() / 2,
                  }),
                  setCurrentTransform(0, 0, 0);
              })
              .attr("src", $(this).data("zoom-url")),
            $zoomContainer.html($currentZoomImage);
        },
      );
      var pinchTracking = { isTracking: !1, lastPinchDistance: 0 },
        touchTracking = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 };
      $allContainer.on("touchend.galleryViewer", function (evt) {
        (pinchTracking.isTracking = !1), (touchTracking.isTracking = !1);
      }),
        $allContainer.on(
          "mousemove.galleryViewer touchmove.galleryViewer",
          function (evt) {
            if (
              (evt.preventDefault(),
              evt.type === "touchmove" && evt.touches.length > 0)
            ) {
              var touch1 = evt.touches[0];
              if (
                (touchTracking.isTracking
                  ? (alterCurrentPanBy(
                      (touch1.clientX - touchTracking.lastTouchX) *
                        touchPanModifier,
                      (touch1.clientY - touchTracking.lastTouchY) *
                        touchPanModifier,
                    ),
                    (touchTracking.lastTouchX = touch1.clientX),
                    (touchTracking.lastTouchY = touch1.clientY))
                  : ((touchTracking.isTracking = !0),
                    (touchTracking.lastTouchX = touch1.clientX),
                    (touchTracking.lastTouchY = touch1.clientY)),
                evt.touches.length === 2)
              ) {
                var touch2 = evt.touches[1],
                  pinchDistance = Math.sqrt(
                    Math.pow(touch1.clientX - touch2.clientX, 2) +
                      Math.pow(touch1.clientY - touch2.clientY, 2),
                  );
                if (!pinchTracking.isTracking)
                  (pinchTracking.lastPinchDistance = pinchDistance),
                    (pinchTracking.isTracking = !0);
                else {
                  var pinchDelta =
                    pinchDistance - pinchTracking.lastPinchDistance;
                  alterCurrentTransformZoomBy(pinchDelta * pinchZoomMultiplier),
                    (pinchTracking.lastPinchDistance = pinchDistance);
                }
              } else pinchTracking.isTracking = !1;
            } else panZoomImageFromCoordinate(evt.clientX, evt.clientY);
          },
        ),
        $allContainer.on("wheel.galleryViewer", function (evt) {
          evt.preventDefault(),
            evt.originalEvent.deltaY != 0 &&
              alterCurrentTransformZoomBy(
                evt.originalEvent.deltaY * wheelZoomMultiplier,
              );
        }),
        $allContainer.on(
          "touchmove.galleryViewer",
          ".gallery-viewer__thumbs",
          function (evt) {
            evt.stopPropagation();
          },
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__next",
          function (evt) {
            evt.preventDefault();
            var $next = $thumbContainer
              .find(".gallery-viewer__thumb--active")
              .next();
            $next.length === 0 &&
              ($next = $thumbContainer.find(".gallery-viewer__thumb:first")),
              $next.trigger("select");
          },
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__prev",
          function (evt) {
            evt.preventDefault();
            var $prev = $thumbContainer
              .find(".gallery-viewer__thumb--active")
              .prev();
            $prev.length === 0 &&
              ($prev = $thumbContainer.find(".gallery-viewer__thumb:last")),
              $prev.trigger("select");
          },
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__close",
          function (evt) {
            evt.preventDefault(), theme.galleryViewerFunctions.close();
          },
        ),
        document.addEventListener(
          "keyup",
          theme.galleryViewerFunctions.onDocumentKeyup,
        ),
        $allContainer.on(
          "click.galleryViewer",
          ".gallery-viewer__zoom-container",
          function (evt) {
            evt.preventDefault(),
              currentTransform.zoom == 1
                ? ((currentTransform.zoom = 0), alterCurrentTransformZoomBy(0))
                : ((currentTransform.zoom = 1),
                  alterCurrentTransformZoomBy(0),
                  panZoomImageFromCoordinate(evt.clientX, evt.clientY));
          },
        ),
        $("html").removeClass("gallery-viewer-open"),
        $(".gallery-viewer").remove(),
        $("html").addClass("gallery-viewer-open"),
        $allContainer.appendTo("body");
      var currentIndex = 0;
      config.currentImage &&
        config.images.forEach((img2, index) => {
          config.currentImage === img2.zoomUrl && (currentIndex = index);
        });
      var $focusThumb = $thumbContainer
        .find(".gallery-viewer__thumb:eq(" + currentIndex + ")")
        .trigger("select");
      config.images.length > 1 ? $focusThumb.focus() : $close.focus(),
        setTimeout(function () {
          $allContainer.removeClass("gallery-viewer--pre-reveal");
        }, 10);
    }),
    (theme.galleryViewerFunctions = {
      close: function () {
        var $galleryViewer = $(".gallery-viewer");
        $galleryViewer.off(".galleryViewer"),
          document.removeEventListener(
            "keyup",
            theme.galleryViewerFunctions.onDocumentKeyup,
          ),
          $galleryViewer.addClass("gallery-viewer--transition-out");
        var transitionDelay = $galleryViewer.css("transition-duration");
        (transitionDelay =
          transitionDelay.indexOf("ms") > -1
            ? parseFloat(transitionDelay)
            : parseFloat(transitionDelay) * 1e3),
          setTimeout(function () {
            $galleryViewer.remove(),
              $("html").removeClass("gallery-viewer-open");
          }, transitionDelay);
      },
      onDocumentKeyup: function (evt) {
        switch (evt.key) {
          case "Escape":
            theme.galleryViewerFunctions.close();
            break;
          case "ArrowLeft":
            $(".gallery-viewer__prev").trigger("click");
            break;
          case "ArrowRight":
            $(".gallery-viewer__next").trigger("click");
            break;
        }
      },
    }),
    (theme.Navigation = {
      init: function (options) {
        if (options.nav.length != 0) {
          var $nav = options.nav,
            navHoverDelay = 250,
            $navLastOpenDropdown = $(),
            navOpenTimeoutId = -1,
            $mobileDrawer = $(options.mobileNavHtml),
            $mobileDrawerFooter = $(
              '<div class="mobile-navigation-drawer__footer">',
            ).appendTo($mobileDrawer);
          $mobileDrawerFooter.append(
            $(".announcement-bar .inline-menu")
              .clone()
              .removeClass("desktop-only"),
          ),
            $mobileDrawerFooter.append(
              $(".announcement-bar .header-disclosures")
                .clone()
                .removeClass("desktop-only"),
            );
          var mobileSocialLinks = $(".announcement-bar .social-links")
              .clone()
              .removeClass("desktop-only")[0],
            mobileSocialLinksCustomIconToSwap = document.querySelector(
              ".announcement-bar .js-replacement-custom-icon",
            );
          mobileSocialLinksCustomIconToSwap &&
            (mobileSocialLinks.querySelector(
              ".social-custom",
            ).parentElement.innerHTML =
              mobileSocialLinksCustomIconToSwap.content.firstElementChild.cloneNode(
                !0,
              ).innerHTML),
            $mobileDrawerFooter.append(mobileSocialLinks),
            theme.suffixIds($mobileDrawer[0], "MobileNav"),
            $mobileDrawer.insertAfter($("#shopify-section-header")),
            $mobileDrawer.on(
              "click",
              ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
              function (evt) {
                evt.preventDefault(),
                  $(this)
                    .parent()
                    .addClass("navigation__item--open")
                    .closest(".mobile-navigation-drawer")
                    .addClass("mobile-navigation-drawer--child-open")
                    .find(".mobile-nav-title")
                    .text(
                      $(this)
                        .siblings(".navigation__link:not(.navigation_image)")
                        .first()
                        .text(),
                    ),
                  $(this)
                    .parent()
                    .closest(".mobile-navigation-drawer")
                    .find(".mobile-nav-title")
                    .attr(
                      "onclick",
                      "window.location.href='" +
                        $(this)
                          .siblings(".navigation__link:not(.navigation_image)")
                          .attr("href") +
                        "'",
                    ),
                  $(this)
                    .siblings(".navigation__tier-2-container")
                    .css({
                      top:
                        Math.ceil(
                          $(".navigation__mobile-header:last").height() + 1,
                        ) + "px",
                    }),
                  this.closest(".mobile-navigation-drawer").scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
              },
            ),
            $mobileDrawer.data("mobile-expand-with-entire-link") &&
              $mobileDrawer.on(
                "click",
                ".navigation__item--with-children > .navigation__link",
                function (evt) {
                  evt.preventDefault(),
                    $(this)
                      .siblings(".navigation__children-toggle")
                      .trigger("click");
                },
              ),
            $mobileDrawer.on("click", ".mobile-nav-back", function (evt) {
              evt.preventDefault(),
                $(this)
                  .closest(".mobile-navigation-drawer")
                  .removeClass("mobile-navigation-drawer--child-open")
                  .find(".navigation__tier-1 > .navigation__item--open")
                  .removeClass("navigation__item--open");
            }),
            $mobileDrawer.on(
              "click",
              ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
              function (evt) {
                evt.preventDefault();
                var doOpen = !$(this)
                  .parent()
                  .hasClass("navigation__item--open");
                if (doOpen) {
                  $(this).parent().addClass("navigation__item--open");
                  var $childContainer = $(this).siblings(
                    ".navigation__tier-3-container",
                  );
                  $childContainer.css(
                    "height",
                    $childContainer.children().outerHeight(),
                  );
                } else
                  $(this).parent().removeClass("navigation__item--open"),
                    $(this)
                      .siblings(".navigation__tier-3-container")
                      .css("height", "");
              },
            ),
            $nav
              .find(".lazyload--manual")
              .removeClass("lazyload--manual")
              .addClass("lazyload"),
            $nav.on(
              "mouseenter mouseleave",
              ".navigation__tier-1 > .navigation__item--with-children",
              function (evt, data) {
                var $dropdownContainer = $(this);
                if (evt.type == "mouseenter") {
                  clearTimeout(navOpenTimeoutId),
                    clearTimeout($dropdownContainer.data("navCloseTimeoutId"));
                  var $openSiblings = $dropdownContainer.siblings(
                    ".navigation__item--show-children",
                  );
                  $openSiblings
                    .not($navLastOpenDropdown)
                    .removeClass("navigation__item--show-children"),
                    ($navLastOpenDropdown = $dropdownContainer);
                  var timeoutDelay =
                      $openSiblings.length == 0 ? 0 : navHoverDelay,
                    newNavOpenTimeoutId = setTimeout(function () {
                      $dropdownContainer
                        .addClass("navigation__item--show-children")
                        .siblings(".navigation__item--show-children")
                        .removeClass("navigation__item--show-children"),
                        $dropdownContainer
                          .closest(".section-header")
                          .addClass("section-header--nav-open");
                    }, timeoutDelay);
                  (navOpenTimeoutId = newNavOpenTimeoutId),
                    $dropdownContainer.data(
                      "navOpenTimeoutId",
                      newNavOpenTimeoutId,
                    );
                } else
                  clearTimeout($dropdownContainer.data("navOpenTimeoutId")),
                    $dropdownContainer.data(
                      "navCloseTimeoutId",
                      setTimeout(function () {
                        $dropdownContainer.removeClass(
                          "navigation__item--show-children",
                        ),
                          $dropdownContainer
                            .closest(".section-header")
                            .removeClass("section-header--nav-open");
                      }, navHoverDelay),
                    );
                $dropdownContainer
                  .children("[aria-expanded]")
                  .attr("aria-expanded", evt.type == "mouseenter");
              },
            );
          var touchHandler = function (evt) {
            if ($(window).width() > 767) {
              if (evt.type == "touchstart")
                $(this).data("touchstartedAt", evt.timeStamp);
              else if (evt.type == "touchend") {
                if (evt.timeStamp - $(this).data("touchstartedAt") < 1e3)
                  return (
                    $(this).data("touchOpenTriggeredAt", evt.timeStamp),
                    $(this).parent().hasClass("navigation__item--show-children")
                      ? $(this).parent().trigger("mouseleave")
                      : ($(
                          ".navigation:first .navigation__item--show-children",
                        ).trigger("mouseleave"),
                        $(this).parent().trigger("mouseenter")),
                    !1
                  );
              } else if (
                evt.type == "click" &&
                $(this).data("touchOpenTriggeredAt") &&
                evt.timeStamp - $(this).data("touchOpenTriggeredAt") < 1e3
              )
                return !1;
            }
          };
          $nav.on(
            "touchstart touchend click",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
            touchHandler,
          );
          var keydownHandler = function (evt) {
            if (evt.which == 13) {
              var $parent = $(this).parent();
              return (
                $parent.trigger(
                  $parent.hasClass("navigation__item--show-children")
                    ? "mouseleave"
                    : "mouseenter",
                ),
                !1
              );
            }
          };
          $nav.on(
            "keydown",
            ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
            keydownHandler,
          ),
            options.proxyTier1Nav &&
              ($(options.proxyTier1Nav).on(
                "mouseenter touchstart",
                ".navigation__item--with-small-menu",
                function (evt) {
                  var $dropdown = $(
                    $(".navigation__tier-1 > .navigation__item", $nav)[
                      $(this).index()
                    ],
                  ).find(".navigation__tier-2-container");
                  document.querySelector("html[dir=rtl]")
                    ? $dropdown.css(
                        "right",
                        $dropdown[0].offsetParent.clientWidth -
                          ($(this).offset().left + this.clientWidth),
                      )
                    : $dropdown.css("left", $(this).offset().left);
                },
              ),
              $(options.proxyTier1Nav)
                .on(
                  "mouseenter mouseleave",
                  ".navigation__tier-1 > .navigation__item--with-children",
                  function (evt) {
                    $(
                      $(".navigation__tier-1 > .navigation__item", $nav)[
                        $(this).index()
                      ],
                    ).trigger(evt.type);
                  },
                )
                .on(
                  "touchstart touchend click",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
                  function (evt) {
                    var response = touchHandler.call(
                      $(
                        $(".navigation__tier-1 > .navigation__item", $nav)[
                          $(this).parent().index()
                        ],
                      ).children(".navigation__link")[0],
                      evt,
                    );
                    if (response === !1) return !1;
                  },
                )
                .on(
                  "keydown",
                  ".navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle",
                  function (evt) {
                    if (evt.which == 13)
                      return (
                        keydownHandler.call(
                          $(
                            $(".navigation__tier-1 > .navigation__item", $nav)[
                              $(this).parent().index()
                            ],
                          ).children(".navigation__children-toggle")[0],
                          evt,
                        ),
                        !1
                      );
                  },
                )),
            $nav.on(
              "click",
              '.navigation__link[href="#"][aria-haspopup="true"]',
              function () {
                return (
                  $(this)
                    .siblings(".navigation__children-toggle")
                    .trigger("click"),
                  !1
                );
              },
            ),
            $nav[0].addEventListener("mouseenter", theme.Navigation.onNavHover),
            $nav[0].addEventListener("mouseleave", theme.Navigation.onNavHover),
            options.proxyTier1Nav.length &&
              (options.proxyTier1Nav[0].addEventListener(
                "mouseenter",
                theme.Navigation.onNavHover,
              ),
              options.proxyTier1Nav[0].addEventListener(
                "mouseleave",
                theme.Navigation.onNavHover,
              ));
        }
      },
      onNavHover: function (evt) {
        $(evt.target)
          .closest(".section-header")
          .toggleClass("section-header--nav-hover", evt.type === "mouseenter");
      },
      destroy: function ($nav, $proxyTier1Nav) {
        $nav
          .add($proxyTier1Nav)
          .off("click mouseenter mouseleave touchstart touchend keydown"),
          theme.ProductBlockManager.unloadImages(
            $(".mobile-navigation-drawer .product-list"),
          ),
          $(".mobile-navigation-drawer").off("click").remove();
      },
    }),
    (theme.initProductGallery = function (container2) {
      var $gallery = $(".gallery", container2);
      if (!$gallery.hasClass("gallery-initialised")) {
        if (
          ($gallery.addClass("gallery-initialised"),
          $gallery.data("variant-image-grouping") &&
            $gallery.data("variant-image-grouping-option-index") !== "")
        ) {
          var productData = theme.OptionManager.getProductData(
              $gallery.closest(".product-detail").find(".product-form"),
            ),
            groupingOptionIndex = $gallery.data(
              "variant-image-grouping-option-index",
            ),
            optionNameMediaMap = {};
          productData.media.forEach((media) => {
            productData.variants.forEach((variant) => {
              variant.featured_media &&
                variant.featured_media.id == media.id &&
                (optionNameMediaMap[variant.options[groupingOptionIndex]] ||
                  (optionNameMediaMap[variant.options[groupingOptionIndex]] =
                    media.id));
            });
          });
          var currentMediaOptionName = "";
          $gallery.find(".slide").each(function (index, item) {
            for (var optionName in optionNameMediaMap)
              $(item).data("media-id") == optionNameMediaMap[optionName] &&
                (currentMediaOptionName = optionName);
            $(item).attr("data-variant-image-group", currentMediaOptionName);
          }),
            (currentMediaOptionName = ""),
            $gallery.find(".thumbnail").each(function (index, item) {
              for (var optionName in optionNameMediaMap)
                $(item).data("media-id") == optionNameMediaMap[optionName] &&
                  (currentMediaOptionName = optionName);
              $(item).attr("data-variant-image-group", currentMediaOptionName);
            });
        }
        var $slideshow = $(".product-slideshow", container2);
        if ($slideshow.length) {
          var slickConfig = {
            autoplay: !1,
            fade: !1,
            infinite: !1,
            useTransform: !0,
            dots: !1,
            arrows: !1,
            waitForAnimate: !1,
            appendArrows: $slideshow
              .siblings(".slideshow-controls")
              .find(".slideshow-controls__arrows"),
            prevArrow:
              '<button type="button" class="slick-product-prev" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="slick-product-next" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            mobileFirst: !0,
            rtl: !!document.querySelector("html[dir=rtl]"),
            responsive: [
              { breakpoint: 768, settings: { fade: !0, arrows: !0 } },
            ],
          };
          if (
            ($slideshow
              .on("init", function (evt, slick) {
                $(".lazyload--manual", this)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload");
              })
              .on("beforeChange", function (evt, slick, current, next) {
                var mediaId = $(slick.$slides[next]).data("media-id");
                $(
                  $(this)
                    .closest(".gallery")
                    .find(
                      '.thumbnails:not(.hidden) .thumbnail[data-media-id="' +
                        mediaId +
                        '"]',
                    ),
                ).trigger("selectFromSlick");
              }),
            $slideshow.closest(
              ".gallery--layout-carousel-beside, .gallery--layout-carousel-under",
            ).length)
          )
            $slideshow.slick(slickConfig);
          else {
            var enforceMobileSlideshow = function () {
              $(window).width() < 768
                ? $slideshow.not(".slick-slider").each(function () {
                    $(this)
                      .find(".slide--inactive-option")
                      .removeClass("slide--inactive-option"),
                      $(this).slick(slickConfig),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  })
                : $slideshow.filter(".slick-slider").each(function () {
                    $(this).slick("slickUnfilter").slick("unslick"),
                      $(this)
                        .closest(".product-detail")
                        .find(".original-selector")
                        .trigger("change");
                  });
            };
            enforceMobileSlideshow(),
              $(window).on(
                "debouncedresize.productGallery",
                enforceMobileSlideshow,
              );
          }
          theme.ProductMedia.init($gallery, {
            onYoutubeInit: function (playerObj) {
              $slideshow.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide,
                );
            },
            onModelViewerInit: function (element) {
              $slideshow.hasClass("slick-slider") &&
                theme.productGallerySlideshowTabFix(
                  $slideshow.slick("getSlick").$slides,
                  $slideshow.slick("getSlick").currentSlide,
                );
            },
            onVideoVisible: function (e) {
              $(window).width() >= 768 &&
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "swipe", !1);
            },
            onModelViewerPlay: function (e) {
              $(e.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !1),
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !1);
            },
            onModelViewerPause: function (e) {
              $(e.target)
                .closest(".slick-slider")
                .slick("slickSetOption", "swipe", !0),
                $(e.target)
                  .closest(".slick-slider")
                  .slick("slickSetOption", "accessibility", !0);
            },
          }),
            $slideshow.hasClass("slick-slider") &&
              theme.productGallerySlideshowTabFix(
                $slideshow.slick("getSlick").$slides,
                $slideshow.slick("getSlick").currentSlide,
              ),
            $slideshow.on("afterChange", function (evt, slick, current) {
              theme.pauseAllMedia(),
                $(window).width() >= 768 && slick.slickSetOption("swipe", !0),
                $(".product-media", slick.$slides[current]).trigger(
                  "mediaVisible",
                ),
                theme.productGallerySlideshowTabFix(slick.$slides, current);
            });
        }
        var $thumbnails = $(".thumbnails:not(.hidden)", container2);
        if ($thumbnails.length) {
          var carouselVisibleItemCount = 6,
            isCarousel = !1,
            assessCarousel = function () {
              $thumbnails.parent().css("display") == "flex"
                ? isCarousel &&
                  ((isCarousel = !1),
                  theme.beforeCarouselUnloadEventBlockFix($thumbnails),
                  $thumbnails
                    .removeClass("owl-carousel")
                    .data("owl.carousel")
                    .destroy(),
                  $gallery
                    .closest(".product-detail")
                    .find(".original-selector")
                    .trigger("change"))
                : isCarousel ||
                  ((isCarousel = !0),
                  theme.beforeCarouselLoadEventBlockFix($thumbnails),
                  $thumbnails.find(".thumbnail").show(),
                  $gallery
                    .find(".hidden-thumbnails")
                    .children()
                    .appendTo($thumbnails),
                  $thumbnails
                    .addClass("owl-carousel")
                    .on("initialized.owl.carousel", function () {
                      $(".lazyload--manual", this)
                        .removeClass("lazyload--manual")
                        .addClass("lazyload");
                    })
                    .owlCarousel({
                      items: carouselVisibleItemCount,
                      dots: !1,
                      margin: 7,
                      rtl: !!document.querySelector("html[dir=rtl]"),
                    }),
                  $gallery
                    .closest(".product-detail")
                    .find(".original-selector")
                    .trigger("change"));
            };
          $(window).on("debouncedresize.productGallery", assessCarousel),
            assessCarousel(),
            $(container2).data("assessCarouselCallback", assessCarousel),
            $(".gallery", container2).on(
              "click select selectFromSlick",
              ".thumbnails.owl-carousel .thumbnail",
              function (e) {
                e.preventDefault();
                var $carouselItem = $(this).parent();
                if (e.type != "selectFromSlick") {
                  var mediaId = $(this).data("media-id"),
                    _$slideshow = $(this)
                      .closest(".gallery")
                      .find(".slideshow.slick-slider");
                  if (_$slideshow) {
                    var index = _$slideshow
                        .find('.slide[data-media-id="' + mediaId + '"]')
                        .index(),
                      slick = _$slideshow.slick("getSlick");
                    slick.currentSlide === index
                      ? $(this).trigger("selectFromSlick")
                      : _$slideshow.slick("slickGoTo", index);
                  }
                } else {
                  $(this)
                    .addClass("selected")
                    .parent()
                    .siblings()
                    .find("a")
                    .removeClass("selected");
                  var shelfStart = $carouselItem
                      .parent()
                      .children(".active:first")
                      .index(),
                    shelfEnd = shelfStart + carouselVisibleItemCount - 1,
                    currentIndex = $carouselItem.index();
                  currentIndex < shelfStart
                    ? $carouselItem
                        .closest(".owl-carousel")
                        .trigger("to.owl.carousel", currentIndex)
                    : currentIndex > shelfEnd &&
                      $carouselItem
                        .closest(".owl-carousel")
                        .trigger(
                          "to.owl.carousel",
                          Math.max(
                            0,
                            currentIndex - carouselVisibleItemCount + 1,
                          ),
                        );
                }
              },
            ),
            $(".gallery", container2).on(
              "click select selectFromSlick",
              " .thumbnails:not(.owl-carousel) .thumbnail",
              function (e) {
                if ((e.preventDefault(), e.type != "selectFromSlick")) {
                  var index = 0,
                    mediaId = $(this).data("media-id");
                  $(this)
                    .parent()
                    .children(":visible")
                    .each(function (iter) {
                      if (((index = iter), $(this).data("media-id") == mediaId))
                        return !1;
                    });
                  var _$slideshow2 = $(this)
                      .closest(".gallery")
                      .find(".slideshow"),
                    slick = _$slideshow2.slick("getSlick");
                  slick.currentSlide === index
                    ? $(this).trigger("selectFromSlick")
                    : _$slideshow2.slick("slickGoTo", index);
                } else
                  $(this)
                    .addClass("selected")
                    .siblings(".selected")
                    .removeClass("selected");
              },
            );
        }
      }
    }),
    (theme.destroyProductGallery = function (container2) {
      $(window).off(".productGallery");
      var $gallery = $(".gallery", container2).off(
        "click select selectFromSlick",
      );
      theme.ProductMedia.destroy($gallery),
        $(".slick-slider", container2)
          .slick("unslick")
          .off("init beforeChange afterChange"),
        $(".owl-carousel", container2).each(function () {
          theme.beforeCarouselUnloadEventBlockFix(this),
            $(this).data("owl.carousel").destroy();
        });
    }),
    (theme.ProductMedia = new (function () {
      var _ = this;
      (_._setupShopifyXr = function () {
        if (!window.ShopifyXR) {
          document.addEventListener(
            "shopify_xr_initialized",
            _._setupShopifyXr.bind(this),
          );
          return;
        }
        window.ShopifyXR.addModels(JSON.parse($(this).html())),
          window.ShopifyXR.setupXRElements();
      }),
        (this.init = function (container2, callbacks) {
          var callbacks = callbacks || {},
            _container = container2;
          $(container2)
            .find(".product-media--video")
            .each(function (index) {
              var poster = this.querySelector(".product-media__poster");
              $(".product-media__video-play-btn", poster).on(
                "click",
                function () {
                  $(this)
                    .closest(".product-media--video")
                    .data("player")
                    .play();
                },
              );
              var playerObj = { container: this, poster };
              playerObj.play = function () {
                theme.pauseAllMedia(),
                  this.poster.classList.add("product-media__poster--hide"),
                  $(this).closest(".slick-slider").slick("setPosition"),
                  this.container
                    .querySelectorAll(".js-youtube")
                    .forEach((video) => {
                      video.contentWindow.postMessage(
                        '{"event":"command","func":"playVideo","args":""}',
                        "*",
                      );
                    }),
                  this.container
                    .querySelectorAll(".js-vimeo")
                    .forEach((video) => {
                      video.contentWindow.postMessage('{"method":"play"}', "*");
                    }),
                  this.container
                    .querySelectorAll("video")
                    .forEach((video) => video.play());
              }.bind(playerObj);
              var template = this.querySelector(
                ".product-media__video-template",
              );
              template &&
                (this.insertAdjacentHTML("beforeend", template.innerHTML),
                this.removeChild(template),
                (this.style.paddingBottom =
                  100 /
                    this.querySelector("video, iframe").getAttribute(
                      "aspect-ratio",
                    ) +
                  "%")),
                $(this)
                  .data("player", playerObj)
                  .addClass("product-media--video-loaded");
            }),
            $(container2).on(
              "mediaVisible",
              ".product-media--video-loaded, .product-media--model-loaded",
              function () {
                $(window).width() >= 768 && $(this).data("player").play(),
                  $(this).hasClass("product-media--model") &&
                    $(".view-in-space", _container).attr(
                      "data-shopify-model3d-id",
                      $(this).data("model-id"),
                    );
              },
            ),
            callbacks.onVideoVisible &&
              $(container2).on(
                "mediaVisible",
                ".product-media--video-loaded",
                callbacks.onVideoVisible,
              ),
            $("model-viewer", container2).each(function () {
              callbacks.onModelViewerPlay &&
                $(this).on(
                  "shopify_model_viewer_ui_toggle_play",
                  callbacks.onModelViewerPlay,
                ),
                callbacks.onModelViewerPause &&
                  $(this).on(
                    "shopify_model_viewer_ui_toggle_pause",
                    callbacks.onModelViewerPause,
                  );
            }),
            $(container2).on(
              "mediaVisible mediaVisibleInitial",
              ".product-media--model:not(.product-media--model-loaded)",
              function (e) {
                var element = $(this).find("model-viewer")[0],
                  autoplay = e.type != "mediaVisibleInitial";
                theme.loadStyleOnce(
                  "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                ),
                  window.Shopify.loadFeatures([
                    {
                      name: "model-viewer-ui",
                      version: "1.0",
                      onLoad: function () {
                        $(this).data(
                          "player",
                          new Shopify.ModelViewerUI(element),
                        ),
                          $(this).addClass("product-media--model-loaded"),
                          callbacks.onModelViewerInit &&
                            callbacks.onModelViewerInit(element),
                          autoplay && $(this).trigger("mediaVisible");
                      }.bind(this),
                    },
                  ]);
              },
            ),
            $(".model-json", container2).length &&
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: _._setupShopifyXr.bind($(".model-json", container2)),
                },
              ]),
            $(document).on("shopify_xr_launch", function () {
              theme.pauseAllMedia({ videos: !0 });
            }),
            setTimeout(
              function () {
                $(".product-slideshow.slick-slider .product-media:first", this)
                  .filter(".product-media--model")
                  .trigger("mediaVisibleInitial"),
                  $(
                    ".product-slideshow:not(.slick-slider) .product-media--model",
                    this,
                  ).trigger("mediaVisibleInitial");
              }.bind(container2),
              50,
            );
        }),
        (this.destroy = function (container2) {
          $(document).off("shopify_xr_launch"),
            $(container2).off("mediaVisible mediaVisibleInitial"),
            $(".product-media--model-loaded", container2).each(function () {
              $(this).data("player").destroy();
            }),
            $(".product-media--video video", container2).off(
              "playing pause ended",
            ),
            $("model-viewer", container2).off(
              "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause",
            );
        });
    })()),
    (theme.productGallerySlideshowTabFix = function (slides, current) {
      $(slides[current])
        .find(
          "a, input, button, select, iframe, video, model-viewer, [tabindex]",
        )
        .each(function () {
          typeof $(this).data("theme-slideshow-original-tabindex") < "u"
            ? $(this).data("theme-slideshow-original-tabindex") === !1
              ? $(this).removeAttr("tabindex")
              : $(this).attr(
                  "tabindex",
                  $(this).data("theme-slideshow-original-tabindex"),
                )
            : $(this).removeAttr("tabindex");
        }),
        $(slides)
          .not(slides[current])
          .find(
            "a, input, button, select, iframe, video, model-viewer, [tabindex]",
          )
          .each(function () {
            typeof $(this).data("theme-slideshow-original-tabindex") > "u" &&
              ($(this).data(
                "theme-slideshow-original-tabindex",
                typeof $(this).attr("tabindex") < "u"
                  ? $(this).attr("tabindex")
                  : !1,
              ),
              $(this).attr("tabindex", "-1"));
          });
    }),
    (theme.productData = {}),
    (theme.OptionManager = new (function () {
      var _ = this;
      (_._getVariantOptionElement = function (variant, $container) {
        return $container.find(
          'select[name="id"] option[value="' +
            (variant ? variant.id : "") +
            '"]',
        );
      }),
        (_.selectors = {
          container: ".product-detail",
          gallery: ".gallery",
          priceArea: ".price-area",
          variantIdInputs: '[name="id"]',
          purchaseForm: ".product-purchase-form",
          primaryVariantIdInput: '.product-purchase-form [name="id"]',
          submitButton: '.product-purchase-form button[type="submit"]',
          multiOption: ".option-selectors",
          customOption: ".custom-option",
          installmentsFormSuffix: "-installments",
        }),
        (_.strings = {
          buttonDefault: theme.strings.products_product_add_to_cart,
          buttonNoStock: theme.strings.products_variant_no_stock,
          buttonNoVariant: theme.strings.products_variant_non_existent,
        }),
        (_.getProductData = function ($form) {
          var productId = $form.data("product-id"),
            data = null;
          return (
            theme.productData[productId] ||
              (theme.productData[productId] = JSON.parse(
                document.getElementById("ProductJson-" + productId).innerHTML,
              )),
            (data = theme.productData[productId]),
            data ||
              console.log(
                "Product data missing (id: " + $form.data("product-id") + ")",
              ),
            data
          );
        }),
        (_.getVariantFromId = function ($productForm, id) {
          for (
            var variants = this.getProductData($productForm).variants, i = 0;
            i < variants.length;
            i++
          )
            if (variants[i].id == id) return variants[i];
          return { available: !1 };
        }),
        (_.getCurrentVariantData = function ($productForm) {
          return _.getVariantFromId(
            $productForm,
            $productForm.find(_.selectors.primaryVariantIdInput).val(),
          );
        }),
        (_.getBaseUnit = function (variant) {
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }),
        (_.addVariantUrlToHistory = function (variant) {
          if (variant) {
            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              variant.id;
            window.history.replaceState({ path: newurl }, "", newurl);
          }
        }),
        (_.updateSku = function (variant, $container) {
          $container.find(".sku .sku__value").html(variant ? variant.sku : ""),
            $container
              .find(".sku")
              .toggleClass("sku--no-sku", !variant || !variant.sku);
        }),
        (_.updateBarcode = function (variant, $container) {
          $container
            .find(".barcode .barcode__value")
            .html(variant ? variant.barcode : ""),
            $container
              .find(".barcode")
              .toggleClass("barcode--no-barcode", !variant || !variant.barcode);
        }),
        (_.updateTransferNotice = function (variant, $container) {
          var transferData = _._getVariantOptionElement(
            variant,
            $container,
          ).data("inventory-transfer");
          transferData
            ? $container
                .find(".product-inventory-transfer")
                .removeClass("product-inventory-transfer--none")
                .html(transferData)
            : $container
                .find(".product-inventory-transfer")
                .addClass("product-inventory-transfer--none")
                .empty();
        }),
        (_.updateVariantDeterminedVisibilityAreas = function (
          variant,
          $container,
        ) {
          $container.find(".variant-visibility-area").each(function () {
            $(this).children(":not(script)").remove(),
              variant
                ? $(this).append(
                    $(this)
                      .children('script[data-variant-id="' + variant.id + '"]')
                      .html(),
                  )
                : $(this).append(
                    $(this).children('script[data-variant-id=""]').html(),
                  );
          });
        }),
        (_.updateBackorder = function (variant, $container) {
          var $backorder = $container.find(".backorder");
          if ($backorder.length)
            if (variant && variant.available)
              if (
                variant.inventory_management &&
                _._getVariantOptionElement(variant, $container).data("stock") ==
                  "out"
              ) {
                var productData = _.getProductData(
                  $backorder.closest(".product-form"),
                );
                $backorder
                  .find(".backorder__variant")
                  .text(
                    productData.title +
                      (variant.title.indexOf("Default") >= 0
                        ? ""
                        : " - " + variant.title),
                  ),
                  $backorder.show();
              } else $backorder.hide();
            else $backorder.hide();
        }),
        (_._updateButtonText = function ($button, string, variant) {
          $button.each(function () {
            var newVal;
            (newVal = _.strings["button" + string]),
              newVal !== !1 &&
                ($(this).is("input")
                  ? $(this).val(newVal)
                  : $(this).html(newVal));
          });
        }),
        (_.updateButtons = function (variant, $container) {
          var $button = $container.find(_.selectors.submitButton);
          if (
            ($container.hasClass("product-upsell__product-detail") ||
              ($button = $button.filter(
                ":not(.product-upsell__product-atc-button)",
              )),
            variant)
          )
            $button.removeAttr("disabled").removeClass("button--sold-out"),
              variant.available == !0
                ? _._updateButtonText($button, "Default", variant)
                : ($button.addClass("button--sold-out"),
                  _._updateButtonText($button, "NoStock", variant));
          else {
            var productData = _.getProductData(
              $button.closest(".product-form"),
            );
            productData.available
              ? theme.getEmptyOptionSelectors($container).length
                ? ($button.removeAttr("disabled"),
                  _._updateButtonText($button, "Default", variant))
                : ($button.attr("disabled", "disabled"),
                  _._updateButtonText($button, "NoVariant", variant))
              : ($button.addClass("button--sold-out"),
                _._updateButtonText($button, "NoStock", variant));
          }
        }),
        (_.updateContainerStatusClasses = function (variant, $container) {
          $container.toggleClass("variant-status--not-selected", !variant),
            $container.toggleClass(
              "variant-status--unavailable",
              variant && !variant.available,
            ),
            $container.toggleClass(
              "variant-status--backorder",
              variant &&
                variant.available &&
                variant.inventory_management &&
                _._getVariantOptionElement(variant, $container).data("stock") ==
                  "out",
            ),
            $container.toggleClass(
              "variant-status--on-sale",
              variant &&
                variant.available &&
                variant.compare_at_price > variant.price,
            );
        }),
        (_.initProductOptions = function ($productForm) {
          if (!$productForm.hasClass("theme-init")) {
            var productData = _.getProductData($productForm);
            $productForm.addClass("theme-init"),
              $productForm
                .find(_.selectors.multiOption)
                .on("change.themeProductOptions", function () {
                  var selectedOptions = [];
                  $(this)
                    .find(".option-selector")
                    .each(function () {
                      $(this).data("selector-type") === "listed"
                        ? selectedOptions.push(
                            $(this).find(".js-option:checked").val(),
                          )
                        : selectedOptions.push(
                            $(this)
                              .find('.js-option[aria-selected="true"]')
                              .data("value"),
                          );
                    });
                  for (
                    var variant = !1, i = 0;
                    i < productData.variants.length;
                    i++
                  ) {
                    for (
                      var v = productData.variants[i], matchCount = 0, j = 0;
                      j < selectedOptions.length;
                      j++
                    )
                      v.options[j] == selectedOptions[j] && matchCount++;
                    if (matchCount == selectedOptions.length) {
                      variant = v;
                      break;
                    }
                  }
                  $productForm
                    .find(_.selectors.variantIdInputs)
                    .val(variant.id),
                    $productForm
                      .find(_.selectors.variantIdInputs)
                      .each(function () {
                        this.dispatchEvent(
                          new CustomEvent("change", {
                            bubbles: !0,
                            cancelable: !1,
                            detail: { variant, selectedOptions },
                          }),
                        );
                      });
                }),
              $productForm
                .find(_.selectors.customOption)
                .each(function () {
                  var $input = $(this).find("input:first, textarea, select");
                  $('<input type="hidden">')
                    .attr({ name: $input.attr("name"), value: $input.val() })
                    .appendTo($productForm.find(_.selectors.purchaseForm));
                })
                .on("change.themeProductOptions", function () {
                  var $radios = $(this).find('input[type="radio"]'),
                    $checkbox = $(this).find('input[type="checkbox"]');
                  if ($radios.length)
                    $productForm
                      .find(_.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === $radios[0].name;
                      })
                      .val($radios.filter(":checked").val())
                      .trigger("change");
                  else if ($checkbox.length) {
                    var val = null;
                    $checkbox.is(":checked")
                      ? (val = $checkbox.val())
                      : (val = $checkbox.siblings('[type="hidden"]').val()),
                      $productForm
                        .find(_.selectors.purchaseForm + " input")
                        .filter(function () {
                          return this.name === $checkbox[0].name;
                        })
                        .val(val)
                        .trigger("change");
                  } else {
                    var $input = $(this).find("select, input, textarea");
                    $productForm
                      .find(_.selectors.purchaseForm + " input")
                      .filter(function () {
                        return this.name === $input.attr("name");
                      })
                      .val($input.val())
                      .trigger("change");
                  }
                }),
              $productForm
                .find(_.selectors.primaryVariantIdInput)
                .each(function () {
                  $(this).on(
                    "change.themeProductOptions firstrun.themeProductOptions",
                    function (e) {
                      if (!$(this).is("input[type=radio]:not(:checked)")) {
                        var variant = e.detail ? e.detail.variant : null;
                        if (!variant && variant !== !1)
                          for (var i = 0; i < productData.variants.length; i++)
                            productData.variants[i].id == $(this).val() &&
                              (variant = productData.variants[i]);
                        var $container = $(this).closest(_.selectors.container),
                          $addToCart = $container
                            .find(_.selectors.submitButton)
                            .filter("[data-add-to-cart-text]");
                        if (
                          ($addToCart.length &&
                            (_.strings.buttonDefault =
                              $addToCart.data("add-to-cart-text")),
                          _.updateButtons(variant, $container),
                          $(window).trigger("cc-variant-updated", {
                            variant,
                            product: productData,
                          }),
                          variant && variant.featured_media)
                        )
                          $container
                            .find(_.selectors.gallery)
                            .trigger("variantImageSelected", [
                              variant,
                              e.type === "firstrun",
                            ]);
                        else if (e.detail && e.detail.selectedOptions) {
                          var matchesRequired = e.detail.selectedOptions.filter(
                            (o) => o && o.length > 0,
                          ).length;
                          if (matchesRequired > 0)
                            for (
                              var i = 0;
                              i < productData.variants.length;
                              i++
                            ) {
                              for (
                                var v = productData.variants[i],
                                  matchCount = 0,
                                  j = 0;
                                j < e.detail.selectedOptions.length;
                                j++
                              )
                                v.options[j] == e.detail.selectedOptions[j] &&
                                  matchCount++;
                              if (
                                matchCount == matchesRequired &&
                                v.featured_media
                              ) {
                                $container
                                  .find(_.selectors.gallery)
                                  .trigger("variantImageSelected", [
                                    v,
                                    e.type === "firstrun",
                                  ]);
                                break;
                              }
                            }
                        }
                        _.updateBarcode(variant, $container),
                          _.updateSku(variant, $container),
                          _.updateTransferNotice(variant, $container),
                          _.updateVariantDeterminedVisibilityAreas(
                            variant,
                            $container,
                          ),
                          _.updateBackorder(variant, $container),
                          _.updateContainerStatusClasses(variant, $container),
                          $productForm.data("enable-history-state") &&
                            e.type == "change" &&
                            _.addVariantUrlToHistory(variant),
                          $productForm.trigger("variantChanged", [
                            variant,
                            productData,
                          ]);
                      }
                    },
                  ),
                    $(this).trigger("firstrun");
                }),
              theme.applyAjaxToProductForm($productForm);
            var searchParams = new URLSearchParams(location.search),
              _loop3 = function (key2) {
                $productForm
                  .find(".option-selector")
                  .filter(function () {
                    return (
                      this.querySelector(".label").firstChild.textContent ===
                      key2
                    );
                  })
                  .each(function () {
                    var value = searchParams.get(key2);
                    this.dataset.selectorType == "dropdown"
                      ? this.querySelector(".cc-select").dispatchEvent(
                          new CustomEvent("selectOption", {
                            detail: { value },
                          }),
                        )
                      : this.querySelectorAll(".opt-label__text").forEach(
                          (el) => {
                            if (el.innerText == value) {
                              var input = document.getElementById(
                                el.parentElement.getAttribute("for"),
                              );
                              input &&
                                ((input.checked = !0),
                                input.dispatchEvent(
                                  new CustomEvent("change", {
                                    bubbles: !0,
                                    cancelable: !1,
                                  }),
                                ));
                            }
                          },
                        );
                  });
              };
            for (var key of searchParams.keys()) _loop3(key);
          }
        }),
        (_.unloadProductOptions = function ($productForm) {
          $productForm.removeClass("theme-init").each(function () {
            $(this).trigger("unloading").off(".themeProductOptions"),
              $(this).find(_.selectors.multiOption).off(".themeProductOptions"),
              $(this)
                .find(_.selectors.customOption)
                .off(".themeProductOptions"),
              theme.removeAjaxFromProductForm($productForm);
          });
        });
    })()),
    (theme.loadQuickbuy = function () {
      function contractDetail($blocks, speed) {
        $blocks.length > 0 &&
          ($blocks.removeClass("expanded"),
          $blocks
            .find(".quickbuy-container")
            .stop()
            .animate({ height: 0 }, speed, function () {
              $(this).find(".inner").empty();
            }),
          $blocks.stop().each(function () {
            $(this).animate({ paddingBottom: 0 }, speed);
          }));
      }
      function loadComponents(componentContainer) {
        $(componentContainer)
          .closest("[data-components]")
          .each(function () {
            $(this)
              .data("components")
              .split(",")
              .forEach((component) => {
                $(document).trigger("cc:component:load", [
                  component,
                  componentContainer,
                ]);
              });
          }),
          $(document).trigger("cc:component:load", [
            "custom-select",
            ".quickbuy-container",
          ]);
      }
      function unloadComponents(componentContainer) {
        $(componentContainer).find(".cc-accordion").off(".qbLoadComponents"),
          $(componentContainer)
            .closest("[data-components]")
            .each(function () {
              $(this)
                .data("components")
                .split(",")
                .forEach((component) => {
                  $(document).trigger("cc:component:unload", [
                    component,
                    componentContainer,
                  ]);
                });
            });
      }
      var debouncedQuickbuyResizeTimeoutID = -1;
      function debouncedQuickbuyResize(qbInner) {
        clearTimeout(debouncedQuickbuyResizeTimeoutID),
          (debouncedQuickbuyResizeTimeoutID = setTimeout(() => {
            var qbc = qbInner.closest(".quickbuy-container"),
              block = qbc.closest(".product-block");
            if (block) {
              if (block.classList.contains("expanded")) {
                var targetHeight = $(qbInner).outerHeight(),
                  expandedSiblings = [...block.parentNode.children].filter(
                    (child) =>
                      child !== block && child.classList.contains("expanded"),
                  ),
                  speed = expandedSiblings.length > 0 ? 0 : droppyDownAnimSpeed;
                $(block)
                  .stop()
                  .animate({ paddingBottom: targetHeight + 20 }, speed),
                  $(qbc).stop().animate({ height: targetHeight }, speed);
              }
            } else
              qbInner.childElementCount > 0 &&
                $(qbc)
                  .stop()
                  .animate(
                    { height: $(qbInner).outerHeight() },
                    droppyDownAnimSpeed,
                  );
          }, 100));
      }
      var quickbuyResizeObserver = null;
      "ResizeObserver" in window
        ? (quickbuyResizeObserver = new ResizeObserver((entries) => {
            for (var entry of entries)
              entry.contentBoxSize && debouncedQuickbuyResize(entry.target);
          }))
        : (quickbuyResizeObserver = {
            disconnect: () => {},
            observer: () => {},
          });
      var droppyDownAnimSpeed = 500;
      $(document).on(
        "click",
        ".product-list .product-block:not(.collection-block):not(.main-search-result) .quickbuy-toggle",
        function () {
          var pageWidth = $(window).width(),
            productUrl = $(this).attr("href");
          if (pageWidth > 767) {
            theme.currentQuickbuyRequest &&
              theme.currentQuickbuyRequest.abort();
            var $block = $(this).closest(".product-block"),
              $detailCont = null,
              $quickbuyCont = null,
              $slider = $(this).closest(".collection-slider"),
              $sliderRow = null;
            if ($slider.length > 0) {
              if (
                (($sliderRow = $slider.closest(".collection-slider-row")),
                $sliderRow.find(".quickbuy-container").length === 0)
              )
                return;
              $quickbuyCont = $sliderRow.find(".quickbuy-container");
            } else $quickbuyCont = $block.find(".quickbuy-container");
            if (
              (($detailCont = $quickbuyCont.find(".inner")),
              $block.toggleClass("expanded").hasClass("expanded"))
            ) {
              if ($slider.length > 0) {
                var noneExpanded =
                  $slider
                    .find(".product-block.expanded")
                    .not($block)
                    .removeClass("expanded").length === 0;
                noneExpanded
                  ? $quickbuyCont.height(0)
                  : ($(".product-form", $quickbuyCont).trigger(
                      "unload-product-form",
                    ),
                    $(".gallery", $quickbuyCont).off(this.namespace),
                    $(".slideshow", $quickbuyCont).slick("unslick"),
                    unloadComponents($quickbuyCont));
              } else {
                var $expandedSiblings = $block.siblings(".expanded");
                $expandedSiblings.each(function () {
                  contractDetail($(this), 0),
                    $(".product-form", this).trigger("unload-product-form"),
                    theme.destroyProductGallery(this),
                    unloadComponents(this);
                });
              }
              quickbuyResizeObserver.disconnect(),
                quickbuyResizeObserver.observe($detailCont[0]),
                $detailCont.html('<div class="loading-spinner"></div>');
              var url = $(this).attr("href");
              (theme.currentQuickbuyRequest = $.get(url, function (response) {
                var $newDetail = $("<div>" + response + "</div>").find(
                  ".quickbuy-content",
                );
                $newDetail.find(".more").attr("href", productUrl),
                  $newDetail
                    .find(".detail .title")
                    .wrapInner($("<a>").attr("href", productUrl)),
                  $newDetail
                    .find(".show-gallery")
                    .removeClass("show-gallery")
                    .attr("href", productUrl),
                  $newDetail.find(".not-in-quickbuy").remove(),
                  $newDetail
                    .find(".only-in-quickbuy")
                    .removeClass("only-in-quickbuy"),
                  $newDetail
                    .find(".sticky-content-container")
                    .removeClass("sticky-content-container"),
                  $newDetail.find(".store-availability-container").remove(),
                  $newDetail
                    .find('[data-enable-history-state="true"]')
                    .attr("data-enable-history-state", "false"),
                  $newDetail
                    .find(".gallery .thumbnails")
                    .removeClass("mobile-only"),
                  [
                    "gallery--layout-carousel-beside",
                    "gallery--layout-columns-1",
                    "gallery--layout-columns-2",
                    "gallery--layout-collage-1",
                    "gallery--layout-collage-2",
                  ].forEach((cl) => {
                    $newDetail
                      .find("." + cl)
                      .removeClass(cl)
                      .addClass("gallery--layout-carousel-under");
                  }),
                  $detailCont.html($newDetail),
                  theme.initProductGallery($quickbuyCont),
                  $quickbuyCont
                    .find(".product-form")
                    .trigger("load-product-form"),
                  loadComponents($quickbuyCont),
                  theme.initAnimateOnScroll();
              }).always(function () {
                theme.currentQuickbuyRequest = !1;
              })),
                $quickbuyCont.find(".close-detail").removeAttr("tabindex");
              var scrollMode = "qb",
                scrollOffset = -120;
              if (
                ($(".section-header").css("position") == "sticky" &&
                  (scrollOffset -= $(".section-header").height()),
                scrollMode == "qb")
              )
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: $quickbuyCont.offset().top + scrollOffset },
                  500,
                );
              else if ($slider.length > 0)
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: $block.offset().top },
                  500,
                );
              else {
                saveCollectionPageData();
                var offsetTop =
                  typeof $block.data("offsetTop") < "u"
                    ? $block.data("offsetTop")
                    : $block.offset().top;
                $("html:not(:animated),body:not(:animated)").animate(
                  { scrollTop: offsetTop + scrollOffset },
                  500,
                );
              }
            } else {
              unloadComponents($quickbuyCont),
                $slider.length > 0
                  ? $quickbuyCont
                      .stop()
                      .animate({ height: 0 }, droppyDownAnimSpeed, function () {
                        $detailCont.empty();
                      })
                  : contractDetail($block, droppyDownAnimSpeed);
              var scrollUpOffset = -140;
              $("html:not(:animated),body:not(:animated)").animate(
                { scrollTop: $block.offset().top + scrollUpOffset },
                500,
              ),
                $quickbuyCont.find(".close-detail").attr("tabindex", "-1");
            }
            return !1;
          }
        },
      ),
        $(document).on(
          "click",
          ".quickbuy-container .close-detail",
          function () {
            var $slider = $(this).closest(".collection-slider-row");
            return (
              $slider.length
                ? $slider
                    .find(".product-block.expanded .quickbuy-toggle:first")
                    .trigger("click")
                : $(this)
                    .closest(".product-block")
                    .find(".quickbuy-toggle:first")
                    .trigger("click"),
              !1
            );
          },
        );
      function saveCollectionPageData() {
        $(".collection-listing").each(function () {
          var $blocks = $(this).find(".product-block");
          if ($blocks.length <= 1) return !0;
          var row = 0,
            currTop = 0,
            blockHeight = Math.min(
              $blocks.first().outerHeight(),
              $($blocks[1]).outerHeight(),
            ),
            blockPageOffset = $blocks.first().offset().top;
          $blocks.each(function (index) {
            var currOffsetTop = $(this).offset().top;
            index == 0
              ? (currTop = currOffsetTop)
              : currOffsetTop > currTop && (row++, (currTop = currOffsetTop)),
              $(this).data({ offsetTop: blockPageOffset + row * blockHeight });
          });
        });
      }
    }),
    $(function () {
      $(document).on("click", ".sharing a", function (e) {
        var $parent = $(this).parent();
        if ($parent.hasClass("twitter")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 575,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Twitter", opts);
        } else if ($parent.hasClass("facebook")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 626,
            height = 256,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Facebook", opts);
        } else if ($parent.hasClass("pinterest")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 700,
            height = 550,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Pinterest", opts);
        } else if ($parent.hasClass("google")) {
          e.preventDefault();
          var url = $(this).attr("href"),
            width = 550,
            height = 450,
            left = ($(window).width() - width) / 2,
            top = ($(window).height() - height) / 2,
            opts =
              "status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,width=" +
              width +
              ",height=" +
              height +
              ",top=" +
              top +
              ",left=" +
              left;
          window.open(url, "Google+", opts);
        }
      });
    });
  var TermsAgreement = class extends HTMLElement {
    connectedCallback() {
      this.delegatedEvent = theme.addDelegateEventListener(
        document,
        "click",
        '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
        this.handleFormSubmittingEvent.bind(this),
      );
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.delegatedEvent);
    }
    handleFormSubmittingEvent(evt) {
      this.querySelector("input:checked") ||
        (evt.preventDefault(),
        theme.showQuickPopup(
          theme.strings.cart_terms_confirmation,
          $(evt.target),
        ));
    }
  };
  window.customElements.define("terms-agreement", TermsAgreement),
    (theme.AnnouncementBarSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.container = container2),
          (this.namespace = theme.namespaceFromSection(container2)),
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          (this.announcements = container2.querySelectorAll(".announcement")),
          this.announcements.length > 1 &&
            ((this.currentAnnouncement = 0),
            container2
              .querySelector(".announcement-bar__middle")
              .addEventListener(
                "focusin",
                this.functions.pauseAnnouncements.bind(this),
              ),
            container2
              .querySelector(".announcement-bar__middle")
              .addEventListener(
                "focusout",
                this.functions.playAnnouncements.bind(this),
              ),
            container2
              .querySelector(".announcement-button--previous")
              .addEventListener(
                "click",
                this.functions.previousAnnouncement.bind(this),
              ),
            container2
              .querySelector(".announcement-button--next")
              .addEventListener(
                "click",
                this.functions.nextAnnouncement.bind(this),
              ),
            (this.observer = new IntersectionObserver(
              this.functions.handleIntersect.bind(this),
            )),
            this.observer.observe(this.container));
      }),
        (this.functions = {
          handleIntersect: function (entries) {
            entries.forEach((entry) => {
              entry.target == this.container &&
                (entry.isIntersecting
                  ? this.functions.playAnnouncements.call(this)
                  : this.functions.pauseAnnouncements.call(this));
            });
          },
          playAnnouncements: function () {
            this.announcementInterval = setInterval(() => {
              this.functions.setCurrentAnnouncement.call(
                this,
                this.currentAnnouncement + 1,
              );
            }, 5e3);
          },
          pauseAnnouncements: function () {
            this.announcementInterval &&
              clearInterval(this.announcementInterval);
          },
          setCurrentAnnouncement: function (newIndex) {
            (this.currentAnnouncement = newIndex % this.announcements.length),
              this.announcements.forEach((el, index) => {
                index !== this.currentAnnouncement
                  ? el.classList.add("announcement--inactive")
                  : el.classList.remove("announcement--inactive");
              });
          },
          previousAnnouncement: function () {
            this.functions.setCurrentAnnouncement.call(
              this,
              this.currentAnnouncement - 1,
            );
          },
          nextAnnouncement: function () {
            this.functions.setCurrentAnnouncement.call(
              this,
              this.currentAnnouncement + 1,
            );
          },
        }),
        (this.onSectionUnload = function (container2) {
          clearInterval(this.announcementInterval),
            $(".disclosure", container2).each(function () {
              $(this).data("disclosure").unload();
            }),
            this.observer && this.observer.disconnect(),
            $(window).off(this.namespace);
        }),
        (this.onBlockSelect = function (block) {
          var index = Array.prototype.indexOf.call(
            block.parentElement.children,
            block,
          );
          this.functions.pauseAnnouncements.call(this),
            this.functions.setCurrentAnnouncement.call(this, index);
        }),
        (this.onBlockDeselect = function (block) {
          this.functions.playAnnouncements.call(this);
        });
    })()),
    (theme.BlogTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          this.$container.on(
            "click" + this.namespace,
            ".link-dropdown__button",
            theme.toggleLinkDropdownButton.bind(this),
          ),
          $(document).on("click" + this.namespace, function () {
            $('.link-dropdown__button[aria-expanded="true"]').trigger("click");
          });
      }),
        (this.onSectionUnload = function (container2) {
          this.$container.off(this.namespace), $(document).off(this.namespace);
        });
    })()),
    (theme.CartTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.$container = $(container2)),
          $(container2).on(
            "click.cartTemplateSection",
            "button[data-toggle-shipping]",
            function () {
              $("#shipping-calculator").toggle();
              var alt = $(this).data("toggle-html");
              return (
                $(this).data("toggle-html", $(this).html()),
                $(this).html(alt),
                !1
              );
            },
          );
      }),
        (this.onSectionUnload = function (container2) {
          $(container2).off(".cartTemplateSection");
        });
    })()),
    (theme.CartDrawerSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.container = container2),
          (this.namespace = theme.namespaceFromSection(container2)),
          (this.popup = new ccPopup(
            $(".cc-popup", container2),
            this.namespace,
          )),
          (this.boundOpen = () => {
            this.popup.open();
          }),
          document.addEventListener("theme:open-cart-drawer", this.boundOpen),
          (this.boundClose = () => this.popup.close()),
          document.addEventListener("theme:close-cart-drawer", this.boundClose),
          container2
            .querySelectorAll(".cc-popup-close")
            .forEach((el) => el.addEventListener("click", this.boundClose)),
          container2
            .querySelector(".cc-popup-background")
            .addEventListener("click", this.boundClose);
      }),
        (this.onSectionSelect = () => {
          document.dispatchEvent(
            new CustomEvent("theme:open-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            }),
          );
        }),
        (this.onSectionDeselect = () => {
          document.dispatchEvent(
            new CustomEvent("theme:close-cart-drawer", {
              bubbles: !0,
              cancelable: !1,
            }),
          );
        }),
        (this.onSectionUnload = function (container2) {
          document.removeEventListener(
            "theme:open-cart-drawer",
            this.boundOpen,
          ),
            document.removeEventListener(
              "theme:close-cart-drawer",
              this.boundClose,
            );
        });
    })()),
    (theme.CollectionTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.filterer = new theme.LoadFilterer(this)),
          $(window).on(
            "debouncedresize" + this.namespace,
            this.functions.truncateButtonSubcollections.bind(this),
          ),
          this.functions.truncateButtonSubcollections.call(this);
        var $subcollectionGallery = $(
          ".subcollection-links--gallery .gallery",
          container2,
        );
        $subcollectionGallery
          .on("init", function () {
            $(".lazyload--manual", this)
              .removeClass("lazyload--manual")
              .addClass("lazyload");
          })
          .slick({
            autoplay: !1,
            fade: !1,
            infinite: !1,
            swipeToSlide: !0,
            slidesToShow: Math.min(
              4,
              $(".subcollection-links--gallery .gallery__item", container2)
                .length,
            ),
            slidesToScroll: 1,
            useTransform: !0,
            arrows: !0,
            dots: !1,
            prevArrow:
              '<button type="button" class="image-page-button image-page-button--previous ltr-icon" aria-label="' +
              theme.strings.previous +
              '">' +
              theme.icons.chevronLeft +
              "</button>",
            nextArrow:
              '<button type="button" class="image-page-button image-page-button--next ltr-icon" aria-label="' +
              theme.strings.next +
              '">' +
              theme.icons.chevronRight +
              "</button>",
            rtl: !!document.querySelector("html[dir=rtl]"),
            responsive: [
              {
                breakpoint: 1e3,
                settings: {
                  slidesToShow: Math.min(
                    3,
                    $(
                      ".subcollection-links--gallery .gallery__item",
                      container2,
                    ).length,
                  ),
                },
              },
              {
                breakpoint: 768,
                settings:
                  $subcollectionGallery.data("mobile-item-count") == "hide"
                    ? "unslick"
                    : {
                        slidesToShow:
                          $subcollectionGallery.data("mobile-item-count"),
                      },
              },
            ],
          });
      }),
        (this.onSectionUnload = function (container2) {
          this.filterer.destroy(),
            $(".subcollection-links__expander", this.$container).off("click"),
            $(".slick-slider", container2).slick("unslick").off("init"),
            $(window).off(this.namespace);
        }),
        (this.functions = {
          truncateButtonSubcollections: function () {
            var $subcollections = $(
              ".subcollection-links--buttons",
              this.$container,
            );
            if ($subcollections.css("display") == "flex") {
              var limit = 4,
                $btns = $subcollections.find(".btn");
              $btns.length > limit &&
                $subcollections.find(".subcollection-links__expander")
                  .length === 0 &&
                ($btns.slice(limit - 1).hide(),
                $(
                  '<a href="#" class="btn btn--tertiary subcollection-links__expander">',
                )
                  .text(
                    theme.strings.collections_general_see_all_subcollections,
                  )
                  .appendTo($subcollections)
                  .on("click", function (evt) {
                    evt.preventDefault(),
                      $(this).siblings().show(),
                      $(this).remove();
                  }));
            } else
              $subcollections.find(".subcollection-links__expander").length &&
                ($subcollections
                  .find(".subcollection-links__expander")
                  .siblings()
                  .show(),
                $subcollections
                  .find(".subcollection-links__expander")
                  .remove());
          },
        });
    })()),
    (theme.CustomRowSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.VideoManager.onSectionLoad(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.VideoManager.onSectionUnload(container2);
        });
    })()),
    (theme.FeaturedCollectionSection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carousels = theme.loadCarousels(container2);
        $carousels.length === 0 &&
          theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.unloadCarousels(container2);
        });
    })()),
    (theme.FeaturedCollectionsSection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carousels = theme.loadCarousels(container2);
        $carousels.length === 0 &&
          theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.unloadCarousels(container2);
        });
    })()),
    (theme.FeaturedProductSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.initProductGallery(container2),
          $(".product-form", container2).trigger("load-product-form"),
          theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.destroyProductGallery(container2),
            $(".product-form", container2).trigger("unload-product-form"),
            $(".slideshow", container2).slick("unslick");
        });
    })()),
    (theme.FooterSection = new (function () {
      (this.onSectionLoad = function (container2) {
        $(".disclosure", container2).each(function () {
          $(this).data("disclosure", new theme.Disclosure($(this)));
        });
      }),
        (this.onSectionUnload = function (container2) {
          $(".disclosure", container2).each(function () {
            $(this).data("disclosure").unload();
          });
        });
    })()),
    (theme.GallerySection = new (function () {
      (this.onSectionLoad = function (container2) {
        var $carouselGallery = $(".gallery--mobile-carousel", container2);
        if ($carouselGallery.length) {
          var assessCarouselFunction = function () {
            var isCarousel = $carouselGallery.hasClass("slick-slider"),
              shouldShowCarousel = $(window).width() < 768;
            if (
              (shouldShowCarousel ||
                $(".lazyload--manual", $carouselGallery)
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
              isCarousel && !shouldShowCarousel)
            ) {
              $carouselGallery.slick("unslick").off("init"),
                $carouselGallery
                  .find("a, .gallery__item")
                  .removeAttr("tabindex")
                  .removeAttr("role");
              var rowLimit = $carouselGallery.data("grid"),
                $currentRow = null;
              $carouselGallery.find(".gallery__item").each(function (index) {
                index % rowLimit === 0 &&
                  ($currentRow = $('<div class="gallery__row">').appendTo(
                    $carouselGallery,
                  )),
                  $(this).appendTo($currentRow);
              });
            } else
              !isCarousel &&
                shouldShowCarousel &&
                ($carouselGallery
                  .find(".gallery__item")
                  .appendTo($carouselGallery),
                $carouselGallery.find(".gallery__row").remove(),
                $carouselGallery
                  .on("init", function () {
                    $(".lazyload--manual", this)
                      .removeClass("lazyload--manual")
                      .addClass("lazyload");
                  })
                  .slick({
                    autoplay: !1,
                    fade: !1,
                    infinite: !0,
                    useTransform: !0,
                    arrows: !1,
                    dots: !0,
                    customPaging: function (slider, i) {
                      return '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" /><circle class="circle-two" cx="15" cy="15" r="13" /></svg></button>';
                    },
                    rtl: !!document.querySelector("html[dir=rtl]"),
                  }));
          };
          assessCarouselFunction(),
            $(window).on(
              "debouncedresize.themeSection" + container2.id,
              assessCarouselFunction,
            );
        }
        $(".overlay-text__title, .overlay-text__rte", container2).each(
          function () {
            theme.avoidUnecessaryOrphans(this);
          },
        );
      }),
        (this.onSectionUnload = function (container2) {
          $(window).off(".themeSection" + container2.id),
            $(".slick-slider", container2).each(function () {
              $(this).slick("unslick").off("init");
            });
        }),
        (this.onBlockSelect = function (block) {
          var blockSlideIndex = $(block).data("slick-index");
          $(block)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", blockSlideIndex);
            });
        });
    })()),
    (theme.HeaderSection = new (function () {
      (this.onSectionLoad = function (container) {
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".social-links",
          function (e) {
            return !1;
          },
        );
        var searchFocusOutTimeoutId = -1;
        $(container).on(
          "focusin.headerSection focusout.headerSection",
          ".search-box",
          function (e) {
            e.type == "focusin"
              ? (clearTimeout(searchFocusOutTimeoutId),
                $(this).closest(".search-box").addClass("focus"))
              : (clearTimeout(searchFocusOutTimeoutId),
                (searchFocusOutTimeoutId = setTimeout(
                  function () {
                    $(this).closest(".search-box").removeClass("focus");
                  }.bind(this),
                  200,
                )));
          },
        ),
          $(container).on(
            "click.headerSection",
            ".show-search-link, .main-search__close",
            function (e) {
              return (
                $("body").toggleClass("show-search").hasClass("show-search")
                  ? (setTimeout(function () {
                      $(".main-search__input:first").focus();
                    }, 500),
                    $(".main-search__suggestions .lazyload--manual")
                      .removeClass("lazyload--manual")
                      .addClass("lazyload"))
                  : $(".show-search-link:first").focus(),
                !1
              );
            },
          ),
          $(container).on(
            "keyup.headerSection",
            ".main-search__input",
            function (e) {
              e.keyCode == 27 && $(".main-search__close").click();
            },
          );
        var $liveSearchContainer = $(
          '.main-search[data-live-search="true"]',
          container,
        );
        if ($liveSearchContainer.length) {
          var searchTimeoutThrottle = 500,
            searchTimeoutID = -1,
            currReqObj = null,
            resultLimit = 8,
            showPrice = $liveSearchContainer.data("live-search-price"),
            showVendor = $liveSearchContainer.data("live-search-vendor"),
            includeMeta = $liveSearchContainer.data("live-search-meta"),
            perRowMob = $liveSearchContainer.data("per-row-mob");
          $(container).on(
            "keyup.headerSection change.headerSection",
            ".main-search__input",
            function () {
              var $searchContainer = $(".main-search"),
                $resultsBox = $searchContainer.find(".main-search__results"),
                valueToSearch = $(this).val();
              if (
                valueToSearch.length > 2 &&
                valueToSearch != $(this).data("oldval")
              ) {
                $(this).data("oldval", valueToSearch),
                  currReqObj?.abort(),
                  clearTimeout(searchTimeoutID);
                var $form = $(this).closest("form"),
                  linkURL =
                    $form.attr("action") +
                    ($form.attr("action").indexOf("?") > -1 ? "&" : "?") +
                    $form.serialize();
                $searchContainer
                  .removeClass(
                    "main-search--has-results main-search--results-on-multiple-lines main-search--no-results",
                  )
                  .addClass("main-search--loading"),
                  $(".main-search__results-spinner").length === 0 &&
                    $resultsBox.html(
                      '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>',
                    ),
                  (searchTimeoutID = setTimeout(function () {
                    var ajaxUrl, ajaxData;
                    theme.Shopify.features.predictiveSearch
                      ? ((ajaxUrl = theme.routes.predictive_search_url),
                        (ajaxData = {
                          q: valueToSearch,
                          section_id: "predictive-search",
                          resources: {
                            type: $form.find('input[name="type"]').val(),
                            limit: resultLimit,
                            options: {
                              unavailable_products: "last",
                              fields: includeMeta
                                ? "title,product_type,variants.title,vendor,tag,variants.sku"
                                : "title,product_type,variants.title,vendor",
                            },
                          },
                        }))
                      : ((ajaxUrl = linkURL),
                        (ajaxData = { section_id: "main-search" })),
                      (currReqObj = $.ajax({
                        url: ajaxUrl,
                        data: ajaxData,
                        dataType: "html",
                        success: function (response) {
                          var $resultsList = null;
                          theme.Shopify.features.predictiveSearch
                            ? ($resultsList = $(response).find(".product-list"))
                            : ($resultsList = $(
                                "<div>" + response + "</div>",
                              ).find(
                                '[data-section-type="search-template"] .product-list',
                              )),
                            (currReqObj = null),
                            theme.ProductBlockManager.unloadImages($resultsBox),
                            $searchContainer.removeClass(
                              "main-search--has-results main-search--results-on-multiple-lines main-search--no-results",
                            ),
                            $resultsBox.empty();
                          var $resultsProducts = $(
                              '<div class="main-search__results__products collection-listing"><div></div></div>',
                            ),
                            $resultsPages = $(
                              '<div class="main-search__results__pages">',
                            );
                          ($resultsProducts.children()[0].className =
                            $resultsList[0].className),
                            $resultsList
                              .find(
                                ".product-block:not(.collection-block):not(.page-block)",
                              )
                              .slice(0, resultLimit)
                              .addClass("main-search-result")
                              .each(function () {
                                $(this).find(".btn.quickbuy-toggle").remove(),
                                  $(this)
                                    .find(".quickbuy-toggle")
                                    .removeClass("quickbuy-toggle"),
                                  showPrice ||
                                    $(this).find(".product-price").remove(),
                                  showVendor ||
                                    $(this).find(".vendor").remove();
                              })
                              .appendTo($resultsProducts.children()),
                            $resultsList
                              .find(".product-block.page-block")
                              .each(function () {
                                var $item = $(
                                  '<a class="main-search-result main-search-result--page">',
                                ).attr(
                                  "href",
                                  $(this).find("a:first").attr("href"),
                                );
                                $('<div class="main-search-result__text">')
                                  .text(
                                    $(this).find(".page-block__title").text(),
                                  )
                                  .appendTo($item),
                                  $resultsPages.append($item);
                              }),
                            $searchContainer.removeClass(
                              "main-search--loading",
                            );
                          var areProducts =
                              $resultsProducts.find(".main-search-result:first")
                                .length > 0,
                            arePages =
                              $resultsPages.find(".main-search-result:first")
                                .length > 0;
                          areProducts || arePages
                            ? ($searchContainer.addClass(
                                "main-search--has-results",
                              ),
                              $searchContainer.toggleClass(
                                "main-search--results-on-multiple-lines",
                                $resultsProducts.find(".product-block").length >
                                  4,
                              ),
                              areProducts &&
                                ($resultsBox.append($resultsProducts),
                                theme.ProductBlockManager.loadImages(
                                  $resultsProducts,
                                )),
                              arePages &&
                                ($('<h6 class="main-search-result__heading">')
                                  .html(
                                    theme.strings.general_quick_search_pages,
                                  )
                                  .prependTo($resultsPages),
                                $resultsBox.append($resultsPages)),
                              $(
                                '<a class="main-search__results-all-link button altcolour">',
                              )
                                .attr("href", linkURL)
                                .html(theme.strings.layout_live_search_see_all)
                                .appendTo($resultsBox),
                              theme.initAnimateOnScroll())
                            : ($searchContainer.addClass(
                                "main-search--no-results",
                              ),
                              $('<div class="main-search__empty-message">')
                                .html(
                                  theme.strings.general_quick_search_no_results,
                                )
                                .appendTo($resultsBox));
                        },
                        error: function (response) {
                          console.log("Error fetching results");
                        },
                      }));
                  }, searchTimeoutThrottle));
              } else
                $(this).val().length <= 2 &&
                  ($(this).data("oldval", valueToSearch),
                  currReqObj?.abort(),
                  clearTimeout(searchTimeoutID),
                  $searchContainer.removeClass(
                    "main-search--has-results main-search--results-on-multiple-lines main-search--loading",
                  ),
                  $resultsBox.empty());
            },
          );
        }
        theme.Navigation.init({
          nav: $(".navigation--main", container),
          mobileNavHtml: $(
            ".mobile-navigation-drawer-template",
            container,
          ).html(),
          proxyTier1Nav: $(".navigation--left", container),
        }),
          theme.inlineNavigationCheck
            ? (theme.inlineNavigationCheck(),
              $(window).on(
                "debouncedresize.headerSection",
                theme.inlineNavigationCheck,
              ))
            : document.querySelector("#InlineNavigationCheckScript") &&
              eval(
                document.querySelector("#InlineNavigationCheckScript")
                  .innerHTML,
              ),
          (this.section = document.querySelector(".section-header")),
          (this.transparentPageheader = document.querySelector(
            ".pageheader--transparent-permitted",
          )),
          this.functions.setTransparency.call(this),
          this.functions.setSticky.call(this),
          this.functions.setHeaderHeightProperty.call(this),
          $(window).on(
            "scroll.headerSection",
            this.functions.afterScroll.bind(this),
          ),
          $(window).on(
            "debouncedresize.headerSection",
            this.functions.afterResize.bind(this),
          ),
          $(".disclosure", container).each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          $(".mobile-navigation-drawer .disclosure").each(function () {
            $(this).data("disclosure", new theme.Disclosure($(this)));
          }),
          theme.settings.cart_type == "drawer" &&
            document.querySelector(".cart-drawer") &&
            $(container).on("click.headerSection", ".cart-link", (evt) => {
              evt.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:open-cart-drawer", {
                    bubbles: !0,
                    cancelable: !1,
                  }),
                );
            }),
          $(document).on("theme:cartchanged.headerSection", function () {
            $.getJSON(location.origin + "?sections=header", function (data) {
              for (
                var cartSummarySelectors = [
                    "#pageheader .logo-area__right__inner",
                  ],
                  i = 0;
                i < cartSummarySelectors.length;
                i++
              ) {
                var $newCartObj = $("<div>" + data.header + "</div>")
                    .find(cartSummarySelectors[i])
                    .first(),
                  $currCart = $(cartSummarySelectors[i]);
                $currCart.html($newCartObj.html());
              }
            });
          }),
          Shopify.designMode &&
            $("body").hasClass("reveal-mobile-nav") &&
            theme.openMobileNav();
      }),
        (this.onSectionUnload = function (container2) {
          $(container2).off(".headerSection"),
            $(document).off(".headerSection"),
            $(window).off(".headerSection"),
            $(".disclosure", container2).each(function () {
              $(this).data("disclosure").unload();
            }),
            $(".mobile-navigation-drawer .disclosure").each(function () {
              $(this).data("disclosure").unload();
            }),
            theme.Navigation.destroy(
              $(".navigation", container2),
              $(".navigation--left", container2),
            );
        }),
        (this.functions = {
          afterScroll: function afterScroll() {
            this.functions.setTransparency.call(this);
          },
          afterResize: function afterResize() {
            this.functions.setSticky.call(this),
              this.functions.setHeaderHeightProperty.call(this);
          },
          setTransparency: function setTransparency() {
            if (this.transparentPageheader) {
              var bar = document.querySelector(".section-announcement-bar"),
                scrollThreshold = bar ? bar.offsetTop + bar.clientHeight : 0;
              !this.isSticky || window.scrollY <= scrollThreshold
                ? this.transparentPageheader.classList.add(
                    "pageheader--transparent",
                  )
                : this.transparentPageheader.classList.remove(
                    "pageheader--transparent",
                  );
            }
          },
          setSticky: function setSticky() {
            this.isSticky =
              getComputedStyle(this.section).position === "sticky" ||
              getComputedStyle(this.section).position === "-webkit-sticky";
          },
          setHeaderHeightProperty: function setHeaderHeightProperty() {
            var headerHeight = 0,
              stickyHeaderHeight = 0;
            this.section &&
              ((headerHeight = Math.ceil(this.section.getBoundingClientRect().bottom)),
              this.isSticky && (stickyHeaderHeight = headerHeight)),
              document.documentElement.style.setProperty(
                "--theme-header-height",
                headerHeight + "px",
              ),
              document.documentElement.style.setProperty(
                "--theme-sticky-header-height",
                stickyHeaderHeight + "px",
              );
          },
        });
    })()),
    (theme.ImageWithTextOverlaySection = new (function () {
      var _ = this;
      (_.checkForHeaderHeightSubtraction = function () {
        $(
          ".section-image-with-text-overlay .height--full-minus-header-height",
        ).each(function () {
          var height = $(window).height();
          document.querySelector(".pageheader--transparent-permitted") &&
          !this.closest(".shopify-section").previousElementSibling
            ? document
                .querySelectorAll(
                  ".section-store-messages, .section-announcement-bar",
                )
                .forEach((el) => {
                  height -= el.clientHeight;
                })
            : (height -=
                document.querySelector(".section-header").clientHeight),
            $(".rimage-outer-wrapper, .placeholder-image", this).height(height);
        });
      }),
        (this.onSectionLoad = function (container2) {
          $(".height--full", container2).each(function () {
            $(this).closest(".section-image-with-text-overlay").index() == 0 &&
              ($(this).addClass("height--full-minus-header-height"),
              _.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.imageWithTextOverlaySection")
                .on(
                  "debouncedresize.imageWithTextOverlaySection",
                  _.checkForHeaderHeightSubtraction,
                ));
          }),
            $(".overlay-text__title, .overlay-text__rte", container2).each(
              function () {
                theme.avoidUnecessaryOrphans(this);
              },
            );
        }),
        (this.onSectionUnload = function (container2) {
          $(window).off(".imageWithTextOverlaySection");
        });
    })()),
    (theme.ListCollectionsTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        theme.ProductBlockManager.loadImages(container2);
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2);
        });
    })()),
    (theme.ProductTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        $("[data-store-availability-container]", container2).length &&
          (this.storeAvailability = new theme.StoreAvailability(
            $("[data-store-availability-container]", container2)[0],
          )),
          theme.initProductGallery(container2),
          $(".product-form", container2).trigger("load-product-form"),
          theme.ProductBlockManager.loadImages(container2),
          $(".theme-product-reviews", container2).on("click", "a", function () {
            return (
              $("html,body").animate(
                { scrollTop: $($(this).attr("href")).offset().top },
                1e3,
              ),
              !1
            );
          });
      }),
        (this.onSectionUnload = function (container2) {
          theme.ProductBlockManager.unloadImages(container2),
            theme.destroyProductGallery(container2),
            $(".product-form", container2).trigger("unload-product-form"),
            $(".theme-product-reviews", container2).off("click"),
            this.storeAvailability && this.storeAvailability.onSectionUnload();
        });
    })()),
    (theme.ScrollingBannerSection = new (function () {
      this.onSectionLoad = function (target) {
        document.fonts.ready.then(() =>
          target.querySelector(".marquee").classList.add("marquee--animate"),
        ),
          target.querySelectorAll(".lazyload").forEach((el) => {
            lazySizes.loader.unveil(el);
          });
      };
    })()),
    (theme.SearchTemplateSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$container = $(container2)),
          (this.filterer = new theme.LoadFilterer(this));
      }),
        (this.onSectionUnload = function () {
          this.filterer.destroy();
        });
    })()),
    (theme.SlideshowSection = new (function () {
      var _ = this;
      (_.checkForHeaderHeightSubtraction = function () {
        $(".section-slideshow .height--full-minus-header-height").each(
          function () {
            var height = $(window).height();
            document.querySelector(".pageheader--transparent-permitted") &&
            !this.closest(".shopify-section").previousElementSibling
              ? document
                  .querySelectorAll(
                    ".section-store-messages, .section-announcement-bar",
                  )
                  .forEach((el) => {
                    height -= el.clientHeight;
                  })
              : (height -=
                  document.querySelector(".section-header").clientHeight),
              $(".rimage-outer-wrapper, .placeholder-image", this).height(
                height,
              );
          },
        );
      }),
        (this.onSectionLoad = function (container2) {
          $(".slideshow", container2).each(function () {
            var slideshowSpeed =
                $(this).data("transition") === "instant" ? 0 : 800,
              autoplaySpeed = $(this).data("autoplay-speed") * 1e3;
            $(this).find(".height--full").length &&
              $(this).closest(".section-slideshow").index() == 0 &&
              ($(this).addClass("height--full-minus-header-height"),
              _.checkForHeaderHeightSubtraction(),
              $(window)
                .off("debouncedresize.slideshowSection")
                .on(
                  "debouncedresize.slideshowSection",
                  _.checkForHeaderHeightSubtraction,
                )),
              $(this)
                .on("init", function () {
                  $(".lazyload--manual", this)
                    .removeClass("lazyload--manual")
                    .addClass("lazyload");
                })
                .slick({
                  autoplay: $(this).data("autoplay"),
                  fade: $(this).data("transition") !== "slide",
                  speed: slideshowSpeed,
                  autoplaySpeed,
                  arrows: $(this).data("navigation") === "arrows",
                  dots: $(this).data("navigation") === "dots",
                  pauseOnHover: !1,
                  infinite: !0,
                  useTransform: !0,
                  prevArrow:
                    '<button type="button" class="slick-prev" aria-label="' +
                    theme.strings.previous +
                    '">' +
                    theme.icons.chevronLeft +
                    "</button>",
                  nextArrow:
                    '<button type="button" class="slick-next" aria-label="' +
                    theme.strings.next +
                    '">' +
                    theme.icons.chevronRight +
                    "</button>",
                  customPaging: function (slider, i) {
                    return (
                      '<button class="custom-dot" type="button" data-role="none" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30" xml:space="preserve"><circle class="circle-one" cx="15" cy="15" r="13" />' +
                      '<circle class="circle-two" cx="15" cy="15" r="13" style="animation-duration: '.concat(
                        autoplaySpeed + slideshowSpeed,
                        'ms" />',
                      ) +
                      "</svg></button>"
                    );
                  },
                  rtl: !!document.querySelector("html[dir=rtl]"),
                  responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: !1,
                        dots: $(this).data("navigation") !== "none",
                      },
                    },
                  ],
                })
                .on("beforeChange", function (event, slick, currentSlide) {
                  if (
                    $(this).data("transition") === "slide_fade" ||
                    $(this).data("transition") === "zoom"
                  ) {
                    var $outgoingSlide = $(slick.$slides.get(currentSlide));
                    $outgoingSlide.addClass("slick--leaving");
                  }
                })
                .on("afterChange", function (event, slick) {
                  $(slick.$slides)
                    .filter(".slick--leaving")
                    .removeClass("slick--leaving");
                });
          }),
            $(".overlay-text__title, .overlay-text__rte", container2).each(
              function () {
                theme.avoidUnecessaryOrphans(this);
              },
            );
        }),
        (this.onSectionUnload = function (container2) {
          $(".slick-slider", container2).slick("unslick").off("init"),
            $(window).off(".slideshowSection");
        }),
        (this.onBlockSelect = function (container2) {
          $(container2)
            .closest(".slick-slider")
            .slick("slickGoTo", $(container2).data("slick-index"))
            .slick("slickPause");
        }),
        (this.onBlockDeselect = function (container2) {
          $(container2).closest(".slick-slider").slick("slickPlay");
        });
    })()),
    (theme.TestimonialsSection = new (function () {
      (this.onSectionLoad = function (container2) {
        (this.namespace = theme.namespaceFromSection(container2)),
          (this.$testimonialContainer = $(".testimonial-list", container2)),
          this.$testimonialContainer
            .find(".testimonial-list__inner")
            .on("init", function () {
              $(".lazyload--manual", this)
                .removeClass("lazyload--manual")
                .addClass("lazyload");
            })
            .slick({
              fade: this.$testimonialContainer.hasClass(
                "testimonial-list--with-images",
              ),
              slidesToShow: this.$testimonialContainer.hasClass(
                "testimonial-list--without-images",
              )
                ? 2
                : 1,
              autoplay: this.$testimonialContainer.data("autoplay"),
              autoplaySpeed: this.$testimonialContainer.data("autoplay-speed"),
              dots: !1,
              arrows: !0,
              appendArrows: this.$testimonialContainer.find(
                ".testimonial-list__controls",
              ),
              prevArrow:
                '<button type="button" class="slick-prev" aria-label="' +
                theme.strings.previous +
                '">' +
                theme.icons.chevronLeft +
                "</button>",
              nextArrow:
                '<button type="button" class="slick-next" aria-label="' +
                theme.strings.next +
                '">' +
                theme.icons.chevronRight +
                "</button>",
              rtl: !!document.querySelector("html[dir=rtl]"),
              responsive: [
                { breakpoint: 768, settings: { fade: !1, slidesToShow: 1 } },
              ],
            });
      }),
        (this.onSectionUnload = function (container2) {
          $(".slick-slider", container2).each(function () {
            $(this).slick("unslick").off("init");
          });
        }),
        (this.onBlockSelect = function (block) {
          var blockSlideIndex = $(block).data("slick-index");
          $(block)
            .closest(".slick-slider")
            .each(function () {
              $(this).slick("slickGoTo", blockSlideIndex);
            });
        });
    })()),
    $(function ($2) {
      var $2 = $2;
      $2(document).on("keyup.themeTabCheck", function (evt) {
        evt.keyCode === 9 &&
          ($2("body").addClass("tab-used"),
          $2(document).off("keyup.themeTabCheck"));
      }),
        $2(document).on("click", "a[data-toggle-target]", function (e) {
          e.preventDefault();
          var $toggler = $2(this),
            $target = $2($2(this).data("toggle-target")),
            $transCont = $target.find(".toggle-target-container"),
            doCollapse = !$target.hasClass("toggle-target--hidden"),
            transitionDuration =
              $target.css("transition-duration").indexOf("ms") >= 0
                ? parseInt($target.css("transition-duration"))
                : parseFloat($target.css("transition-duration")) * 1e3;
          $target.hasClass("toggle-target--in-transition") ||
            (doCollapse
              ? ($toggler.addClass("toggle-target-toggler--is-hidden"),
                $target
                  .addClass(
                    "toggle-target--in-transition toggle-target--hiding",
                  )
                  .css({ height: $transCont.outerHeight() + "px", opacity: 1 }),
                setTimeout(function () {
                  $target.css({ height: 0, opacity: 0 }),
                    setTimeout(function () {
                      $target
                        .addClass("toggle-target--hidden")
                        .removeClass(
                          "toggle-target--in-transition toggle-target--hiding",
                        ),
                        $target.css({ height: "", opacity: "" });
                    }, transitionDuration);
                }, 10))
              : ($toggler.removeClass("toggle-target-toggler--is-hidden"),
                $target
                  .addClass(
                    "toggle-target--in-transition toggle-target--revealing",
                  )
                  .css({ height: 0, opacity: 0, display: "block" }),
                setTimeout(function () {
                  $target.css({
                    height: $transCont.outerHeight() + "px",
                    opacity: 1,
                  }),
                    setTimeout(function () {
                      $target.removeClass(
                        "toggle-target--hidden toggle-target--in-transition toggle-target--revealing",
                      ),
                        $target.css({ height: "", opacity: "", display: "" });
                    }, transitionDuration);
                }, 10)));
        }),
        $2(document).on("change", "select.navdrop", function () {
          window.location = $2(this).val();
        }),
        $2(document).on("click", ".mobile-nav-toggle", function (e) {
          e.preventDefault(),
            $2("body").hasClass("enable-mobile-nav-transition")
              ? ($2("body").removeClass(
                  "reveal-mobile-nav reveal-mobile-nav--revealed",
                ),
                setTimeout(function () {
                  $2("body").removeClass("enable-mobile-nav-transition");
                }, 750))
              : theme.openMobileNav();
        }),
        (theme.openMobileNav = function () {
          $2("body").addClass("enable-mobile-nav-transition"),
            setTimeout(function () {
              $2("body").addClass("reveal-mobile-nav"),
                $2(".mobile-navigation-drawer .disclosure").each(function () {
                  var $list = $2(".disclosure-list", this),
                    listHeight = 0;
                  $list.children().each(function () {
                    listHeight += $2(this).height();
                  }),
                    $2(".disclosure-list", this).css(
                      "height",
                      listHeight + "px",
                    );
                }),
                $2(".mobile-navigation-drawer .lazyload--manual")
                  .removeClass("lazyload--manual")
                  .addClass("lazyload"),
                $2(".mobile-navigation-drawer .product-list").each(function () {
                  theme.ProductBlockManager.loadImages($2(this));
                });
              var de = $2(
                  ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first",
                ).css("transition-delay"),
                du = $2(
                  ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link:first",
                ).css("transition-duration"),
                delayS =
                  parseFloat(de.split(",")[0]) + parseFloat(du.split(",")[0]);
              setTimeout(function () {
                $2("body").addClass("reveal-mobile-nav--revealed");
              }, delayS * 1e3);
            }, 10);
        }),
        $2(
          '<a href="#" class="page-shade" aria-label="' +
            theme.strings.general_navigation_menu_toggle_aria_label +
            '"></a>',
        )
          .on("click", function () {
            return (
              $2("body").removeClass("reveal-mobile-nav show-search"),
              setTimeout(function () {
                $2("body").removeClass("enable-mobile-nav-transition");
              }, 750),
              !1
            );
          })
          .appendTo("body"),
        theme.settings.quickbuy_style != "off" && theme.loadQuickbuy(),
        $2(document).on("load-product-form", ".product-form", function (e) {
          if ($2(this).data("product-id") !== "") {
            var $productFormContainer = $2(this),
              $productDetail = $2(this).closest(".product-detail");
            $2(this).on("variantChanged", function (evt, variant, product) {
              var $labelCont = $productDetail.find(".product-label-list");
              $labelCont.find(".product-label-container").remove(),
                variant
                  ? $labelCont.append(
                      $2(
                        "#variant-label-"
                          .concat(product.id, "-")
                          .concat(variant.id),
                      ).html(),
                    )
                  : $labelCont.append(
                      $2("#variant-label-".concat(product.id, "-none")).html(),
                    ),
                variant &&
                  $productDetail
                    .find(".dynamic-payment-button-template")
                    .each(function () {
                      $2(this).after($2(this).html()).remove(),
                        Shopify.PaymentButton && Shopify.PaymentButton.init();
                    });
            });
            var $iconOptionContainers = $productDetail.find(
              ".option-selector--swatch",
            );
            $iconOptionContainers.length &&
              $2("body.swatch-style-icon_circle, body.swatch-style-icon_square")
                .length &&
              ($iconOptionContainers
                .find(".label")
                .append('<span class="label__value">'),
              $2(this).on("variantChanged", function (evt, variant) {
                $iconOptionContainers.each(function () {
                  var optionIndex = $2(this).data("option-index");
                  if (variant) {
                    var optionValue = variant.options[optionIndex];
                    $2(this).find(".label__value").text(optionValue);
                  } else {
                    var selectedOption = this.querySelector(".opt-btn:checked");
                    selectedOption &&
                      $2(this).find(".label__value").text(selectedOption.value);
                  }
                });
              }));
            var $availabilityDependentOptions = $productDetail.find(
              '.option-selectors[data-disable-unavailable="true"]',
            );
            $availabilityDependentOptions.length &&
              $2(this).on("variantChanged", function (evt, variant) {
                var _this2 = this,
                  productData = theme.OptionManager.getProductData($2(this)),
                  optionStatusMap = [],
                  currentSelectedOptionValues = [];
                $2(
                  '.option-selectors[data-disable-unavailable="true"] .option-selector',
                  this,
                ).each(function (index) {
                  var checkedInput = $2(this).find("input:checked"),
                    selectedOption = $2(this).find(
                      '.cc-select__option[aria-selected="true"]',
                    ),
                    value = checkedInput.length
                      ? checkedInput.val()
                      : selectedOption
                        ? selectedOption.data("value")
                        : null;
                  currentSelectedOptionValues.push(value);
                });
                for (
                  var optionIndex = 0;
                  optionIndex < productData.options.length;
                  optionIndex++
                ) {
                  for (
                    var optionName = productData.options[optionIndex],
                      values = {},
                      i = 0;
                    i < productData.variants.length;
                    i++
                  ) {
                    var v = productData.variants[i];
                    values[v.options[optionIndex]] ||
                      (values[v.options[optionIndex]] = !1);
                  }
                  optionStatusMap.push({ name: optionName, values });
                }
                for (
                  var _loop4 = function (optionIndex2) {
                      for (
                        var optionName2 = productData.options[optionIndex2],
                          fixedOptions = [],
                          _i2 = 0;
                        _i2 < currentSelectedOptionValues.length &&
                        _i2 < optionIndex2;
                        _i2++
                      )
                        fixedOptions.push(currentSelectedOptionValues[_i2]);
                      Object.keys(optionStatusMap[optionIndex2].values).forEach(
                        (optionValue2) => {
                          var fixedOptionsForValue = fixedOptions.map((x) => x);
                          fixedOptionsForValue.push(optionValue2);
                          for (
                            var availableVariantExists = !1, _i3 = 0;
                            _i3 < productData.variants.length;
                            _i3++
                          ) {
                            for (
                              var _v = productData.variants[_i3],
                                variantComplies = !0,
                                j = 0;
                              j < fixedOptionsForValue.length;
                              j++
                            )
                              fixedOptionsForValue[j] &&
                                fixedOptionsForValue[j] != _v.options[j] &&
                                (variantComplies = !1);
                            variantComplies &&
                              _v.available &&
                              (availableVariantExists = !0);
                          }
                          optionStatusMap[optionIndex2].values[optionValue2] =
                            availableVariantExists;
                        },
                      );
                    },
                    _optionIndex = 0;
                  _optionIndex < productData.options.length;
                  _optionIndex++
                )
                  _loop4(_optionIndex);
                for (var _i = 0; _i < optionStatusMap.length; _i++) {
                  var _loop5 = function (optionValue2) {
                    $2(
                      '.option-selector[data-selector-type="listed"][data-option-index="'.concat(
                        _i,
                        '"] .opt-btn',
                      ),
                      _this2,
                    )
                      .filter(function () {
                        return this.value === optionValue2;
                      })
                      .toggleClass(
                        "is-unavailable",
                        !optionStatusMap[_i].values[optionValue2],
                      ),
                      $2(
                        '.option-selector[data-selector-type="dropdown"][data-option-index="'.concat(
                          _i,
                          '"] .cc-select__option',
                        ),
                        _this2,
                      )
                        .filter(function () {
                          return this.dataset.value === optionValue2;
                        })
                        .toggleClass(
                          "is-unavailable",
                          !optionStatusMap[_i].values[optionValue2],
                        );
                  };
                  for (var optionValue in optionStatusMap[_i].values)
                    _loop5(optionValue);
                }
              }),
              $productFormContainer.on(
                "change",
                ".option-selector",
                function () {
                  $productFormContainer.hasClass(
                    "product-form--validation-started",
                  ) && theme.validateProductForm($productFormContainer);
                },
              ),
              theme.OptionManager.initProductOptions($2(this));
          }
        }),
        $2(document).on("unload-product-form", ".product-form", function () {
          $2(this).off("variantChanged change"),
            theme.OptionManager.unloadProductOptions($2(this));
        }),
        $2(document).on(
          "click",
          ".hover-add-to-cart .option-selector--swatch .opt-label",
          function () {
            let swatchValue = $2(this).attr("data-swatch");
            $2(this)
              .closest(".block-inner-inner")
              .find(
                '.product-block-options--swatch [data-swatch="' +
                  swatchValue +
                  '"]',
              )
              .trigger("mouseenter");
          },
        ),
        $2(document).on(
          "submit",
          ".hover-add-to-cart .product-purchase-form",
          function (event) {
            event.preventDefault();
          },
        ),
        $2(document).on(
          "variantImageSelected",
          ".gallery",
          function (e, data, isFirstRun) {
            var $gallery = $2(this),
              $galleryCollageContainer = $gallery
                .filter(
                  ".gallery--layout-columns-1, .gallery--layout-columns-2, .gallery--layout-collage-1, .gallery--layout-collage-2",
                )
                .find(".product-slideshow:not(.slick-slider)"),
              collageGroupedImagesChanged = !1,
              $slideshow = null;
            if (
              $gallery.attr("data-variant-image-grouping-option-index") !== ""
            ) {
              var pivotOptionIndex = $gallery.attr(
                  "data-variant-image-grouping-option-index",
                ),
                selectedGroupOption = data.options[pivotOptionIndex],
                $thumbnails = $gallery.find(".thumbnails");
              if (
                (($slideshow = $gallery.find(".slideshow")),
                $slideshow.hasClass("slick-slider"))
              ) {
                var currentIsVisible = !!$slideshow.find(
                  '.slide[data-media-id="'.concat(data.featured_media.id, '"]'),
                ).length;
                $slideshow
                  .slick("slickUnfilter")
                  .slick(
                    "slickFilter",
                    '.slide[data-media-id="'
                      .concat(
                        data.featured_media.id,
                        '"], [data-variant-image-group="',
                      )
                      .concat(
                        selectedGroupOption
                          .replace('"', "&quot;")
                          .replace(/<>/g, ""),
                        '"]',
                      ),
                  ),
                  $slideshow
                    .find(".slide")
                    .css({
                      position: "",
                      left: "",
                      top: "",
                      zIndex: "",
                      opacity: "",
                    }),
                  currentIsVisible ||
                    ($slideshow.slick("slickGoTo", 0, !0),
                    $slideshow.slick(
                      "slickGoTo",
                      $slideshow
                        .find(
                          '.slide[data-media-id="'.concat(
                            data.featured_media.id,
                            '"]',
                          ),
                        )
                        .data("slick-index"),
                      !0,
                    ));
              }
              if ($thumbnails.hasClass("owl-carousel")) {
                var $hiddenThumbnails = $gallery.find(".hidden-thumbnails");
                $hiddenThumbnails.length ||
                  ($hiddenThumbnails = $2(
                    '<div class="hidden-thumbnails hidden">',
                  ).insertAfter($thumbnails)),
                  $thumbnails
                    .find(".thumbnail")
                    .show()
                    .each(function () {
                      if (
                        $2(this).attr("data-variant-image-group") !=
                          selectedGroupOption &&
                        $2(this).attr("data-media-id") != data.featured_media.id
                      ) {
                        var index = $2(this).parent().index();
                        $2(this).appendTo($hiddenThumbnails),
                          $thumbnails.trigger("remove.owl.carousel", [index]);
                      }
                    }),
                  $hiddenThumbnails.find(".thumbnail").each(function () {
                    ($2(this).attr("data-variant-image-group") ==
                      selectedGroupOption ||
                      $2(this).attr("data-media-id") ==
                        data.featured_media.id) &&
                      ($2(this).show(),
                      $thumbnails.trigger("add.owl.carousel", [this]));
                  }),
                  $thumbnails.trigger("refresh.owl.carousel");
              } else
                $thumbnails.find(".thumbnail").each(function () {
                  $2(this).attr("data-variant-image-group") ==
                    selectedGroupOption ||
                  $2(this).attr("data-media-id") == data.featured_media.id
                    ? $2(this).show()
                    : $2(this).hide();
                });
              $galleryCollageContainer.length &&
                ($galleryCollageContainer.find(".slide").each(function () {
                  $2(this).attr("data-variant-image-group") ==
                    selectedGroupOption ||
                  $2(this).attr("data-media-id") == data.featured_media.id
                    ? ($2(this).hasClass("slide--inactive-option") &&
                        (collageGroupedImagesChanged = !0),
                      $2(this).removeClass("slide--inactive-option"))
                    : ($2(this).hasClass("slide--inactive-option") ||
                        (collageGroupedImagesChanged = !0),
                      $2(this).addClass("slide--inactive-option"));
                }),
                $galleryCollageContainer
                  .find(".slide--inactive-option")
                  .appendTo($galleryCollageContainer));
            }
            if (
              ($gallery
                .find(
                  '.thumbnails a[data-media-id="' +
                    data.featured_media.id +
                    '"]:first',
                )
                .trigger("select"),
              $galleryCollageContainer.length)
            ) {
              var $active = $gallery.find(
                '.slide[data-media-id="' + data.featured_media.id + '"]:first',
              );
              $active.length &&
                (isFirstRun && !collageGroupedImagesChanged
                  ? theme.scrollToRevealElement($active[0])
                  : collageGroupedImagesChanged
                    ? ($gallery
                        .find(".slide--was-highlighted")
                        .removeClass("slide--was-highlighted"),
                      $active.addClass("slide--was-highlighted"))
                    : $active.hasClass("slide--was-highlighted") ||
                      (clearTimeout(theme.variantImageFadeTimeout),
                      $gallery
                        .find(".slide--highlight-on")
                        .removeClass("slide--highlight-on"),
                      $gallery
                        .find(".slide--highlight-off")
                        .removeClass("slide--highlight-off"),
                      $gallery
                        .find(".slide--was-highlighted")
                        .removeClass("slide--was-highlighted"),
                      $active
                        .addClass("slide--highlight-on slide--was-highlighted")
                        .siblings()
                        .addClass("slide--highlight-off"),
                      (theme.variantImageFadeTimeout = setTimeout(function () {
                        $gallery
                          .find(".slide--highlight-on")
                          .removeClass("slide--highlight-on"),
                          $gallery
                            .find(".slide--highlight-off")
                            .removeClass("slide--highlight-off");
                      }, 1200)),
                      theme.scrollToRevealElement($active[0])));
            }
          },
        ),
        $2(document).on(
          "click",
          ".product-detail .gallery .main-image a.show-gallery",
          function () {
            var images = [],
              $imgs = $2(this)
                .closest(".product-slideshow")
                .find(".slide:not(.slide--inactive-option) .show-gallery"),
              clickedHref = $2(this).attr("href");
            if ($imgs.length)
              $imgs.each(function () {
                var $imgThumb = $2(this).find(".rimage-outer-wrapper").clone();
                $imgThumb
                  .find(".lazyloaded")
                  .removeClass("lazyloaded")
                  .addClass("lazyload")
                  .parent()
                  .addClass("lazyload--placeholder"),
                  images.push({
                    thumbTag: $imgThumb,
                    zoomUrl: $2(this).attr("href"),
                  });
              });
            else {
              var $img = $2(this).find(".rimage-outer-wrapper").clone();
              $img
                .find(".lazyloaded")
                .removeClass("lazyloaded")
                .addClass("lazyload")
                .parent()
                .addClass("lazyload--placeholder"),
                images.push({ thumbTag: $img, zoomUrl: $2(this).attr("href") });
            }
            return (
              theme.buildGalleryViewer({
                images,
                currentImage: clickedHref,
                prev: theme.icons.chevronLeft,
                next: theme.icons.chevronRight,
                close: theme.icons.close,
              }),
              !1
            );
          },
        );
      var $nonSectionedProductLists = $2(
        ".product-list, .collection-listing",
      ).filter(function () {
        return $2(this).closest("[data-section-type]").length == 0;
      });
      if (
        ($nonSectionedProductLists.length &&
          theme.ProductBlockManager.loadImages($nonSectionedProductLists),
        $2(window).on("debouncedresize", function () {
          setTimeout(function () {
            theme.ProductBlockManager.afterImagesResized();
          }, 100);
        }),
        $2("#template label").each(function () {
          var $sibinputs = $2(this).siblings(
            'input:not([type="submit"]), textarea',
          );
          $sibinputs.length == 1 &&
            $sibinputs.attr("id").length > 0 &&
            $2(this).attr("for", $sibinputs.attr("id"));
        }),
        $2(document).on(
          "click",
          ".quantity-wrapper [data-quantity]",
          function () {
            var adj = $2(this).data("quantity") == "up" ? 1 : -1,
              $qty = $2(this)
                .closest(".quantity-wrapper")
                .find("[name=quantity]");
            return (
              $qty.attr("step") && (adj *= parseInt($qty.attr("step"))),
              $qty
                .val(Math.max(1, parseInt($qty.val()) + adj))
                .trigger("change"),
              !1
            );
          },
        ),
        $2(".responsive-table").on(
          "click",
          ".responsive-table__cell-head",
          function () {
            if ($2(window).width() < 768)
              return $2(this).closest("tr").toggleClass("expanded"), !1;
          },
        ),
        typeof cc < "u" && cc.sections)
      )
        for (var sectionKey in cc.sections) {
          var ccSection = cc.sections[sectionKey];
          if (ccSection.name === "video") {
            var t = ccSection.section.onSectionLoad;
            ccSection.section.onSectionLoad = function (container2) {
              $2(".overlay-text__title, .overlay-text__rte", container2).each(
                function () {
                  theme.avoidUnecessaryOrphans(this);
                },
              ),
                t.call(this, container2);
            };
          }
        }
      theme.Sections.init(),
        theme.Sections.register("header", theme.HeaderSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "announcement-bar",
          theme.AnnouncementBarSection,
          { deferredLoad: !1 },
        ),
        theme.Sections.register("footer", theme.FooterSection),
        theme.Sections.register("cart-drawer", theme.CartDrawerSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("slideshow", theme.SlideshowSection),
        theme.Sections.register("gallery", theme.GallerySection),
        theme.Sections.register("testimonials", theme.TestimonialsSection),
        theme.Sections.register(
          "image-with-text-overlay",
          theme.ImageWithTextOverlaySection,
        ),
        theme.Sections.register(
          "featured-collection",
          theme.FeaturedCollectionSection,
        ),
        theme.Sections.register(
          "featured-collections",
          theme.FeaturedCollectionsSection,
        ),
        theme.Sections.register("map", theme.MapSection),
        theme.Sections.register("background-video", theme.VideoManager, {
          deferredLoadViewportExcess: 800,
        }),
        theme.Sections.register("custom-row", theme.CustomRowSection),
        theme.Sections.register(
          "featured-product",
          theme.FeaturedProductSection,
        ),
        theme.Sections.register(
          "scrolling-banner",
          theme.ScrollingBannerSection,
        ),
        theme.Sections.register("main-product", theme.ProductTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "collection-template",
          theme.CollectionTemplateSection,
          { deferredLoad: !1 },
        ),
        theme.Sections.register(
          "search-template",
          theme.SearchTemplateSection,
          { deferredLoad: !1 },
        ),
        theme.Sections.register("blog-template", theme.BlogTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register("cart-template", theme.CartTemplateSection, {
          deferredLoad: !1,
        }),
        theme.Sections.register(
          "list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 },
        ),
        theme.Sections.register(
          "page-list-collections-template",
          theme.ListCollectionsTemplateSection,
          { deferredLoad: !1 },
        ),
        theme.Sections.register("contact", new (function () {})());
    }),
    $(function ($2) {
      cc.sections.length
        ? cc.sections.forEach((section) => {
            try {
              var data = {};
              typeof section.deferredLoad < "u" &&
                (data.deferredLoad = section.deferredLoad),
                typeof section.deferredLoadViewportExcess < "u" &&
                  (data.deferredLoadViewportExcess =
                    section.deferredLoadViewportExcess),
                theme.Sections.register(section.name, section.section, data);
            } catch (err) {
              console.error(
                "Unable to register section ".concat(section.name, "."),
                err,
              );
            }
          })
        : console.warn("Barry: No common sections have been registered.");
    });
})(theme.jQuery);
//# sourceMappingURL=/s/files/1/0073/2361/5279/t/396/assets/theme.js.map?v=1735786173
